var _excluded = ["inputs"],
    _excluded2 = ["inputId"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf2(object); if (object === null) break; } return object; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf2(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf2(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct2()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf2(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _slicedToArray2(arr, i) { return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2(); }

function _nonIterableRest2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles2(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inherits2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2(subClass, superClass); }

function _setPrototypeOf2(o, p) { _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf2(o, p); }

function _createSuper2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct2(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn2(this, result); }; }

function _possibleConstructorReturn2(self, call) { if (call && (_typeof2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized2(self); }

function _assertThisInitialized2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf2(o) { _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf2(o); }

function _classCallCheck2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function __defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass2(Constructor, protoProps, staticProps) { if (protoProps) __defineProperties(Constructor.prototype, protoProps); if (staticProps) __defineProperties(Constructor, staticProps); return Constructor; }

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

import IconButton from '@material-ui/core/IconButton';
import CopyIcon from '@material-ui/icons/FileCopy';
import React, { useState, useRef } from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import path from 'path';
import url from 'url';
import fs from 'fs';
import Close from '@material-ui/icons/Close';
import Menu from '@material-ui/icons/Menu';
import { Paper, InputBase, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useStyles = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    typography: {
      fontSize: '20px'
    }
  };
});

var Dropdown = function Dropdown(props) {
  var classes = useStyles();

  var getData = function getData(e) {
    var data = {};
    data[props.itemID] = e.target.value;
    props.valueChange(Object.assign({}, data));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(NativeSelect, {
    inputProps: {
      id: props.itemID + props.direction,
      name: 'openinghours'
    },
    onChange: function onChange(e) {
      getData(e);
    },
    value: props.defaultValue
  }, props.listItems.map(function (hour) {
    return /*#__PURE__*/React.createElement("option", {
      key: btoa("".concat(props.direction).concat(hour).concat(Math.random())),
      value: hour.valueItem
    }, hour.displayItem);
  })));
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".opening-hours_opening_hours__JGChY {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-family: 'GothamBook', sans-serif; }\n  .opening-hours_opening_hours__JGChY input,\n  .opening-hours_opening_hours__JGChY select,\n  .opening-hours_opening_hours__JGChY textarea,\n  .opening-hours_opening_hours__JGChY button {\n    font-size: 0.7em;\n    font-family: inherit; }\n  .opening-hours_opening_hours__JGChY form input[type='submit'],\n  .opening-hours_opening_hours__JGChY form input[type='button'],\n  .opening-hours_opening_hours__JGChY form button,\n  .opening-hours_opening_hours__JGChY form button:hover {\n    background-image: unset; }\n  .opening-hours_opening_hours__JGChY select {\n    line-height: 1; }\n  .opening-hours_opening_hours__JGChY a.opening-hours_button__3GMo2,\n  .opening-hours_opening_hours__JGChY a:link.opening-hours_button__3GMo2,\n  .opening-hours_opening_hours__JGChY a:visited.opening-hours_button__3GMo2,\n  .opening-hours_opening_hours__JGChY a:hover.opening-hours_button__3GMo2,\n  .opening-hours_opening_hours__JGChY input[type='submit'],\n  .opening-hours_opening_hours__JGChY input[type='button'],\n  .opening-hours_opening_hours__JGChY button {\n    background-image: unset; }\n  .opening-hours_opening_hours__JGChY .opening-hours_toggle_button_group__dFWQ0 {\n    display: flex;\n    flex-direction: column;\n    padding: 1em;\n    overflow: auto; }\n  .opening-hours_opening_hours__JGChY .opening-hours_opening-hours-enable__1Pa30 {\n    padding: 1em; }\n  .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp {\n    display: flex;\n    flex-direction: column-reverse; }\n    .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul {\n      margin: 0;\n      padding-right: 1em;\n      padding-left: 1em;\n      list-style: none; }\n      .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li {\n        padding: 0.5em; }\n        .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R {\n          display: flex;\n          align-items: baseline; }\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R input,\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R select,\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R textarea,\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R button {\n            font-size: 13px;\n            font-family: 'GothamBook', sans-serif; }\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R div {\n            width: 10em;\n            min-width: 5em;\n            text-align: center; }\n            .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R div:first-child {\n              text-align: left; }\n          .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp ul li .opening-hours_dropdown__1hN1R select {\n            min-width: 8em;\n            max-width: 10em; }\n    .opening-hours_opening_hours__JGChY .opening-hours_opening_hours_list__3oGDp .opening-hours_copy-hours__2cotv {\n      display: flex;\n      justify-content: flex-end;\n      margin: 1em; }\n\nlabel.opening-hours_widget_label__1a5eF {\n  display: block;\n  float: left;\n  width: 100%;\n  margin-left: 0.7em;\n  padding-top: 1em;\n  color: #5e6469;\n  font-weight: bold;\n  text-transform: uppercase; }\n\n#opening-hours_drop-off-section__18ITT.opening-hours_disabled-section__2mkpJ {\n  pointer-events: none; }\n";
var css$1 = {
  "opening_hours": "opening-hours_opening_hours__JGChY",
  "button": "opening-hours_button__3GMo2",
  "toggle_button_group": "opening-hours_toggle_button_group__dFWQ0",
  "opening-hours-enable": "opening-hours_opening-hours-enable__1Pa30",
  "opening_hours_list": "opening-hours_opening_hours_list__3oGDp",
  "dropdown": "opening-hours_dropdown__1hN1R",
  "copy-hours": "opening-hours_copy-hours__2cotv",
  "widget_label": "opening-hours_widget_label__1a5eF",
  "drop-off-section": "opening-hours_drop-off-section__18ITT",
  "disabled-section": "opening-hours_disabled-section__2mkpJ"
};
styleInject(css_248z$2);

var ToggleButtonGroupControlled = function ToggleButtonGroupControlled(props) {
  // react hook for handling selected days internally.
  var _useState = useState(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(e, v) {
    // sorting selected weekdays
    // prop function to pass updated data to the parent
    props.weekdayChange(v.sort());
    setValue(v);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    onChange: handleChange,
    size: "small",
    value: value.map(function (item) {
      return Number(item);
    })
  }, props.listItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ToggleButton, {
      disableRipple: true,
      key: item,
      tabIndex: index,
      value: index
    }, item);
  })));
};

var OpeningHours = /*#__PURE__*/function (_React$Component) {
  _inherits(OpeningHours, _React$Component);

  var _super = _createSuper(OpeningHours);

  function OpeningHours(props) {
    var _this;

    _classCallCheck(this, OpeningHours);

    _this = _super.call(this, props);
    var pData;

    if (props.preloadData && _typeof(props.preloadData) === 'object') {
      pData = props.preloadData;
    } else {
      pData = {};
    }

    _this.state = {
      openingHoursData: pData,
      openingHoursEnabled: props.enabled,
      selectedWeekdays: Object.keys(pData),
      timeFormat24hours: props.timeFormat24hours || false,
      weekdays: props.weekDays
    };
    _this.listItems = _this.generateHours();
    _this.initialValue = {
      closing: _this.listItems[34]['valueItem'],
      opening: _this.listItems[18]['valueItem']
    };
    return _this;
  }

  _createClass(OpeningHours, [{
    key: "getDefaultValue",
    value: function getDefaultValue(weekday, fromto) {
      return this.state.openingHoursData[weekday] && this.state.openingHoursData[weekday][fromto] || this.listItems[0];
    }
  }, {
    key: "generateHours",
    value: function generateHours() {
      this.date = new Date();
      var hours = [];
      this.date.setHours(0, 0, 0, 0);

      for (var i = 0; i < 48; i += 1) {
        hours.push({
          displayItem: this.date.toLocaleString('en-US', {
            hour: '2-digit',
            hour12: !this.state.timeFormat24hours,
            minute: '2-digit'
          }),
          valueItem: this.date.toLocaleString('en-US', {
            hour: '2-digit',
            hour12: false,
            minute: '2-digit'
          })
        });
        this.date.setMinutes(this.date.getMinutes() + 30);
      }

      return hours;
    }
  }, {
    key: "timeChange",
    value: function timeChange(time, fromto) {
      var key = Object.keys(time)[0];
      var selectedOpeningHours = this.state.openingHoursData;
      selectedOpeningHours[key] = this.state.openingHoursData[key] || {};
      selectedOpeningHours[key][fromto] = time[key];
      this.setState({
        openingHoursData: selectedOpeningHours
      });
    }
  }, {
    key: "weekdaysChange",
    value: function weekdaysChange(value) {
      var _this2 = this;

      var selectedOpeningHours = {};
      value.map(function (item) {
        if (_this2.state.openingHoursData[item]) {
          selectedOpeningHours[item] = _this2.state.openingHoursData[item];
        } else {
          selectedOpeningHours[item] = Object.assign({}, _this2.initialValue);
        }
      });
      this.setState({
        openingHoursData: selectedOpeningHours,
        selectedWeekdays: value
      });
    }
  }, {
    key: "copyTime",
    value: function copyTime() {
      var newValue = {};
      var baseValue = this.state.openingHoursData[this.state.selectedWeekdays[0]];
      var selectedWeekdays = this.state.selectedWeekdays;
      this.state.selectedWeekdays.map(function (item) {
        newValue[item] = Object.assign({}, baseValue);
      });
      this.setState({
        openingHoursData: newValue,
        selectedWeekdays: selectedWeekdays
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var data = JSON.stringify(this.state.openingHoursData);
      var inputField = document.querySelector("#".concat(this.props.inputID));

      if (data !== '{}' && this.state.openingHoursEnabled) {
        inputField.value = data;
      } else {
        inputField.value = null;
      }
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown(weekday, ddtype) {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(Dropdown, {
        defaultValue: this.getDefaultValue(weekday, ddtype),
        direction: ddtype,
        itemID: weekday,
        listItems: this.listItems,
        valueChange: function valueChange(value) {
          return _this3.timeChange(value, ddtype);
        }
      });
    }
  }, {
    key: "renderCopyButton",
    value: function renderCopyButton() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement(IconButton, {
        disableRipple: true,
        onClick: function onClick() {
          return _this4.copyTime();
        },
        title: this.props.t['opening_hours.widget.copy_to_all_label'],
        variant: "outlined"
      }, /*#__PURE__*/React.createElement(CopyIcon, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: css$1.opening_hours
      }, /*#__PURE__*/React.createElement("label", {
        className: css$1.widget_label
      }, this.props.t['opening_hours.widget.title']), this.state.openingHoursEnabled && /*#__PURE__*/React.createElement("div", {
        className: css$1.toggle_button_group
      }, /*#__PURE__*/React.createElement(ToggleButtonGroupControlled, {
        className: css$1.toggle_button_group,
        listItems: this.state.weekdays,
        value: this.state.selectedWeekdays,
        weekdayChange: function weekdayChange(value) {
          return _this5.weekdaysChange(value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: css$1.opening_hours_list
      }, /*#__PURE__*/React.createElement("ul", null, this.state.selectedWeekdays.map(function (weekday, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: weekday
        }, /*#__PURE__*/React.createElement("div", {
          className: css$1.dropdown
        }, /*#__PURE__*/React.createElement("div", null, _this5.state.weekdays[weekday]), _this5.state.openingHoursEnabled ? _this5.renderDropdown(weekday, 'opening') : /*#__PURE__*/React.createElement("div", null, _this5.getDefaultValue(weekday, 'opening')), _this5.state.openingHoursEnabled ? _this5.renderDropdown(weekday, 'closing') : /*#__PURE__*/React.createElement("div", null, _this5.getDefaultValue(weekday, 'closing')), _this5.state.openingHoursEnabled && index === 0 && _this5.state.selectedWeekdays.length > 1 && _this5.renderCopyButton()));
      }))));
    }
  }]);

  return OpeningHours;
}(React.Component);

OpeningHours.defaultProps = {
  preloadData: {},
  weekDays: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
};

var OpeningHoursViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(OpeningHoursViewer, _React$Component);

  var _super = _createSuper(OpeningHoursViewer);

  function OpeningHoursViewer(props) {
    var _this;

    _classCallCheck(this, OpeningHoursViewer);

    _this = _super.call(this, props);
    var pData = props.preloadData;
    _this.state = {
      openingHoursData: pData,
      selectedWeekdays: Object.keys(pData),
      timeFormat24hours: props.timeFormat24hours || false,
      weekdays: props.weekDays
    };
    return _this;
  }

  _createClass(OpeningHoursViewer, [{
    key: "getDisplayValue",
    value: function getDisplayValue(weekday, fromto) {
      if (this.state.openingHoursData[weekday][fromto]['displayItem']) {
        return this.state.openingHoursData[weekday][fromto]['displayItem'];
      } else {
        var value = this.state.openingHoursData[weekday][fromto];

        if (fromto === 'opening' && value === '24:00') {
          value = '00:00';
        }

        return this.state.timeFormat24hours ? value : this.getDisplayTime(value);
      }
    }
  }, {
    key: "getDisplayTime",
    value: function getDisplayTime(t) {
      var date = new Date();
      var time = t.match(/(\d+)(?::(\d\d))?\s*(p?)/);
      date.setHours(parseInt(time[1]) + (time[3] ? 12 : 0));
      date.setMinutes(parseInt(time[2]) || 0);
      return date.toLocaleString('en-US', {
        hour: '2-digit',
        hour12: !this.state.timeFormat24hours,
        minute: '2-digit'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: css$1.opening_hours
      }, /*#__PURE__*/React.createElement("h3", null, this.props.t['opening_hours.widget.title']), /*#__PURE__*/React.createElement("div", {
        className: css$1.opening_hours_list
      }, /*#__PURE__*/React.createElement("ul", null, this.state.selectedWeekdays.map(function (weekday) {
        return /*#__PURE__*/React.createElement("li", {
          key: weekday
        }, /*#__PURE__*/React.createElement("div", {
          className: css$1.dropdown
        }, /*#__PURE__*/React.createElement("div", null, _this2.state.weekdays[weekday]), /*#__PURE__*/React.createElement("div", {
          className: "al-right"
        }, /*#__PURE__*/React.createElement("span", null, _this2.getDisplayValue(weekday, 'opening'))), /*#__PURE__*/React.createElement("div", {
          className: "al-right"
        }, /*#__PURE__*/React.createElement("span", null, _this2.getDisplayValue(weekday, 'closing')))));
      }))));
    }
  }]);

  return OpeningHoursViewer;
}(React.Component);

OpeningHoursViewer.defaultProps = {
  preloadData: {},
  timeFormat24hours: true,
  weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace(n) {
  return n && n['default'] || n;
}

var decodeDataHtml = createCommonjsModule(function (module, exports) {
  // Generated using scripts/write-decode-map.ts
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = new Uint16Array( // prettier-ignore
  "\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\uD835\uDD04rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\uD835\uDD38plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\uD835\uDC9Cign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\uD835\uDD05pf;\uC000\uD835\uDD39eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\uD835\uDC9Ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\uD835\uDD07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\uD835\uDD3B\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\uD835\uDC9Frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\uD835\uDD08rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\uD835\uDD3Csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\uD835\uDD09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\uD835\uDD3DAll;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\uD835\uDD0A;\u62D9pf;\uC000\uD835\uDD3Eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\uD835\uDCA2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\uD835\uDD40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\uD835\uDD0Dpf;\uC000\uD835\uDD41\u01E3\u07C7\0\u07CCr;\uC000\uD835\uDCA5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\uD835\uDD0Epf;\uC000\uD835\uDD42cr;\uC000\uD835\uDCA6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\uD835\uDD0F\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\uD835\uDD43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\uD835\uDD10nusPlus;\u6213pf;\uC000\uD835\uDD44c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\uD835\uDD11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\uD835\uDCA9ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\uD835\uDD12rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\uD835\uDD46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\uD835\uDCAAash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\uD835\uDD13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\uD835\uDCAB;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B\"\u4022r;\uC000\uD835\uDD14pf;\u611Acr;\uC000\uD835\uDCAC\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\uD835\uDD16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\uD835\uDD4A\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\uD835\uDCAEar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\uD835\uDD17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\uD835\uDD4BipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\uD835\uDCAFrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\uD835\uDD18rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\uD835\uDD4C\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\uD835\uDCB0ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\uD835\uDD19pf;\uC000\uD835\uDD4Dcr;\uC000\uD835\uDCB1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\uD835\uDD1Apf;\uC000\uD835\uDD4Ecr;\uC000\uD835\uDCB2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\uD835\uDD1B;\u439Epf;\uC000\uD835\uDD4Fcr;\uC000\uD835\uDCB3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\uD835\uDD1Cpf;\uC000\uD835\uDD50cr;\uC000\uD835\uDCB4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\uD835\uDCB5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\uD835\uDD1Erave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\uD835\uDD52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\uD835\uDCB6;\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\uD835\uDD1Fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\uD835\uDD53\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\uD835\uDCB7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\uD835\uDD20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\uD835\uDD54o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\uD835\uDCB8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\uD835\uDD21ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\uD835\uDD55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\uD835\uDCB9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\uD835\uDD22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\uD835\uDD56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\uD835\uDD23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\uD835\uDD57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\uD835\uDCBB\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\uD835\uDD24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\uD835\uDD58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\uD835\uDD25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\uD835\uDD59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\uD835\uDCBDas\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\uD835\uDD26rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\uD835\uDD5Aa;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\uD835\uDCBEn\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\uD835\uDD27ath;\u4237pf;\uC000\uD835\uDD5B\u01E3\u23EC\0\u23F1r;\uC000\uD835\uDCBFrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\uD835\uDD28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\uD835\uDD5Ccr;\uC000\uD835\uDCC0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\uD835\uDD29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\uD835\uDD5Dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\uD835\uDCC1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\uD835\uDD2Ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\uD835\uDD5E\u0100ct\u28F8\u28FDr;\uC000\uD835\uDCC2pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\uD835\uDD2B\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\uD835\uDD5F\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\uD835\uDCC3ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\uD835\uDD2C\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\uD835\uDD60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\uD835\uDD2D\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\uD835\uDD61nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\uD835\uDCC5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\uD835\uDD2Epf;\uC000\uD835\uDD62rime;\u6057cr;\uC000\uD835\uDCC6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\uD835\uDD2F\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\uD835\uDD63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\uD835\uDCC7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\uD835\uDD30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\uD835\uDD64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\uD835\uDCC8tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\uD835\uDD31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\uD835\uDD65rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\uD835\uDCC9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\uD835\uDD32rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\uD835\uDD66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\uD835\uDCCA\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\uD835\uDD33tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\uD835\uDD67ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\uD835\uDCCB\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\uD835\uDD34pf;\uC000\uD835\uDD68\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\uD835\uDCCC\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\uD835\uDD35\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\uD835\uDD69im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\uD835\uDCCD\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\uD835\uDD36cy;\u4457pf;\uC000\uD835\uDD6Acr;\uC000\uD835\uDCCE\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\uD835\uDD37cy;\u4436grarr;\u61DDpf;\uC000\uD835\uDD6Bcr;\uC000\uD835\uDCCF\u0100jn\u3B85\u3B87;\u600Dj;\u600C".split("").map(function (c) {
    return c.charCodeAt(0);
  }));
});
unwrapExports(decodeDataHtml);
var decodeDataXml = createCommonjsModule(function (module, exports) {
  // Generated using scripts/write-decode-map.ts
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = new Uint16Array( // prettier-ignore
  "\u0200aglq\t\x15\x18\x1B\u026D\x0F\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function (c) {
    return c.charCodeAt(0);
  }));
});
unwrapExports(decodeDataXml);
var decode_codepoint = createCommonjsModule(function (module, exports) {
  // Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
  var _a;

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.replaceCodePoint = exports.fromCodePoint = void 0;
  var decodeMap = new Map([[0, 65533], // C1 Unicode control character reference replacements
  [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
  /**
   * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
   */

  exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function (codePoint) {
    var output = "";

    if (codePoint > 0xffff) {
      codePoint -= 0x10000;
      output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
      codePoint = 0xdc00 | codePoint & 0x3ff;
    }

    output += String.fromCharCode(codePoint);
    return output;
  };
  /**
   * Replace the given code point with a replacement character if it is a
   * surrogate or is outside the valid range. Otherwise return the code
   * point unchanged.
   */

  function replaceCodePoint(codePoint) {
    var _a;

    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) {
      return 0xfffd;
    }

    return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
  }

  exports.replaceCodePoint = replaceCodePoint;
  /**
   * Replace the code point if relevant, then convert it to a string.
   *
   * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
   * @param codePoint The code point to decode.
   * @returns The decoded code point.
   */

  function decodeCodePoint(codePoint) {
    return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
  }

  exports.default = decodeCodePoint;
});
unwrapExports(decode_codepoint);
decode_codepoint.replaceCodePoint;
decode_codepoint.fromCodePoint;
var decode$2 = createCommonjsModule(function (module, exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);

    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function get() {
          return m[k];
        }
      };
    }

    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });

  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }

    __setModuleDefault(result, mod);

    return result;
  };

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;

  var decode_data_html_js_1 = __importDefault(decodeDataHtml);

  exports.htmlDecodeTree = decode_data_html_js_1.default;

  var decode_data_xml_js_1 = __importDefault(decodeDataXml);

  exports.xmlDecodeTree = decode_data_xml_js_1.default;

  var decode_codepoint_js_1 = __importStar(decode_codepoint);

  exports.decodeCodePoint = decode_codepoint_js_1.default;
  var decode_codepoint_js_2 = decode_codepoint;
  Object.defineProperty(exports, "replaceCodePoint", {
    enumerable: true,
    get: function get() {
      return decode_codepoint_js_2.replaceCodePoint;
    }
  });
  Object.defineProperty(exports, "fromCodePoint", {
    enumerable: true,
    get: function get() {
      return decode_codepoint_js_2.fromCodePoint;
    }
  });
  var CharCodes;

  (function (CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
  })(CharCodes || (CharCodes = {}));
  /** Bit that needs to be set to convert an upper case ASCII character to lower case */


  var TO_LOWER_BIT = 32;
  var BinTrieFlags;

  (function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
  })(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));

  function isNumber(code) {
    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
  }

  function isHexadecimalCharacter(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
  }

  function isAsciiAlphaNumeric(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
  }
  /**
   * Checks if the given character is a valid end character for an entity in an attribute.
   *
   * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
   * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
   */


  function isEntityInAttributeInvalidEnd(code) {
    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
  }

  var EntityDecoderState;

  (function (EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
  })(EntityDecoderState || (EntityDecoderState = {}));

  var DecodingMode;

  (function (DecodingMode) {
    /** Entities in text nodes that can end with any character. */
    DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */

    DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */

    DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
  })(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
  /**
   * Token decoder with support of writing partial entities.
   */


  var EntityDecoder =
  /** @class */
  function () {
    function EntityDecoder(
    /** The tree used to decode entities. */
    decodeTree,
    /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */
    emitCodePoint,
    /** An object that is used to produce errors. */
    errors) {
      this.decodeTree = decodeTree;
      this.emitCodePoint = emitCodePoint;
      this.errors = errors;
      /** The current state of the decoder. */

      this.state = EntityDecoderState.EntityStart;
      /** Characters that were consumed while parsing an entity. */

      this.consumed = 1;
      /**
       * The result of the entity.
       *
       * Either the result index of a numeric entity, or the codepoint of a
       * numeric entity.
       */

      this.result = 0;
      /** The current index in the decode tree. */

      this.treeIndex = 0;
      /** The number of characters that were consumed in excess. */

      this.excess = 1;
      /** The mode in which the decoder is operating. */

      this.decodeMode = DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */


    EntityDecoder.prototype.startEntity = function (decodeMode) {
      this.decodeMode = decodeMode;
      this.state = EntityDecoderState.EntityStart;
      this.result = 0;
      this.treeIndex = 0;
      this.excess = 1;
      this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */


    EntityDecoder.prototype.write = function (str, offset) {
      switch (this.state) {
        case EntityDecoderState.EntityStart:
          {
            if (str.charCodeAt(offset) === CharCodes.NUM) {
              this.state = EntityDecoderState.NumericStart;
              this.consumed += 1;
              return this.stateNumericStart(str, offset + 1);
            }

            this.state = EntityDecoderState.NamedEntity;
            return this.stateNamedEntity(str, offset);
          }

        case EntityDecoderState.NumericStart:
          {
            return this.stateNumericStart(str, offset);
          }

        case EntityDecoderState.NumericDecimal:
          {
            return this.stateNumericDecimal(str, offset);
          }

        case EntityDecoderState.NumericHex:
          {
            return this.stateNumericHex(str, offset);
          }

        case EntityDecoderState.NamedEntity:
          {
            return this.stateNamedEntity(str, offset);
          }
      }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */


    EntityDecoder.prototype.stateNumericStart = function (str, offset) {
      if (offset >= str.length) {
        return -1;
      }

      if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
        this.state = EntityDecoderState.NumericHex;
        this.consumed += 1;
        return this.stateNumericHex(str, offset + 1);
      }

      this.state = EntityDecoderState.NumericDecimal;
      return this.stateNumericDecimal(str, offset);
    };

    EntityDecoder.prototype.addToNumericResult = function (str, start, end, base) {
      if (start !== end) {
        var digitCount = end - start;
        this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
        this.consumed += digitCount;
      }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */


    EntityDecoder.prototype.stateNumericHex = function (str, offset) {
      var startIdx = offset;

      while (offset < str.length) {
        var char = str.charCodeAt(offset);

        if (isNumber(char) || isHexadecimalCharacter(char)) {
          offset += 1;
        } else {
          this.addToNumericResult(str, startIdx, offset, 16);
          return this.emitNumericEntity(char, 3);
        }
      }

      this.addToNumericResult(str, startIdx, offset, 16);
      return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */


    EntityDecoder.prototype.stateNumericDecimal = function (str, offset) {
      var startIdx = offset;

      while (offset < str.length) {
        var char = str.charCodeAt(offset);

        if (isNumber(char)) {
          offset += 1;
        } else {
          this.addToNumericResult(str, startIdx, offset, 10);
          return this.emitNumericEntity(char, 2);
        }
      }

      this.addToNumericResult(str, startIdx, offset, 10);
      return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */


    EntityDecoder.prototype.emitNumericEntity = function (lastCp, expectedLength) {
      var _a; // Ensure we consumed at least one digit.


      if (this.consumed <= expectedLength) {
        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
        return 0;
      } // Figure out if this is a legit end of the entity


      if (lastCp === CharCodes.SEMI) {
        this.consumed += 1;
      } else if (this.decodeMode === DecodingMode.Strict) {
        return 0;
      }

      this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);

      if (this.errors) {
        if (lastCp !== CharCodes.SEMI) {
          this.errors.missingSemicolonAfterCharacterReference();
        }

        this.errors.validateNumericCharacterReference(this.result);
      }

      return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */


    EntityDecoder.prototype.stateNamedEntity = function (str, offset) {
      var decodeTree = this.decodeTree;
      var current = decodeTree[this.treeIndex]; // The mask is the number of bytes of the value, including the current byte.

      var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;

      for (; offset < str.length; offset++, this.excess++) {
        var char = str.charCodeAt(offset);
        this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);

        if (this.treeIndex < 0) {
          return this.result === 0 || // If we are parsing an attribute
          this.decodeMode === DecodingMode.Attribute && ( // We shouldn't have consumed any characters after the entity,
          valueLength === 0 || // And there should be no invalid characters.
          isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
        }

        current = decodeTree[this.treeIndex];
        valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14; // If the branch is a value, store it and continue

        if (valueLength !== 0) {
          // If the entity is terminated by a semicolon, we are done.
          if (char === CharCodes.SEMI) {
            return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
          } // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.


          if (this.decodeMode !== DecodingMode.Strict) {
            this.result = this.treeIndex;
            this.consumed += this.excess;
            this.excess = 0;
          }
        }
      }

      return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */


    EntityDecoder.prototype.emitNotTerminatedNamedEntity = function () {
      var _a;

      var _b = this,
          result = _b.result,
          decodeTree = _b.decodeTree;

      var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
      this.emitNamedEntityData(result, valueLength, this.consumed);
      (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
      return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */


    EntityDecoder.prototype.emitNamedEntityData = function (result, valueLength, consumed) {
      var decodeTree = this.decodeTree;
      this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);

      if (valueLength === 3) {
        // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
      }

      return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */


    EntityDecoder.prototype.end = function () {
      var _a;

      switch (this.state) {
        case EntityDecoderState.NamedEntity:
          {
            // Emit a named entity if we have one.
            return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          }
        // Otherwise, emit a numeric entity if we have one.

        case EntityDecoderState.NumericDecimal:
          {
            return this.emitNumericEntity(0, 2);
          }

        case EntityDecoderState.NumericHex:
          {
            return this.emitNumericEntity(0, 3);
          }

        case EntityDecoderState.NumericStart:
          {
            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
          }

        case EntityDecoderState.EntityStart:
          {
            // Return 0 if we have no entity.
            return 0;
          }
      }
    };

    return EntityDecoder;
  }();

  exports.EntityDecoder = EntityDecoder;
  /**
   * Creates a function that decodes entities in a string.
   *
   * @param decodeTree The decode tree.
   * @returns A function that decodes entities in a string.
   */

  function getDecoder(decodeTree) {
    var ret = "";
    var decoder = new EntityDecoder(decodeTree, function (str) {
      return ret += (0, decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
      var lastIndex = 0;
      var offset = 0;

      while ((offset = str.indexOf("&", offset)) >= 0) {
        ret += str.slice(lastIndex, offset);
        decoder.startEntity(decodeMode);
        var len = decoder.write(str, // Skip the "&"
        offset + 1);

        if (len < 0) {
          lastIndex = offset + decoder.end();
          break;
        }

        lastIndex = offset + len; // If `len` is 0, skip the current `&` and continue.

        offset = len === 0 ? lastIndex + 1 : lastIndex;
      }

      var result = ret + str.slice(lastIndex); // Make sure we don't keep a reference to the final string.

      ret = "";
      return result;
    };
  }
  /**
   * Determines the branch of the current node that is taken given the current
   * character. This function is used to traverse the trie.
   *
   * @param decodeTree The trie.
   * @param current The current node.
   * @param nodeIdx The index right after the current node and its value.
   * @param char The current character.
   * @returns The index of the next node, or -1 if no branch is taken.
   */


  function determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE; // Case 1: Single branch encoded in jump offset

    if (branchCount === 0) {
      return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    } // Case 2: Multiple branches encoded in jump table


    if (jumpOffset) {
      var value = char - jumpOffset;
      return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    } // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.


    var lo = nodeIdx;
    var hi = lo + branchCount - 1;

    while (lo <= hi) {
      var mid = lo + hi >>> 1;
      var midVal = decodeTree[mid];

      if (midVal < char) {
        lo = mid + 1;
      } else if (midVal > char) {
        hi = mid - 1;
      } else {
        return decodeTree[mid + branchCount];
      }
    }

    return -1;
  }

  exports.determineBranch = determineBranch;
  var htmlDecoder = getDecoder(decode_data_html_js_1.default);
  var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
  /**
   * Decodes an HTML string.
   *
   * @param str The string to decode.
   * @param mode The decoding mode.
   * @returns The decoded string.
   */

  function decodeHTML(str, mode) {
    if (mode === void 0) {
      mode = DecodingMode.Legacy;
    }

    return htmlDecoder(str, mode);
  }

  exports.decodeHTML = decodeHTML;
  /**
   * Decodes an HTML string in an attribute.
   *
   * @param str The string to decode.
   * @returns The decoded string.
   */

  function decodeHTMLAttribute(str) {
    return htmlDecoder(str, DecodingMode.Attribute);
  }

  exports.decodeHTMLAttribute = decodeHTMLAttribute;
  /**
   * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
   *
   * @param str The string to decode.
   * @returns The decoded string.
   */

  function decodeHTMLStrict(str) {
    return htmlDecoder(str, DecodingMode.Strict);
  }

  exports.decodeHTMLStrict = decodeHTMLStrict;
  /**
   * Decodes an XML string, requiring all entities to be terminated by a semicolon.
   *
   * @param str The string to decode.
   * @returns The decoded string.
   */

  function decodeXML(str) {
    return xmlDecoder(str, DecodingMode.Strict);
  }

  exports.decodeXML = decodeXML;
});
unwrapExports(decode$2);
decode$2.decodeXML;
decode$2.decodeHTMLStrict;
decode$2.decodeHTMLAttribute;
decode$2.decodeHTML;
var decode_5 = decode$2.determineBranch;
decode$2.EntityDecoder;
decode$2.DecodingMode;
var decode_8 = decode$2.BinTrieFlags;
var decode_9 = decode$2.fromCodePoint;
var decode_10 = decode$2.replaceCodePoint;
decode$2.decodeCodePoint;
var decode_12 = decode$2.xmlDecodeTree;
var decode_13 = decode$2.htmlDecodeTree;
var CharCodes;

(function (CharCodes) {
  CharCodes[CharCodes["Tab"] = 9] = "Tab";
  CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
  CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
  CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
  CharCodes[CharCodes["Space"] = 32] = "Space";
  CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
  CharCodes[CharCodes["Number"] = 35] = "Number";
  CharCodes[CharCodes["Amp"] = 38] = "Amp";
  CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
  CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
  CharCodes[CharCodes["Dash"] = 45] = "Dash";
  CharCodes[CharCodes["Slash"] = 47] = "Slash";
  CharCodes[CharCodes["Zero"] = 48] = "Zero";
  CharCodes[CharCodes["Nine"] = 57] = "Nine";
  CharCodes[CharCodes["Semi"] = 59] = "Semi";
  CharCodes[CharCodes["Lt"] = 60] = "Lt";
  CharCodes[CharCodes["Eq"] = 61] = "Eq";
  CharCodes[CharCodes["Gt"] = 62] = "Gt";
  CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
  CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
  CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
  CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
  CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
  CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
  CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
  CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
  CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})(CharCodes || (CharCodes = {}));
/** All the states the tokenizer can be in. */


var State;

(function (State) {
  State[State["Text"] = 1] = "Text";
  State[State["BeforeTagName"] = 2] = "BeforeTagName";
  State[State["InTagName"] = 3] = "InTagName";
  State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
  State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
  State[State["InClosingTagName"] = 6] = "InClosingTagName";
  State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName"; // Attributes

  State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
  State[State["InAttributeName"] = 9] = "InAttributeName";
  State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
  State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
  State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
  State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
  State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq"; // Declarations

  State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
  State[State["InDeclaration"] = 16] = "InDeclaration"; // Processing instructions

  State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction"; // Comments & CDATA

  State[State["BeforeComment"] = 18] = "BeforeComment";
  State[State["CDATASequence"] = 19] = "CDATASequence";
  State[State["InSpecialComment"] = 20] = "InSpecialComment";
  State[State["InCommentLike"] = 21] = "InCommentLike"; // Special tags

  State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
  State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
  State[State["InSpecialTag"] = 24] = "InSpecialTag";
  State[State["BeforeEntity"] = 25] = "BeforeEntity";
  State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
  State[State["InNamedEntity"] = 27] = "InNamedEntity";
  State[State["InNumericEntity"] = 28] = "InNumericEntity";
  State[State["InHexEntity"] = 29] = "InHexEntity";
})(State || (State = {}));

function isWhitespace(c) {
  return c === CharCodes.Space || c === CharCodes.NewLine || c === CharCodes.Tab || c === CharCodes.FormFeed || c === CharCodes.CarriageReturn;
}

function isEndOfTagSection(c) {
  return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace(c);
}

function isNumber(c) {
  return c >= CharCodes.Zero && c <= CharCodes.Nine;
}

function isASCIIAlpha(c) {
  return c >= CharCodes.LowerA && c <= CharCodes.LowerZ || c >= CharCodes.UpperA && c <= CharCodes.UpperZ;
}

function isHexDigit(c) {
  return c >= CharCodes.UpperA && c <= CharCodes.UpperF || c >= CharCodes.LowerA && c <= CharCodes.LowerF;
}

var QuoteType;

(function (QuoteType) {
  QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
  QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
  QuoteType[QuoteType["Single"] = 2] = "Single";
  QuoteType[QuoteType["Double"] = 3] = "Double";
})(QuoteType || (QuoteType = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */


var Sequences = {
  Cdata: new Uint8Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
  CdataEnd: new Uint8Array([0x5d, 0x5d, 0x3e]),
  CommentEnd: new Uint8Array([0x2d, 0x2d, 0x3e]),
  ScriptEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74]),
  StyleEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
  TitleEnd: new Uint8Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]) // `</title`

};

var Tokenizer = /*#__PURE__*/function () {
  function Tokenizer(_ref3, cbs) {
    var _ref3$xmlMode = _ref3.xmlMode,
        xmlMode = _ref3$xmlMode === void 0 ? false : _ref3$xmlMode,
        _ref3$decodeEntities = _ref3.decodeEntities,
        decodeEntities = _ref3$decodeEntities === void 0 ? true : _ref3$decodeEntities;

    _classCallCheck2(this, Tokenizer);

    this.cbs = cbs;
    /** The current state the tokenizer is in. */

    this.state = State.Text;
    /** The read buffer. */

    this.buffer = "";
    /** The beginning of the section that is currently being read. */

    this.sectionStart = 0;
    /** The index within the buffer that we are currently looking at. */

    this.index = 0;
    /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */

    this.baseState = State.Text;
    /** For special parsing behavior inside of script and style tags. */

    this.isSpecial = false;
    /** Indicates whether the tokenizer has been paused. */

    this.running = true;
    /** The offset of the current buffer. */

    this.offset = 0;
    this.currentSequence = undefined;
    this.sequenceIndex = 0;
    this.trieIndex = 0;
    this.trieCurrent = 0;
    /** For named entities, the index of the value. For numeric entities, the code point. */

    this.entityResult = 0;
    this.entityExcess = 0;
    this.xmlMode = xmlMode;
    this.decodeEntities = decodeEntities;
    this.entityTrie = xmlMode ? decode_12 : decode_13;
  }

  _createClass2(Tokenizer, [{
    key: "reset",
    value: function reset() {
      this.state = State.Text;
      this.buffer = "";
      this.sectionStart = 0;
      this.index = 0;
      this.baseState = State.Text;
      this.currentSequence = undefined;
      this.running = true;
      this.offset = 0;
    }
  }, {
    key: "write",
    value: function write(chunk) {
      this.offset += this.buffer.length;
      this.buffer = chunk;
      this.parse();
    }
  }, {
    key: "end",
    value: function end() {
      if (this.running) this.finish();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.running = false;
    }
  }, {
    key: "resume",
    value: function resume() {
      this.running = true;

      if (this.index < this.buffer.length + this.offset) {
        this.parse();
      }
    }
    /**
     * The current index within all of the written data.
     */

  }, {
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
    /**
     * The start of the current section.
     */

  }, {
    key: "getSectionStart",
    value: function getSectionStart() {
      return this.sectionStart;
    }
  }, {
    key: "stateText",
    value: function stateText(c) {
      if (c === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
        if (this.index > this.sectionStart) {
          this.cbs.ontext(this.sectionStart, this.index);
        }

        this.state = State.BeforeTagName;
        this.sectionStart = this.index;
      } else if (this.decodeEntities && c === CharCodes.Amp) {
        this.state = State.BeforeEntity;
      }
    }
  }, {
    key: "stateSpecialStartSequence",
    value: function stateSpecialStartSequence(c) {
      var isEnd = this.sequenceIndex === this.currentSequence.length;
      var isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
      isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
      (c | 0x20) === this.currentSequence[this.sequenceIndex];

      if (!isMatch) {
        this.isSpecial = false;
      } else if (!isEnd) {
        this.sequenceIndex++;
        return;
      }

      this.sequenceIndex = 0;
      this.state = State.InTagName;
      this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */

  }, {
    key: "stateInSpecialTag",
    value: function stateInSpecialTag(c) {
      if (this.sequenceIndex === this.currentSequence.length) {
        if (c === CharCodes.Gt || isWhitespace(c)) {
          var endOfText = this.index - this.currentSequence.length;

          if (this.sectionStart < endOfText) {
            // Spoof the index so that reported locations match up.
            var actualIndex = this.index;
            this.index = endOfText;
            this.cbs.ontext(this.sectionStart, endOfText);
            this.index = actualIndex;
          }

          this.isSpecial = false;
          this.sectionStart = endOfText + 2; // Skip over the `</`

          this.stateInClosingTagName(c);
          return; // We are done; skip the rest of the function.
        }

        this.sequenceIndex = 0;
      }

      if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
        this.sequenceIndex += 1;
      } else if (this.sequenceIndex === 0) {
        if (this.currentSequence === Sequences.TitleEnd) {
          // We have to parse entities in <title> tags.
          if (this.decodeEntities && c === CharCodes.Amp) {
            this.state = State.BeforeEntity;
          }
        } else if (this.fastForwardTo(CharCodes.Lt)) {
          // Outside of <title> tags, we can fast-forward.
          this.sequenceIndex = 1;
        }
      } else {
        // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === CharCodes.Lt);
      }
    }
  }, {
    key: "stateCDATASequence",
    value: function stateCDATASequence(c) {
      if (c === Sequences.Cdata[this.sequenceIndex]) {
        if (++this.sequenceIndex === Sequences.Cdata.length) {
          this.state = State.InCommentLike;
          this.currentSequence = Sequences.CdataEnd;
          this.sequenceIndex = 0;
          this.sectionStart = this.index + 1;
        }
      } else {
        this.sequenceIndex = 0;
        this.state = State.InDeclaration;
        this.stateInDeclaration(c); // Reconsume the character
      }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */

  }, {
    key: "fastForwardTo",
    value: function fastForwardTo(c) {
      while (++this.index < this.buffer.length + this.offset) {
        if (this.buffer.charCodeAt(this.index - this.offset) === c) {
          return true;
        }
      }
      /*
       * We increment the index at the end of the `parse` loop,
       * so set it to `buffer.length - 1` here.
       *
       * TODO: Refactor `parse` to increment index before calling states.
       */


      this.index = this.buffer.length + this.offset - 1;
      return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */

  }, {
    key: "stateInCommentLike",
    value: function stateInCommentLike(c) {
      if (c === this.currentSequence[this.sequenceIndex]) {
        if (++this.sequenceIndex === this.currentSequence.length) {
          if (this.currentSequence === Sequences.CdataEnd) {
            this.cbs.oncdata(this.sectionStart, this.index, 2);
          } else {
            this.cbs.oncomment(this.sectionStart, this.index, 2);
          }

          this.sequenceIndex = 0;
          this.sectionStart = this.index + 1;
          this.state = State.Text;
        }
      } else if (this.sequenceIndex === 0) {
        // Fast-forward to the first character of the sequence
        if (this.fastForwardTo(this.currentSequence[0])) {
          this.sequenceIndex = 1;
        }
      } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
        // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
      }
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */

  }, {
    key: "isTagStartChar",
    value: function isTagStartChar(c) {
      return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
    }
  }, {
    key: "startSpecial",
    value: function startSpecial(sequence, offset) {
      this.isSpecial = true;
      this.currentSequence = sequence;
      this.sequenceIndex = offset;
      this.state = State.SpecialStartSequence;
    }
  }, {
    key: "stateBeforeTagName",
    value: function stateBeforeTagName(c) {
      if (c === CharCodes.ExclamationMark) {
        this.state = State.BeforeDeclaration;
        this.sectionStart = this.index + 1;
      } else if (c === CharCodes.Questionmark) {
        this.state = State.InProcessingInstruction;
        this.sectionStart = this.index + 1;
      } else if (this.isTagStartChar(c)) {
        var lower = c | 0x20;
        this.sectionStart = this.index;

        if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
          this.startSpecial(Sequences.TitleEnd, 3);
        } else {
          this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
        }
      } else if (c === CharCodes.Slash) {
        this.state = State.BeforeClosingTagName;
      } else {
        this.state = State.Text;
        this.stateText(c);
      }
    }
  }, {
    key: "stateInTagName",
    value: function stateInTagName(c) {
      if (isEndOfTagSection(c)) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = State.BeforeAttributeName;
        this.stateBeforeAttributeName(c);
      }
    }
  }, {
    key: "stateBeforeClosingTagName",
    value: function stateBeforeClosingTagName(c) {
      if (isWhitespace(c)) ;else if (c === CharCodes.Gt) {
        this.state = State.Text;
      } else {
        this.state = this.isTagStartChar(c) ? State.InClosingTagName : State.InSpecialComment;
        this.sectionStart = this.index;
      }
    }
  }, {
    key: "stateInClosingTagName",
    value: function stateInClosingTagName(c) {
      if (c === CharCodes.Gt || isWhitespace(c)) {
        this.cbs.onclosetag(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = State.AfterClosingTagName;
        this.stateAfterClosingTagName(c);
      }
    }
  }, {
    key: "stateAfterClosingTagName",
    value: function stateAfterClosingTagName(c) {
      // Skip everything until ">"
      if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
        this.state = State.Text;
        this.baseState = State.Text;
        this.sectionStart = this.index + 1;
      }
    }
  }, {
    key: "stateBeforeAttributeName",
    value: function stateBeforeAttributeName(c) {
      if (c === CharCodes.Gt) {
        this.cbs.onopentagend(this.index);

        if (this.isSpecial) {
          this.state = State.InSpecialTag;
          this.sequenceIndex = 0;
        } else {
          this.state = State.Text;
        }

        this.baseState = this.state;
        this.sectionStart = this.index + 1;
      } else if (c === CharCodes.Slash) {
        this.state = State.InSelfClosingTag;
      } else if (!isWhitespace(c)) {
        this.state = State.InAttributeName;
        this.sectionStart = this.index;
      }
    }
  }, {
    key: "stateInSelfClosingTag",
    value: function stateInSelfClosingTag(c) {
      if (c === CharCodes.Gt) {
        this.cbs.onselfclosingtag(this.index);
        this.state = State.Text;
        this.baseState = State.Text;
        this.sectionStart = this.index + 1;
        this.isSpecial = false; // Reset special state, in case of self-closing special tags
      } else if (!isWhitespace(c)) {
        this.state = State.BeforeAttributeName;
        this.stateBeforeAttributeName(c);
      }
    }
  }, {
    key: "stateInAttributeName",
    value: function stateInAttributeName(c) {
      if (c === CharCodes.Eq || isEndOfTagSection(c)) {
        this.cbs.onattribname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = State.AfterAttributeName;
        this.stateAfterAttributeName(c);
      }
    }
  }, {
    key: "stateAfterAttributeName",
    value: function stateAfterAttributeName(c) {
      if (c === CharCodes.Eq) {
        this.state = State.BeforeAttributeValue;
      } else if (c === CharCodes.Slash || c === CharCodes.Gt) {
        this.cbs.onattribend(QuoteType.NoValue, this.index);
        this.state = State.BeforeAttributeName;
        this.stateBeforeAttributeName(c);
      } else if (!isWhitespace(c)) {
        this.cbs.onattribend(QuoteType.NoValue, this.index);
        this.state = State.InAttributeName;
        this.sectionStart = this.index;
      }
    }
  }, {
    key: "stateBeforeAttributeValue",
    value: function stateBeforeAttributeValue(c) {
      if (c === CharCodes.DoubleQuote) {
        this.state = State.InAttributeValueDq;
        this.sectionStart = this.index + 1;
      } else if (c === CharCodes.SingleQuote) {
        this.state = State.InAttributeValueSq;
        this.sectionStart = this.index + 1;
      } else if (!isWhitespace(c)) {
        this.sectionStart = this.index;
        this.state = State.InAttributeValueNq;
        this.stateInAttributeValueNoQuotes(c); // Reconsume token
      }
    }
  }, {
    key: "handleInAttributeValue",
    value: function handleInAttributeValue(c, quote) {
      if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.cbs.onattribend(quote === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
        this.state = State.BeforeAttributeName;
      } else if (this.decodeEntities && c === CharCodes.Amp) {
        this.baseState = this.state;
        this.state = State.BeforeEntity;
      }
    }
  }, {
    key: "stateInAttributeValueDoubleQuotes",
    value: function stateInAttributeValueDoubleQuotes(c) {
      this.handleInAttributeValue(c, CharCodes.DoubleQuote);
    }
  }, {
    key: "stateInAttributeValueSingleQuotes",
    value: function stateInAttributeValueSingleQuotes(c) {
      this.handleInAttributeValue(c, CharCodes.SingleQuote);
    }
  }, {
    key: "stateInAttributeValueNoQuotes",
    value: function stateInAttributeValueNoQuotes(c) {
      if (isWhitespace(c) || c === CharCodes.Gt) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.cbs.onattribend(QuoteType.Unquoted, this.index);
        this.state = State.BeforeAttributeName;
        this.stateBeforeAttributeName(c);
      } else if (this.decodeEntities && c === CharCodes.Amp) {
        this.baseState = this.state;
        this.state = State.BeforeEntity;
      }
    }
  }, {
    key: "stateBeforeDeclaration",
    value: function stateBeforeDeclaration(c) {
      if (c === CharCodes.OpeningSquareBracket) {
        this.state = State.CDATASequence;
        this.sequenceIndex = 0;
      } else {
        this.state = c === CharCodes.Dash ? State.BeforeComment : State.InDeclaration;
      }
    }
  }, {
    key: "stateInDeclaration",
    value: function stateInDeclaration(c) {
      if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
        this.cbs.ondeclaration(this.sectionStart, this.index);
        this.state = State.Text;
        this.sectionStart = this.index + 1;
      }
    }
  }, {
    key: "stateInProcessingInstruction",
    value: function stateInProcessingInstruction(c) {
      if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
        this.cbs.onprocessinginstruction(this.sectionStart, this.index);
        this.state = State.Text;
        this.sectionStart = this.index + 1;
      }
    }
  }, {
    key: "stateBeforeComment",
    value: function stateBeforeComment(c) {
      if (c === CharCodes.Dash) {
        this.state = State.InCommentLike;
        this.currentSequence = Sequences.CommentEnd; // Allow short comments (eg. <!-->)

        this.sequenceIndex = 2;
        this.sectionStart = this.index + 1;
      } else {
        this.state = State.InDeclaration;
      }
    }
  }, {
    key: "stateInSpecialComment",
    value: function stateInSpecialComment(c) {
      if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
        this.cbs.oncomment(this.sectionStart, this.index, 0);
        this.state = State.Text;
        this.sectionStart = this.index + 1;
      }
    }
  }, {
    key: "stateBeforeSpecialS",
    value: function stateBeforeSpecialS(c) {
      var lower = c | 0x20;

      if (lower === Sequences.ScriptEnd[3]) {
        this.startSpecial(Sequences.ScriptEnd, 4);
      } else if (lower === Sequences.StyleEnd[3]) {
        this.startSpecial(Sequences.StyleEnd, 4);
      } else {
        this.state = State.InTagName;
        this.stateInTagName(c); // Consume the token again
      }
    }
  }, {
    key: "stateBeforeEntity",
    value: function stateBeforeEntity(c) {
      // Start excess with 1 to include the '&'
      this.entityExcess = 1;
      this.entityResult = 0;

      if (c === CharCodes.Number) {
        this.state = State.BeforeNumericEntity;
      } else if (c === CharCodes.Amp) ;else {
        this.trieIndex = 0;
        this.trieCurrent = this.entityTrie[0];
        this.state = State.InNamedEntity;
        this.stateInNamedEntity(c);
      }
    }
  }, {
    key: "stateInNamedEntity",
    value: function stateInNamedEntity(c) {
      this.entityExcess += 1;
      this.trieIndex = decode_5(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);

      if (this.trieIndex < 0) {
        this.emitNamedEntity();
        this.index--;
        return;
      }

      this.trieCurrent = this.entityTrie[this.trieIndex];
      var masked = this.trieCurrent & decode_8.VALUE_LENGTH; // If the branch is a value, store it and continue

      if (masked) {
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (masked >> 14) - 1; // If we have a legacy entity while parsing strictly, just skip the number of bytes

        if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
          this.trieIndex += valueLength;
        } else {
          // Add 1 as we have already incremented the excess
          var entityStart = this.index - this.entityExcess + 1;

          if (entityStart > this.sectionStart) {
            this.emitPartial(this.sectionStart, entityStart);
          } // If this is a surrogate pair, consume the next two bytes


          this.entityResult = this.trieIndex;
          this.trieIndex += valueLength;
          this.entityExcess = 0;
          this.sectionStart = this.index + 1;

          if (valueLength === 0) {
            this.emitNamedEntity();
          }
        }
      }
    }
  }, {
    key: "emitNamedEntity",
    value: function emitNamedEntity() {
      this.state = this.baseState;

      if (this.entityResult === 0) {
        return;
      }

      var valueLength = (this.entityTrie[this.entityResult] & decode_8.VALUE_LENGTH) >> 14;

      switch (valueLength) {
        case 1:
          {
            this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_8.VALUE_LENGTH);
            break;
          }

        case 2:
          {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            break;
          }

        case 3:
          {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
      }
    }
  }, {
    key: "stateBeforeNumericEntity",
    value: function stateBeforeNumericEntity(c) {
      if ((c | 0x20) === CharCodes.LowerX) {
        this.entityExcess++;
        this.state = State.InHexEntity;
      } else {
        this.state = State.InNumericEntity;
        this.stateInNumericEntity(c);
      }
    }
  }, {
    key: "emitNumericEntity",
    value: function emitNumericEntity(strict) {
      var entityStart = this.index - this.entityExcess - 1;
      var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);

      if (numberStart !== this.index) {
        // Emit leading data if any
        if (entityStart > this.sectionStart) {
          this.emitPartial(this.sectionStart, entityStart);
        }

        this.sectionStart = this.index + Number(strict);
        this.emitCodePoint(decode_10(this.entityResult));
      }

      this.state = this.baseState;
    }
  }, {
    key: "stateInNumericEntity",
    value: function stateInNumericEntity(c) {
      if (c === CharCodes.Semi) {
        this.emitNumericEntity(true);
      } else if (isNumber(c)) {
        this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
        this.entityExcess++;
      } else {
        if (this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else {
          this.state = this.baseState;
        }

        this.index--;
      }
    }
  }, {
    key: "stateInHexEntity",
    value: function stateInHexEntity(c) {
      if (c === CharCodes.Semi) {
        this.emitNumericEntity(true);
      } else if (isNumber(c)) {
        this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
        this.entityExcess++;
      } else if (isHexDigit(c)) {
        this.entityResult = this.entityResult * 16 + ((c | 0x20) - CharCodes.LowerA + 10);
        this.entityExcess++;
      } else {
        if (this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else {
          this.state = this.baseState;
        }

        this.index--;
      }
    }
  }, {
    key: "allowLegacyEntity",
    value: function allowLegacyEntity() {
      return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      // If we are inside of text or attributes, emit what we already have.
      if (this.running && this.sectionStart !== this.index) {
        if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
          this.cbs.ontext(this.sectionStart, this.index);
          this.sectionStart = this.index;
        } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = this.index;
        }
      }
    }
  }, {
    key: "shouldContinue",
    value: function shouldContinue() {
      return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */

  }, {
    key: "parse",
    value: function parse() {
      while (this.shouldContinue()) {
        var c = this.buffer.charCodeAt(this.index - this.offset);

        switch (this.state) {
          case State.Text:
            {
              this.stateText(c);
              break;
            }

          case State.SpecialStartSequence:
            {
              this.stateSpecialStartSequence(c);
              break;
            }

          case State.InSpecialTag:
            {
              this.stateInSpecialTag(c);
              break;
            }

          case State.CDATASequence:
            {
              this.stateCDATASequence(c);
              break;
            }

          case State.InAttributeValueDq:
            {
              this.stateInAttributeValueDoubleQuotes(c);
              break;
            }

          case State.InAttributeName:
            {
              this.stateInAttributeName(c);
              break;
            }

          case State.InCommentLike:
            {
              this.stateInCommentLike(c);
              break;
            }

          case State.InSpecialComment:
            {
              this.stateInSpecialComment(c);
              break;
            }

          case State.BeforeAttributeName:
            {
              this.stateBeforeAttributeName(c);
              break;
            }

          case State.InTagName:
            {
              this.stateInTagName(c);
              break;
            }

          case State.InClosingTagName:
            {
              this.stateInClosingTagName(c);
              break;
            }

          case State.BeforeTagName:
            {
              this.stateBeforeTagName(c);
              break;
            }

          case State.AfterAttributeName:
            {
              this.stateAfterAttributeName(c);
              break;
            }

          case State.InAttributeValueSq:
            {
              this.stateInAttributeValueSingleQuotes(c);
              break;
            }

          case State.BeforeAttributeValue:
            {
              this.stateBeforeAttributeValue(c);
              break;
            }

          case State.BeforeClosingTagName:
            {
              this.stateBeforeClosingTagName(c);
              break;
            }

          case State.AfterClosingTagName:
            {
              this.stateAfterClosingTagName(c);
              break;
            }

          case State.BeforeSpecialS:
            {
              this.stateBeforeSpecialS(c);
              break;
            }

          case State.InAttributeValueNq:
            {
              this.stateInAttributeValueNoQuotes(c);
              break;
            }

          case State.InSelfClosingTag:
            {
              this.stateInSelfClosingTag(c);
              break;
            }

          case State.InDeclaration:
            {
              this.stateInDeclaration(c);
              break;
            }

          case State.BeforeDeclaration:
            {
              this.stateBeforeDeclaration(c);
              break;
            }

          case State.BeforeComment:
            {
              this.stateBeforeComment(c);
              break;
            }

          case State.InProcessingInstruction:
            {
              this.stateInProcessingInstruction(c);
              break;
            }

          case State.InNamedEntity:
            {
              this.stateInNamedEntity(c);
              break;
            }

          case State.BeforeEntity:
            {
              this.stateBeforeEntity(c);
              break;
            }

          case State.InHexEntity:
            {
              this.stateInHexEntity(c);
              break;
            }

          case State.InNumericEntity:
            {
              this.stateInNumericEntity(c);
              break;
            }

          default:
            {
              // `this._state === State.BeforeNumericEntity`
              this.stateBeforeNumericEntity(c);
            }
        }

        this.index++;
      }

      this.cleanup();
    }
  }, {
    key: "finish",
    value: function finish() {
      if (this.state === State.InNamedEntity) {
        this.emitNamedEntity();
      } // If there is remaining data, emit it in a reasonable way


      if (this.sectionStart < this.index) {
        this.handleTrailingData();
      }

      this.cbs.onend();
    }
    /** Handle any trailing data. */

  }, {
    key: "handleTrailingData",
    value: function handleTrailingData() {
      var endIndex = this.buffer.length + this.offset;

      if (this.state === State.InCommentLike) {
        if (this.currentSequence === Sequences.CdataEnd) {
          this.cbs.oncdata(this.sectionStart, endIndex, 0);
        } else {
          this.cbs.oncomment(this.sectionStart, endIndex, 0);
        }
      } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
        this.emitNumericEntity(false); // All trailing data will have been consumed
      } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
        this.emitNumericEntity(false); // All trailing data will have been consumed
      } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) ;else {
        this.cbs.ontext(this.sectionStart, endIndex);
      }
    }
  }, {
    key: "emitPartial",
    value: function emitPartial(start, endIndex) {
      if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
        this.cbs.onattribdata(start, endIndex);
      } else {
        this.cbs.ontext(start, endIndex);
      }
    }
  }, {
    key: "emitCodePoint",
    value: function emitCodePoint(cp) {
      if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
        this.cbs.onattribentity(cp);
      } else {
        this.cbs.ontextentity(cp);
      }
    }
  }]);

  return Tokenizer;
}();

var formTags = new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([["tr", new Set(["tr", "th", "td"])], ["th", new Set(["th"])], ["td", new Set(["thead", "th", "td"])], ["body", new Set(["head", "link", "script"])], ["li", new Set(["li"])], ["p", pTag], ["h1", pTag], ["h2", pTag], ["h3", pTag], ["h4", pTag], ["h5", pTag], ["h6", pTag], ["select", formTags], ["input", formTags], ["output", formTags], ["button", formTags], ["datalist", formTags], ["textarea", formTags], ["option", new Set(["option"])], ["optgroup", new Set(["optgroup", "option"])], ["dd", ddtTags], ["dt", ddtTags], ["address", pTag], ["article", pTag], ["aside", pTag], ["blockquote", pTag], ["details", pTag], ["div", pTag], ["dl", pTag], ["fieldset", pTag], ["figcaption", pTag], ["figure", pTag], ["footer", pTag], ["form", pTag], ["header", pTag], ["hr", pTag], ["main", pTag], ["nav", pTag], ["ol", pTag], ["pre", pTag], ["section", pTag], ["table", pTag], ["ul", pTag], ["rt", rtpTags], ["rp", rtpTags], ["tbody", tableSectionTags], ["tfoot", tableSectionTags]]);
var voidElements = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]);
var reNameEnd = /\s|\//;

var Parser$1 = /*#__PURE__*/function () {
  function Parser$1(cbs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, Parser$1);

    var _a, _b, _c, _d, _e;

    this.options = options;
    /** The start index of the last event. */

    this.startIndex = 0;
    /** The end index of the last event. */

    this.endIndex = 0;
    /**
     * Store the start index of the current open tag,
     * so we can update the start index for attributes.
     */

    this.openTagStart = 0;
    this.tagname = "";
    this.attribname = "";
    this.attribvalue = "";
    this.attribs = null;
    this.stack = [];
    this.foreignContext = [];
    this.buffers = [];
    this.bufferOffset = 0;
    /** The index of the last written buffer. Used when resuming after a `pause()`. */

    this.writeIndex = 0;
    /** Indicates whether the parser has finished running / `.end` has been called. */

    this.ended = false;
    this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
    this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
    this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
    this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer)(this.options, this);
    (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
  } // Tokenizer event handlers

  /** @internal */


  _createClass2(Parser$1, [{
    key: "ontext",
    value: function ontext(start, endIndex) {
      var _a, _b;

      var data = this.getSlice(start, endIndex);
      this.endIndex = endIndex - 1;
      (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
      this.startIndex = endIndex;
    }
    /** @internal */

  }, {
    key: "ontextentity",
    value: function ontextentity(cp) {
      var _a, _b;
      /*
       * Entities can be emitted on the character, or directly after.
       * We use the section start here to get accurate indices.
       */


      var index = this.tokenizer.getSectionStart();
      this.endIndex = index - 1;
      (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, decode_9(cp));
      this.startIndex = index;
    }
  }, {
    key: "isVoidElement",
    value: function isVoidElement(name) {
      return !this.options.xmlMode && voidElements.has(name);
    }
    /** @internal */

  }, {
    key: "onopentagname",
    value: function onopentagname(start, endIndex) {
      this.endIndex = endIndex;
      var name = this.getSlice(start, endIndex);

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      this.emitOpenTag(name);
    }
  }, {
    key: "emitOpenTag",
    value: function emitOpenTag(name) {
      var _a, _b, _c, _d;

      this.openTagStart = this.startIndex;
      this.tagname = name;
      var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);

      if (impliesClose) {
        while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
          var element = this.stack.pop();
          (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
        }
      }

      if (!this.isVoidElement(name)) {
        this.stack.push(name);

        if (foreignContextElements.has(name)) {
          this.foreignContext.push(true);
        } else if (htmlIntegrationElements.has(name)) {
          this.foreignContext.push(false);
        }
      }

      (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
      if (this.cbs.onopentag) this.attribs = {};
    }
  }, {
    key: "endOpenTag",
    value: function endOpenTag(isImplied) {
      var _a, _b;

      this.startIndex = this.openTagStart;

      if (this.attribs) {
        (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
        this.attribs = null;
      }

      if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
        this.cbs.onclosetag(this.tagname, true);
      }

      this.tagname = "";
    }
    /** @internal */

  }, {
    key: "onopentagend",
    value: function onopentagend(endIndex) {
      this.endIndex = endIndex;
      this.endOpenTag(false); // Set `startIndex` for next node

      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "onclosetag",
    value: function onclosetag(start, endIndex) {
      var _a, _b, _c, _d, _e, _f;

      this.endIndex = endIndex;
      var name = this.getSlice(start, endIndex);

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
        this.foreignContext.pop();
      }

      if (!this.isVoidElement(name)) {
        var pos = this.stack.lastIndexOf(name);

        if (pos !== -1) {
          if (this.cbs.onclosetag) {
            var count = this.stack.length - pos;

            while (count--) {
              // We know the stack has sufficient elements.
              this.cbs.onclosetag(this.stack.pop(), count !== 0);
            }
          } else this.stack.length = pos;
        } else if (!this.options.xmlMode && name === "p") {
          // Implicit open before close
          this.emitOpenTag("p");
          this.closeCurrentTag(true);
        }
      } else if (!this.options.xmlMode && name === "br") {
        // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
        (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
        (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
      } // Set `startIndex` for next node


      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "onselfclosingtag",
    value: function onselfclosingtag(endIndex) {
      this.endIndex = endIndex;

      if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
        this.closeCurrentTag(false); // Set `startIndex` for next node

        this.startIndex = endIndex + 1;
      } else {
        // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
      }
    }
  }, {
    key: "closeCurrentTag",
    value: function closeCurrentTag(isOpenImplied) {
      var _a, _b;

      var name = this.tagname;
      this.endOpenTag(isOpenImplied); // Self-closing tags will be on the top of the stack

      if (this.stack[this.stack.length - 1] === name) {
        // If the opening tag isn't implied, the closing tag has to be implied.
        (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
        this.stack.pop();
      }
    }
    /** @internal */

  }, {
    key: "onattribname",
    value: function onattribname(start, endIndex) {
      this.startIndex = start;
      var name = this.getSlice(start, endIndex);
      this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */

  }, {
    key: "onattribdata",
    value: function onattribdata(start, endIndex) {
      this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */

  }, {
    key: "onattribentity",
    value: function onattribentity(cp) {
      this.attribvalue += decode_9(cp);
    }
    /** @internal */

  }, {
    key: "onattribend",
    value: function onattribend(quote, endIndex) {
      var _a, _b;

      this.endIndex = endIndex;
      (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === QuoteType.Double ? '"' : quote === QuoteType.Single ? "'" : quote === QuoteType.NoValue ? undefined : null);

      if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
        this.attribs[this.attribname] = this.attribvalue;
      }

      this.attribvalue = "";
    }
  }, {
    key: "getInstructionName",
    value: function getInstructionName(value) {
      var index = value.search(reNameEnd);
      var name = index < 0 ? value : value.substr(0, index);

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      return name;
    }
    /** @internal */

  }, {
    key: "ondeclaration",
    value: function ondeclaration(start, endIndex) {
      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex);

      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
      } // Set `startIndex` for next node


      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "onprocessinginstruction",
    value: function onprocessinginstruction(start, endIndex) {
      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex);

      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
      } // Set `startIndex` for next node


      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "oncomment",
    value: function oncomment(start, endIndex, offset) {
      var _a, _b, _c, _d;

      this.endIndex = endIndex;
      (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
      (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c); // Set `startIndex` for next node

      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "oncdata",
    value: function oncdata(start, endIndex, offset) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex - offset);

      if (this.options.xmlMode || this.options.recognizeCDATA) {
        (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
        (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
      } else {
        (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
        (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
      } // Set `startIndex` for next node


      this.startIndex = endIndex + 1;
    }
    /** @internal */

  }, {
    key: "onend",
    value: function onend() {
      var _a, _b;

      if (this.cbs.onclosetag) {
        // Set the end index for all remaining tags
        this.endIndex = this.startIndex;

        for (var _index = this.stack.length; _index > 0; this.cbs.onclosetag(this.stack[--_index], true)) {
          ;
        }
      }

      (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */

  }, {
    key: "reset",
    value: function reset() {
      var _a, _b, _c, _d;

      (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
      this.tokenizer.reset();
      this.tagname = "";
      this.attribname = "";
      this.attribs = null;
      this.stack.length = 0;
      this.startIndex = 0;
      this.endIndex = 0;
      (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
      this.buffers.length = 0;
      this.bufferOffset = 0;
      this.writeIndex = 0;
      this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */

  }, {
    key: "parseComplete",
    value: function parseComplete(data) {
      this.reset();
      this.end(data);
    }
  }, {
    key: "getSlice",
    value: function getSlice(start, end) {
      while (start - this.bufferOffset >= this.buffers[0].length) {
        this.shiftBuffer();
      }

      var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);

      while (end - this.bufferOffset > this.buffers[0].length) {
        this.shiftBuffer();
        slice += this.buffers[0].slice(0, end - this.bufferOffset);
      }

      return slice;
    }
  }, {
    key: "shiftBuffer",
    value: function shiftBuffer() {
      this.bufferOffset += this.buffers[0].length;
      this.writeIndex--;
      this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */

  }, {
    key: "write",
    value: function write(chunk) {
      var _a, _b;

      if (this.ended) {
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
        return;
      }

      this.buffers.push(chunk);

      if (this.tokenizer.running) {
        this.tokenizer.write(chunk);
        this.writeIndex++;
      }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */

  }, {
    key: "end",
    value: function end(chunk) {
      var _a, _b;

      if (this.ended) {
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
        return;
      }

      if (chunk) this.write(chunk);
      this.ended = true;
      this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */

  }, {
    key: "pause",
    value: function pause() {
      this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */

  }, {
    key: "resume",
    value: function resume() {
      this.tokenizer.resume();

      while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      }

      if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */

  }, {
    key: "parseChunk",
    value: function parseChunk(chunk) {
      this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */

  }, {
    key: "done",
    value: function done(chunk) {
      this.end(chunk);
    }
  }]);

  return Parser$1;
}();
/** Types of elements found in htmlparser2's DOM */


var ElementType;

(function (ElementType) {
  /** Type for the root element of a document */
  ElementType["Root"] = "root";
  /** Type for Text */

  ElementType["Text"] = "text";
  /** Type for <? ... ?> */

  ElementType["Directive"] = "directive";
  /** Type for <!-- ... --> */

  ElementType["Comment"] = "comment";
  /** Type for <script> tags */

  ElementType["Script"] = "script";
  /** Type for <style> tags */

  ElementType["Style"] = "style";
  /** Type for Any tag */

  ElementType["Tag"] = "tag";
  /** Type for <![CDATA[ ... ]]> */

  ElementType["CDATA"] = "cdata";
  /** Type for <!doctype ...> */

  ElementType["Doctype"] = "doctype";
})(ElementType || (ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */


function isTag$1(elem) {
  return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
} // Exports for backwards compatibility

/** Type for the root element of a document */


var Root$2 = ElementType.Root;
/** Type for Text */

var Text$1 = ElementType.Text;
/** Type for <? ... ?> */

var Directive = ElementType.Directive;
/** Type for <!-- ... --> */

var Comment$2 = ElementType.Comment;
/** Type for <script> tags */

var Script = ElementType.Script;
/** Type for <style> tags */

var Style = ElementType.Style;
/** Type for Any tag */

var Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */

var CDATA$1 = ElementType.CDATA;
/** Type for <!doctype ...> */

var Doctype = ElementType.Doctype;
var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get ElementType() {
    return ElementType;
  },

  isTag: isTag$1,
  Root: Root$2,
  Text: Text$1,
  Directive: Directive,
  Comment: Comment$2,
  Script: Script,
  Style: Style,
  Tag: Tag,
  CDATA: CDATA$1,
  Doctype: Doctype
});
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */

var Node$1 = /*#__PURE__*/function () {
  function Node$1() {
    _classCallCheck2(this, Node$1);

    /** Parent of the node */
    this.parent = null;
    /** Previous sibling */

    this.prev = null;
    /** Next sibling */

    this.next = null;
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */

    this.startIndex = null;
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */

    this.endIndex = null;
  } // Read-write aliases for properties

  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */


  _createClass2(Node$1, [{
    key: "parentNode",
    get: function get() {
      return this.parent;
    },
    set: function set(parent) {
      this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */

  }, {
    key: "previousSibling",
    get: function get() {
      return this.prev;
    },
    set: function set(prev) {
      this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */

  }, {
    key: "nextSibling",
    get: function get() {
      return this.next;
    },
    set: function set(next) {
      this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */

  }, {
    key: "cloneNode",
    value: function cloneNode() {
      var recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return cloneNode$1(this, recursive);
    }
  }]);

  return Node$1;
}();
/**
 * A node that contains some data.
 */


var DataNode = /*#__PURE__*/function (_Node$) {
  _inherits2(DataNode, _Node$);

  var _super2 = _createSuper2(DataNode);

  /**
   * @param data The content of the data node
   */
  function DataNode(data) {
    var _this6;

    _classCallCheck2(this, DataNode);

    _this6 = _super2.call(this);
    _this6.data = data;
    return _this6;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */


  _createClass2(DataNode, [{
    key: "nodeValue",
    get: function get() {
      return this.data;
    },
    set: function set(data) {
      this.data = data;
    }
  }]);

  return DataNode;
}(Node$1);
/**
 * Text within the document.
 */


var Text = /*#__PURE__*/function (_DataNode) {
  _inherits2(Text, _DataNode);

  var _super3 = _createSuper2(Text);

  function Text() {
    var _this7;

    _classCallCheck2(this, Text);

    _this7 = _super3.apply(this, arguments);
    _this7.type = ElementType.Text;
    return _this7;
  }

  _createClass2(Text, [{
    key: "nodeType",
    get: function get() {
      return 3;
    }
  }]);

  return Text;
}(DataNode);
/**
 * Comments within the document.
 */


var Comment$1 = /*#__PURE__*/function (_DataNode2) {
  _inherits2(Comment$1, _DataNode2);

  var _super4 = _createSuper2(Comment$1);

  function Comment$1() {
    var _this8;

    _classCallCheck2(this, Comment$1);

    _this8 = _super4.apply(this, arguments);
    _this8.type = ElementType.Comment;
    return _this8;
  }

  _createClass2(Comment$1, [{
    key: "nodeType",
    get: function get() {
      return 8;
    }
  }]);

  return Comment$1;
}(DataNode);
/**
 * Processing instructions, including doc types.
 */


var ProcessingInstruction = /*#__PURE__*/function (_DataNode3) {
  _inherits2(ProcessingInstruction, _DataNode3);

  var _super5 = _createSuper2(ProcessingInstruction);

  function ProcessingInstruction(name, data) {
    var _this9;

    _classCallCheck2(this, ProcessingInstruction);

    _this9 = _super5.call(this, data);
    _this9.name = name;
    _this9.type = ElementType.Directive;
    return _this9;
  }

  _createClass2(ProcessingInstruction, [{
    key: "nodeType",
    get: function get() {
      return 1;
    }
  }]);

  return ProcessingInstruction;
}(DataNode);
/**
 * A `Node` that can have children.
 */


var NodeWithChildren = /*#__PURE__*/function (_Node$2) {
  _inherits2(NodeWithChildren, _Node$2);

  var _super6 = _createSuper2(NodeWithChildren);

  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  function NodeWithChildren(children) {
    var _this10;

    _classCallCheck2(this, NodeWithChildren);

    _this10 = _super6.call(this);
    _this10.children = children;
    return _this10;
  } // Aliases

  /** First child of the node. */


  _createClass2(NodeWithChildren, [{
    key: "firstChild",
    get: function get() {
      var _a;

      return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */

  }, {
    key: "lastChild",
    get: function get() {
      return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */

  }, {
    key: "childNodes",
    get: function get() {
      return this.children;
    },
    set: function set(children) {
      this.children = children;
    }
  }]);

  return NodeWithChildren;
}(Node$1);

var CDATA = /*#__PURE__*/function (_NodeWithChildren) {
  _inherits2(CDATA, _NodeWithChildren);

  var _super7 = _createSuper2(CDATA);

  function CDATA() {
    var _this11;

    _classCallCheck2(this, CDATA);

    _this11 = _super7.apply(this, arguments);
    _this11.type = ElementType.CDATA;
    return _this11;
  }

  _createClass2(CDATA, [{
    key: "nodeType",
    get: function get() {
      return 4;
    }
  }]);

  return CDATA;
}(NodeWithChildren);
/**
 * The root node of the document.
 */


var Document$1 = /*#__PURE__*/function (_NodeWithChildren2) {
  _inherits2(Document$1, _NodeWithChildren2);

  var _super8 = _createSuper2(Document$1);

  function Document$1() {
    var _this12;

    _classCallCheck2(this, Document$1);

    _this12 = _super8.apply(this, arguments);
    _this12.type = ElementType.Root;
    return _this12;
  }

  _createClass2(Document$1, [{
    key: "nodeType",
    get: function get() {
      return 9;
    }
  }]);

  return Document$1;
}(NodeWithChildren);
/**
 * An element within the DOM.
 */


var Element = /*#__PURE__*/function (_NodeWithChildren3) {
  _inherits2(Element, _NodeWithChildren3);

  var _super9 = _createSuper2(Element);

  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  function Element(name, attribs) {
    var _this13;

    var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag;

    _classCallCheck2(this, Element);

    _this13 = _super9.call(this, children);
    _this13.name = name;
    _this13.attribs = attribs;
    _this13.type = type;
    return _this13;
  }

  _createClass2(Element, [{
    key: "nodeType",
    get: function get() {
      return 1;
    } // DOM Level 1 aliases

    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */

  }, {
    key: "tagName",
    get: function get() {
      return this.name;
    },
    set: function set(name) {
      this.name = name;
    }
  }, {
    key: "attributes",
    get: function get() {
      var _this14 = this;

      return Object.keys(this.attribs).map(function (name) {
        var _a, _b;

        return {
          name: name,
          value: _this14.attribs[name],
          namespace: (_a = _this14["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
          prefix: (_b = _this14["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
        };
      });
    }
  }]);

  return Element;
}(NodeWithChildren);
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */


function isTag(node) {
  return isTag$1(node);
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */


function isCDATA(node) {
  return node.type === ElementType.CDATA;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */


function isText(node) {
  return node.type === ElementType.Text;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */


function isComment(node) {
  return node.type === ElementType.Comment;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */


function isDirective(node) {
  return node.type === ElementType.Directive;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */


function isDocument(node) {
  return node.type === ElementType.Root;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */


function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */


function cloneNode$1(node) {
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result;

  if (isText(node)) {
    result = new Text(node.data);
  } else if (isComment(node)) {
    result = new Comment$1(node.data);
  } else if (isTag(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone = new Element(node.name, _objectSpread({}, node.attribs), children);
    children.forEach(function (child) {
      return child.parent = clone;
    });

    if (node.namespace != null) {
      clone.namespace = node.namespace;
    }

    if (node["x-attribsNamespace"]) {
      clone["x-attribsNamespace"] = _objectSpread({}, node["x-attribsNamespace"]);
    }

    if (node["x-attribsPrefix"]) {
      clone["x-attribsPrefix"] = _objectSpread({}, node["x-attribsPrefix"]);
    }

    result = clone;
  } else if (isCDATA(node)) {
    var _children = recursive ? cloneChildren(node.children) : [];

    var _clone = new CDATA(_children);

    _children.forEach(function (child) {
      return child.parent = _clone;
    });

    result = _clone;
  } else if (isDocument(node)) {
    var _children2 = recursive ? cloneChildren(node.children) : [];

    var _clone2 = new Document$1(_children2);

    _children2.forEach(function (child) {
      return child.parent = _clone2;
    });

    if (node["x-mode"]) {
      _clone2["x-mode"] = node["x-mode"];
    }

    result = _clone2;
  } else if (isDirective(node)) {
    var instruction = new ProcessingInstruction(node.name, node.data);

    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }

    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node.type));
  }

  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;

  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }

  return result;
}

function cloneChildren(childs) {
  var children = childs.map(function (child) {
    return cloneNode$1(child, true);
  });

  for (var i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }

  return children;
} // Default options


var defaultOpts = {
  withStartIndices: false,
  withEndIndices: false,
  xmlMode: false
};

var DomHandler = /*#__PURE__*/function () {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  function DomHandler(callback, options, elementCB) {
    _classCallCheck2(this, DomHandler);

    /** The elements of the DOM */
    this.dom = [];
    /** The root element for the DOM */

    this.root = new Document$1(this.dom);
    /** Indicated whether parsing has been completed. */

    this.done = false;
    /** Stack of open tags. */

    this.tagStack = [this.root];
    /** A data node that is still being written to. */

    this.lastNode = null;
    /** Reference to the parser instance. Used for location information. */

    this.parser = null; // Make it possible to skip arguments, for backwards-compatibility

    if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }

    if (_typeof2(callback) === "object") {
      options = callback;
      callback = undefined;
    }

    this.callback = callback !== null && callback !== void 0 ? callback : null;
    this.options = options !== null && options !== void 0 ? options : defaultOpts;
    this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
  }

  _createClass2(DomHandler, [{
    key: "onparserinit",
    value: function onparserinit(parser) {
      this.parser = parser;
    } // Resets the handler back to starting state

  }, {
    key: "onreset",
    value: function onreset() {
      this.dom = [];
      this.root = new Document$1(this.dom);
      this.done = false;
      this.tagStack = [this.root];
      this.lastNode = null;
      this.parser = null;
    } // Signals the handler that parsing is done

  }, {
    key: "onend",
    value: function onend() {
      if (this.done) return;
      this.done = true;
      this.parser = null;
      this.handleCallback(null);
    }
  }, {
    key: "onerror",
    value: function onerror(error) {
      this.handleCallback(error);
    }
  }, {
    key: "onclosetag",
    value: function onclosetag() {
      this.lastNode = null;
      var elem = this.tagStack.pop();

      if (this.options.withEndIndices) {
        elem.endIndex = this.parser.endIndex;
      }

      if (this.elementCB) this.elementCB(elem);
    }
  }, {
    key: "onopentag",
    value: function onopentag(name, attribs) {
      var type = this.options.xmlMode ? ElementType.Tag : undefined;
      var element = new Element(name, attribs, undefined, type);
      this.addNode(element);
      this.tagStack.push(element);
    }
  }, {
    key: "ontext",
    value: function ontext(data) {
      var lastNode = this.lastNode;

      if (lastNode && lastNode.type === ElementType.Text) {
        lastNode.data += data;

        if (this.options.withEndIndices) {
          lastNode.endIndex = this.parser.endIndex;
        }
      } else {
        var _node = new Text(data);

        this.addNode(_node);
        this.lastNode = _node;
      }
    }
  }, {
    key: "oncomment",
    value: function oncomment(data) {
      if (this.lastNode && this.lastNode.type === ElementType.Comment) {
        this.lastNode.data += data;
        return;
      }

      var node = new Comment$1(data);
      this.addNode(node);
      this.lastNode = node;
    }
  }, {
    key: "oncommentend",
    value: function oncommentend() {
      this.lastNode = null;
    }
  }, {
    key: "oncdatastart",
    value: function oncdatastart() {
      var text = new Text("");
      var node = new CDATA([text]);
      this.addNode(node);
      text.parent = node;
      this.lastNode = text;
    }
  }, {
    key: "oncdataend",
    value: function oncdataend() {
      this.lastNode = null;
    }
  }, {
    key: "onprocessinginstruction",
    value: function onprocessinginstruction(name, data) {
      var node = new ProcessingInstruction(name, data);
      this.addNode(node);
    }
  }, {
    key: "handleCallback",
    value: function handleCallback(error) {
      if (typeof this.callback === "function") {
        this.callback(error, this.dom);
      } else if (error) {
        throw error;
      }
    }
  }, {
    key: "addNode",
    value: function addNode(node) {
      var parent = this.tagStack[this.tagStack.length - 1];
      var previousSibling = parent.children[parent.children.length - 1];

      if (this.options.withStartIndices) {
        node.startIndex = this.parser.startIndex;
      }

      if (this.options.withEndIndices) {
        node.endIndex = this.parser.endIndex;
      }

      parent.children.push(node);

      if (previousSibling) {
        node.prev = previousSibling;
        previousSibling.next = node;
      }

      node.parent = parent;
      this.lastNode = null;
    }
  }]);

  return DomHandler;
}();

var xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var xmlCodeMap = new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]); // For compatibility with node < 4, we wrap `codePointAt`

var getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function (str, index) {
  return str.codePointAt(index);
} : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
function (c, index) {
  return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */

function encodeXML(str) {
  var ret = "";
  var lastIdx = 0;
  var match;

  while ((match = xmlReplacer.exec(str)) !== null) {
    var i = match.index;
    var char = str.charCodeAt(i);
    var next = xmlCodeMap.get(char);

    if (next !== undefined) {
      ret += str.substring(lastIdx, i) + next;
      lastIdx = i + 1;
    } else {
      ret += "".concat(str.substring(lastIdx, i), "&#x").concat(getCodePoint(str, i).toString(16), ";"); // Increase by 1 if we have a surrogate pair

      lastIdx = xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
    }
  }

  return ret + str.substr(lastIdx);
}
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */


function getEscaper(regex, map) {
  return function escape(data) {
    var match;
    var lastIdx = 0;
    var result = "";

    while (match = regex.exec(data)) {
      if (lastIdx !== match.index) {
        result += data.substring(lastIdx, match.index);
      } // We know that this character will be in the map.


      result += map.get(match[0].charCodeAt(0)); // Every match will be of length 1

      lastIdx = match.index + 1;
    }

    return result + data.substring(lastIdx);
  };
}
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */


var escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */

var escapeText = getEscaper(/[&<>\u00A0]/g, new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
var elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function (val) {
  return [val.toLowerCase(), val];
}));
var attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function (val) {
  return [val.toLowerCase(), val];
}));
/*
 * Module dependencies
 */

var unencodedElements = new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);

function replaceQuotes(value) {
  return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */


function formatAttributes(attributes, opts) {
  var _a;

  if (!attributes) return;
  var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML : escapeAttribute;
  return Object.keys(attributes).map(function (key) {
    var _a, _b;

    var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";

    if (opts.xmlMode === "foreign") {
      /* Fix up mixed-case attribute names */
      key = (_b = attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
    }

    if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
      return key;
    }

    return "".concat(key, "=\"").concat(encode(value), "\"");
  }).join(" ");
}
/**
 * Self-enclosing tags
 */


var singleTag = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */

function render(node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var nodes = "length" in node ? node : [node];
  var output = "";

  for (var i = 0; i < nodes.length; i++) {
    output += renderNode(nodes[i], options);
  }

  return output;
}

function renderNode(node, options) {
  switch (node.type) {
    case Root$2:
      return render(node.children, options);
    // @ts-expect-error We don't use `Doctype` yet

    case Doctype:
    case Directive:
      return renderDirective(node);

    case Comment$2:
      return renderComment(node);

    case CDATA$1:
      return renderCdata(node);

    case Script:
    case Style:
    case Tag:
      return renderTag(node, options);

    case Text$1:
      return renderText(node, options);
  }
}

var foreignModeIntegrationPoints = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
var foreignElements = new Set(["svg", "math"]);

function renderTag(elem, opts) {
  var _a; // Handle SVG / MathML in HTML


  if (opts.xmlMode === "foreign") {
    /* Fix up mixed-case element names */
    elem.name = (_a = elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
    /* Exit foreign mode at integration points */

    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = _objectSpread(_objectSpread({}, opts), {}, {
        xmlMode: false
      });
    }
  }

  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = _objectSpread(_objectSpread({}, opts), {}, {
      xmlMode: "foreign"
    });
  }

  var tag = "<".concat(elem.name);
  var attribs = formatAttributes(elem.attribs, opts);

  if (attribs) {
    tag += " ".concat(attribs);
  }

  if (elem.children.length === 0 && (opts.xmlMode ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
  opts.selfClosingTags !== false : // User explicitly asked for self-closing tags, even in HTML mode
  opts.selfClosingTags && singleTag.has(elem.name))) {
    if (!opts.xmlMode) tag += " ";
    tag += "/>";
  } else {
    tag += ">";

    if (elem.children.length > 0) {
      tag += render(elem.children, opts);
    }

    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += "</".concat(elem.name, ">");
    }
  }

  return tag;
}

function renderDirective(elem) {
  return "<".concat(elem.data, ">");
}

function renderText(elem, opts) {
  var _a;

  var data = elem.data || ""; // If entities weren't decoded, no need to encode them back

  if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data = opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML(data) : escapeText(data);
  }

  return data;
}

function renderCdata(elem) {
  return "<![CDATA[".concat(elem.children[0].data, "]]>");
}

function renderComment(elem) {
  return "<!--".concat(elem.data, "-->");
}
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */


function getOuterHTML(node, options) {
  return render(node, options);
}
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */


function getInnerHTML(node, options) {
  return hasChildren(node) ? node.children.map(function (node) {
    return getOuterHTML(node, options);
  }).join("") : "";
}
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */


function getText(node) {
  if (Array.isArray(node)) return node.map(getText).join("");
  if (isTag(node)) return node.name === "br" ? "\n" : getText(node.children);
  if (isCDATA(node)) return getText(node.children);
  if (isText(node)) return node.data;
  return "";
}
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */


function textContent(node) {
  if (Array.isArray(node)) return node.map(textContent).join("");

  if (hasChildren(node) && !isComment(node)) {
    return textContent(node.children);
  }

  if (isText(node)) return node.data;
  return "";
}
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */


function innerText(node) {
  if (Array.isArray(node)) return node.map(innerText).join("");

  if (hasChildren(node) && (node.type === ElementType.Tag || isCDATA(node))) {
    return innerText(node.children);
  }

  if (isText(node)) return node.data;
  return "";
}
/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */


function getChildren(elem) {
  return hasChildren(elem) ? elem.children : [];
}
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */


function getParent(elem) {
  return elem.parent || null;
}
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */


function getSiblings(elem) {
  var parent = getParent(elem);
  if (parent != null) return getChildren(parent);
  var siblings = [elem];
  var prev = elem.prev,
      next = elem.next;

  while (prev != null) {
    siblings.unshift(prev);
    var _prev = prev;
    prev = _prev.prev;
  }

  while (next != null) {
    siblings.push(next);
    var _next = next;
    next = _next.next;
  }

  return siblings;
}
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */


function getAttributeValue(elem, name) {
  var _a;

  return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */


function hasAttrib(elem, name) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */


function getName(elem) {
  return elem.name;
}
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */


function nextElementSibling(elem) {
  var next = elem.next;

  while (next !== null && !isTag(next)) {
    var _next2 = next;
    next = _next2.next;
  }

  return next;
}
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */


function prevElementSibling(elem) {
  var prev = elem.prev;

  while (prev !== null && !isTag(prev)) {
    var _prev2 = prev;
    prev = _prev2.prev;
  }

  return prev;
}
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */


function removeElement(elem) {
  if (elem.prev) elem.prev.next = elem.next;
  if (elem.next) elem.next.prev = elem.prev;

  if (elem.parent) {
    var childs = elem.parent.children;
    var childsIndex = childs.lastIndexOf(elem);

    if (childsIndex >= 0) {
      childs.splice(childsIndex, 1);
    }
  }

  elem.next = null;
  elem.prev = null;
  elem.parent = null;
}
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */


function replaceElement(elem, replacement) {
  var prev = replacement.prev = elem.prev;

  if (prev) {
    prev.next = replacement;
  }

  var next = replacement.next = elem.next;

  if (next) {
    next.prev = replacement;
  }

  var parent = replacement.parent = elem.parent;

  if (parent) {
    var childs = parent.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */


function appendChild(parent, child) {
  removeElement(child);
  child.next = null;
  child.parent = parent;

  if (parent.children.push(child) > 1) {
    var sibling = parent.children[parent.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */


function append(elem, next) {
  removeElement(next);
  var parent = elem.parent;
  var currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent;

  if (currNext) {
    currNext.prev = next;

    if (parent) {
      var childs = parent.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent) {
    parent.children.push(next);
  }
}
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */


function prependChild(parent, child) {
  removeElement(child);
  child.parent = parent;
  child.prev = null;

  if (parent.children.unshift(child) !== 1) {
    var sibling = parent.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */


function prepend(elem, prev) {
  removeElement(prev);
  var parent = elem.parent;

  if (parent) {
    var childs = parent.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }

  if (elem.prev) {
    elem.prev.next = prev;
  }

  prev.parent = parent;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */


function filter$1(test, node) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  return find(test, Array.isArray(node) ? node : [node], recurse, limit);
}
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */


function find(test, nodes, recurse, limit) {
  var result = [];
  /** Stack of the arrays we are looking at. */

  var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
  /** Stack of the indices within the arrays. */

  var indexStack = [0];

  for (;;) {
    // First, check if the current array has any more elements to look at.
    if (indexStack[0] >= nodeStack[0].length) {
      // If we have no more arrays to look at, we are done.
      if (indexStack.length === 1) {
        return result;
      } // Otherwise, remove the current array from the stack.


      nodeStack.shift();
      indexStack.shift(); // Loop back to the start to continue with the next array.

      continue;
    }

    var elem = nodeStack[0][indexStack[0]++];

    if (test(elem)) {
      result.push(elem);
      if (--limit <= 0) return result;
    }

    if (recurse && hasChildren(elem) && elem.children.length > 0) {
      /*
       * Add the children to the stack. We are depth-first, so this is
       * the next array we look at.
       */
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */


function findOneChild(test, nodes) {
  return nodes.find(test);
}
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */


function findOne(test, nodes) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var searchedNodes = Array.isArray(nodes) ? nodes : [nodes];

  for (var i = 0; i < searchedNodes.length; i++) {
    var _node2 = searchedNodes[i];

    if (isTag(_node2) && test(_node2)) {
      return _node2;
    }

    if (recurse && hasChildren(_node2) && _node2.children.length > 0) {
      var found = findOne(test, _node2.children, true);
      if (found) return found;
    }
  }

  return null;
}
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */


function existsOne(test, nodes) {
  return (Array.isArray(nodes) ? nodes : [nodes]).some(function (node) {
    return isTag(node) && test(node) || hasChildren(node) && existsOne(test, node.children);
  });
}
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */


function findAll(test, nodes) {
  var result = [];
  var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
  var indexStack = [0];

  for (;;) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (nodeStack.length === 1) {
        return result;
      } // Otherwise, remove the current array from the stack.


      nodeStack.shift();
      indexStack.shift(); // Loop back to the start to continue with the next array.

      continue;
    }

    var elem = nodeStack[0][indexStack[0]++];
    if (isTag(elem) && test(elem)) result.push(elem);

    if (hasChildren(elem) && elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
/**
 * A map of functions to check nodes against.
 */


var Checks = {
  tag_name: function tag_name(name) {
    if (typeof name === "function") {
      return function (elem) {
        return isTag(elem) && name(elem.name);
      };
    } else if (name === "*") {
      return isTag;
    }

    return function (elem) {
      return isTag(elem) && elem.name === name;
    };
  },
  tag_type: function tag_type(type) {
    if (typeof type === "function") {
      return function (elem) {
        return type(elem.type);
      };
    }

    return function (elem) {
      return elem.type === type;
    };
  },
  tag_contains: function tag_contains(data) {
    if (typeof data === "function") {
      return function (elem) {
        return isText(elem) && data(elem.data);
      };
    }

    return function (elem) {
      return isText(elem) && elem.data === data;
    };
  }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */

function getAttribCheck(attrib, value) {
  if (typeof value === "function") {
    return function (elem) {
      return isTag(elem) && value(elem.attribs[attrib]);
    };
  }

  return function (elem) {
    return isTag(elem) && elem.attribs[attrib] === value;
  };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */


function combineFuncs(a, b) {
  return function (elem) {
    return a(elem) || b(elem);
  };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */


function compileTest(options) {
  var funcs = Object.keys(options).map(function (key) {
    var value = options[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */


function testElement(options, node) {
  var test = compileTest(options);
  return test ? test(node) : true;
}
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */


function getElements(options, nodes, recurse) {
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  var test = compileTest(options);
  return test ? filter$1(test, nodes, recurse, limit) : [];
}
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */


function getElementById(id, nodes) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!Array.isArray(nodes)) nodes = [nodes];
  return findOne(getAttribCheck("id", id), nodes, recurse);
}
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */


function getElementsByTagName(tagName, nodes) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  return filter$1(Checks["tag_name"](tagName), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `className`.
 *
 * @category Legacy Query Functions
 * @param className Class name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `className`.
 */


function getElementsByClassName(className, nodes) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  return filter$1(getAttribCheck("class", className), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */


function getElementsByTagType(type, nodes) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  return filter$1(Checks["tag_type"](type), nodes, recurse, limit);
}
/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */


function removeSubsets(nodes) {
  var idx = nodes.length;
  /*
   * Check if each node (or one of its ancestors) is already contained in the
   * array.
   */

  while (--idx >= 0) {
    var _node3 = nodes[idx];
    /*
     * Remove the node if it is not unique.
     * We are going through the array from the end, so we only
     * have to check nodes that preceed the node under consideration in the array.
     */

    if (idx > 0 && nodes.lastIndexOf(_node3, idx - 1) >= 0) {
      nodes.splice(idx, 1);
      continue;
    }

    for (var ancestor = _node3.parent; ancestor; ancestor = ancestor.parent) {
      if (nodes.includes(ancestor)) {
        nodes.splice(idx, 1);
        break;
      }
    }
  }

  return nodes;
}
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */


var DocumentPosition;

(function (DocumentPosition) {
  DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */


function compareDocumentPosition(nodeA, nodeB) {
  var aParents = [];
  var bParents = [];

  if (nodeA === nodeB) {
    return 0;
  }

  var current = hasChildren(nodeA) ? nodeA : nodeA.parent;

  while (current) {
    aParents.unshift(current);
    current = current.parent;
  }

  current = hasChildren(nodeB) ? nodeB : nodeB.parent;

  while (current) {
    bParents.unshift(current);
    current = current.parent;
  }

  var maxIdx = Math.min(aParents.length, bParents.length);
  var idx = 0;

  while (idx < maxIdx && aParents[idx] === bParents[idx]) {
    idx++;
  }

  if (idx === 0) {
    return DocumentPosition.DISCONNECTED;
  }

  var sharedParent = aParents[idx - 1];
  var siblings = sharedParent.children;
  var aSibling = aParents[idx];
  var bSibling = bParents[idx];

  if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
    if (sharedParent === nodeB) {
      return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
    }

    return DocumentPosition.FOLLOWING;
  }

  if (sharedParent === nodeA) {
    return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
  }

  return DocumentPosition.PRECEDING;
}
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */


function uniqueSort(nodes) {
  nodes = nodes.filter(function (node, i, arr) {
    return !arr.includes(node, i + 1);
  });
  nodes.sort(function (a, b) {
    var relative = compareDocumentPosition(a, b);

    if (relative & DocumentPosition.PRECEDING) {
      return -1;
    } else if (relative & DocumentPosition.FOLLOWING) {
      return 1;
    }

    return 0;
  });
  return nodes;
}
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */


function getFeed(doc) {
  var feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */


function getAtomFeed(feedRoot) {
  var _a;

  var childs = feedRoot.children;
  var feed = {
    type: "atom",
    items: getElementsByTagName("entry", childs).map(function (item) {
      var _a;

      var children = item.children;
      var entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "id", children);
      addConditionally(entry, "title", "title", children);
      var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];

      if (href) {
        entry.link = href;
      }

      var description = fetch("summary", children) || fetch("content", children);

      if (description) {
        entry.description = description;
      }

      var pubDate = fetch("updated", children);

      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }

      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];

  if (href) {
    feed.link = href;
  }

  addConditionally(feed, "description", "subtitle", childs);
  var updated = fetch("updated", childs);

  if (updated) {
    feed.updated = new Date(updated);
  }

  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */


function getRssFeed(feedRoot) {
  var _a, _b;

  var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
  var feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: getElementsByTagName("item", feedRoot.children).map(function (item) {
      var children = item.children;
      var entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "guid", children);
      addConditionally(entry, "title", "title", children);
      addConditionally(entry, "link", "link", children);
      addConditionally(entry, "description", "description", children);
      var pubDate = fetch("pubDate", children) || fetch("dc:date", children);
      if (pubDate) entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  var updated = fetch("lastBuildDate", childs);

  if (updated) {
    feed.updated = new Date(updated);
  }

  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}

var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */

function getMediaElements(where) {
  return getElementsByTagName("media:content", where).map(function (elem) {
    var attribs = elem.attribs;
    var media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };

    var _iterator = _createForOfIteratorHelper(MEDIA_KEYS_STRING),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attrib = _step.value;

        if (attribs[attrib]) {
          media[attrib] = attribs[attrib];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(MEDIA_KEYS_INT),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _attrib = _step2.value;

        if (attribs[_attrib]) {
          media[_attrib] = parseInt(attribs[_attrib], 10);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }

    return media;
  });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */


function getOneElement(tagName, node) {
  return getElementsByTagName(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */


function fetch(tagName, where) {
  var recurse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return textContent(getElementsByTagName(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */


function addConditionally(obj, prop, tagName, where) {
  var recurse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var val = fetch(tagName, where, recurse);
  if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */


function isValidFeed(value) {
  return value === "rss" || value === "feed" || value === "rdf:RDF";
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isTag: isTag,
  isCDATA: isCDATA,
  isText: isText,
  isComment: isComment,
  isDocument: isDocument,
  hasChildren: hasChildren,
  getOuterHTML: getOuterHTML,
  getInnerHTML: getInnerHTML,
  getText: getText,
  textContent: textContent,
  innerText: innerText,
  getChildren: getChildren,
  getParent: getParent,
  getSiblings: getSiblings,
  getAttributeValue: getAttributeValue,
  hasAttrib: hasAttrib,
  getName: getName,
  nextElementSibling: nextElementSibling,
  prevElementSibling: prevElementSibling,
  removeElement: removeElement,
  replaceElement: replaceElement,
  appendChild: appendChild,
  append: append,
  prependChild: prependChild,
  prepend: prepend,
  filter: filter$1,
  find: find,
  findOneChild: findOneChild,
  findOne: findOne,
  existsOne: existsOne,
  findAll: findAll,
  testElement: testElement,
  getElements: getElements,
  getElementById: getElementById,
  getElementsByTagName: getElementsByTagName,
  getElementsByClassName: getElementsByClassName,
  getElementsByTagType: getElementsByTagType,
  removeSubsets: removeSubsets,

  get DocumentPosition() {
    return DocumentPosition;
  },

  compareDocumentPosition: compareDocumentPosition,
  uniqueSort: uniqueSort,
  getFeed: getFeed
}); // Helper methods

/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */

function parseDocument(data, options) {
  var handler = new DomHandler(undefined, options);
  new Parser$1(handler, options).end(data);
  return handler.root;
}
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */


function parseDOM(data, options) {
  return parseDocument(data, options).children;
}
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 */


function createDomStream(callback, options, elementCallback) {
  var handler = new DomHandler(callback, options, elementCallback);
  return new Parser$1(handler, options);
}

var parseFeedDefaultOptions = {
  xmlMode: true
};
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
 */

function parseFeed(feed) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : parseFeedDefaultOptions;
  return getFeed(parseDOM(feed, options));
}

var esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parseDocument: parseDocument,
  parseDOM: parseDOM,
  createDomStream: createDomStream,
  parseFeed: parseFeed,
  Parser: Parser$1,
  DomHandler: DomHandler,
  DefaultHandler: DomHandler,
  Tokenizer: Tokenizer,
  ElementType: index$1,
  getFeed: getFeed,
  DomUtils: index
});

var escapeStringRegexp = function escapeStringRegexp(string) {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  } // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.


  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */


function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject$1(o) {
  var ctor, prot;
  if (isObject(o) === false) return false; // If has modified constructor

  ctor = o.constructor;
  if (ctor === undefined) return true; // If has modified prototype

  prot = ctor.prototype;
  if (isObject(prot) === false) return false; // If constructor does not have an Object-specific method

  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  } // Most likely a plain Object


  return true;
}

var isPlainObject$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isPlainObject: isPlainObject$1
});

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && _typeof2(value) === 'object';
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
} // Protects from prototype poisoning and unexpected merging up the prototype chain.


function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.

  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var parseSrcset = createCommonjsModule(function (module) {
  /**
   * Srcset Parser
   *
   * By Alex Bell |  MIT License
   *
   * JS Parser for the string value that appears in markup <img srcset="here">
   *
   * @returns Array [{url: _, d: _, w: _, h:_}, ...]
   *
   * Based super duper closely on the reference algorithm at:
   * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
   *
   * Most comments are copied in directly from the spec
   * (except for comments in parens).
   */
  (function (root, factory) {
    if (module.exports) {
      // Node. Does not work with strict CommonJS, but
      // only CommonJS-like environments that support module.exports,
      // like Node.
      module.exports = factory();
    } else {
      // Browser globals (root is window)
      root.parseSrcset = factory();
    }
  })(commonjsGlobal, function () {
    // 1. Let input be the value passed to this algorithm.
    return function (input) {
      // UTILITY FUNCTIONS
      // Manual is faster than RegEx
      // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
      // http://jsperf.com/whitespace-character/5
      function isSpace(c) {
        return c === " " || // space
        c === "\t" || // horizontal tab
        c === "\n" || // new line
        c === "\f" || // form feed
        c === "\r"; // carriage return
      }

      function collectCharacters(regEx) {
        var chars,
            match = regEx.exec(input.substring(pos));

        if (match) {
          chars = match[0];
          pos += chars.length;
          return chars;
        }
      }

      var inputLength = input.length,
          // (Don't use \s, to avoid matching non-breaking space)
      regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
          regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
          regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
          regexTrailingCommas = /[,]+$/,
          regexNonNegativeInteger = /^\d+$/,
          // ( Positive or negative or unsigned integers or decimals, without or without exponents.
      // Must include at least one digit.
      // According to spec tests any decimal point must be followed by a digit.
      // No leading plus sign is allowed.)
      // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
      regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
          url,
          descriptors,
          currentDescriptor,
          state,
          c,
          // 2. Let position be a pointer into input, initially pointing at the start
      //    of the string.
      pos = 0,
          // 3. Let candidates be an initially empty source set.
      candidates = []; // 4. Splitting loop: Collect a sequence of characters that are space
      //    characters or U+002C COMMA characters. If any U+002C COMMA characters
      //    were collected, that is a parse error.

      while (true) {
        collectCharacters(regexLeadingCommasOrSpaces); // 5. If position is past the end of input, return candidates and abort these steps.

        if (pos >= inputLength) {
          return candidates; // (we're done, this is the sole return path)
        } // 6. Collect a sequence of characters that are not space characters,
        //    and let that be url.


        url = collectCharacters(regexLeadingNotSpaces); // 7. Let descriptors be a new empty list.

        descriptors = []; // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
        //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
        //         more than one character, that is a parse error.

        if (url.slice(-1) === ",") {
          url = url.replace(regexTrailingCommas, ""); // (Jump ahead to step 9 to skip tokenization and just push the candidate).

          parseDescriptors(); //	Otherwise, follow these substeps:
        } else {
          tokenize();
        } // (close else of step 8)
        // 16. Return to the step labeled splitting loop.

      } // (Close of big while loop.)

      /**
       * Tokenizes descriptor properties prior to parsing
       * Returns undefined.
       */


      function tokenize() {
        // 8.1. Descriptor tokeniser: Skip whitespace
        collectCharacters(regexLeadingSpaces); // 8.2. Let current descriptor be the empty string.

        currentDescriptor = ""; // 8.3. Let state be in descriptor.

        state = "in descriptor";

        while (true) {
          // 8.4. Let c be the character at position.
          c = input.charAt(pos); //  Do the following depending on the value of state.
          //  For the purpose of this step, "EOF" is a special character representing
          //  that position is past the end of input.
          // In descriptor

          if (state === "in descriptor") {
            // Do the following, depending on the value of c:
            // Space character
            // If current descriptor is not empty, append current descriptor to
            // descriptors and let current descriptor be the empty string.
            // Set state to after descriptor.
            if (isSpace(c)) {
              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
                currentDescriptor = "";
                state = "after descriptor";
              } // U+002C COMMA (,)
              // Advance position to the next character in input. If current descriptor
              // is not empty, append current descriptor to descriptors. Jump to the step
              // labeled descriptor parser.

            } else if (c === ",") {
              pos += 1;

              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
              }

              parseDescriptors();
              return; // U+0028 LEFT PARENTHESIS (()
              // Append c to current descriptor. Set state to in parens.
            } else if (c === "(") {
              currentDescriptor = currentDescriptor + c;
              state = "in parens"; // EOF
              // If current descriptor is not empty, append current descriptor to
              // descriptors. Jump to the step labeled descriptor parser.
            } else if (c === "") {
              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
              }

              parseDescriptors();
              return; // Anything else
              // Append c to current descriptor.
            } else {
              currentDescriptor = currentDescriptor + c;
            } // (end "in descriptor"
            // In parens

          } else if (state === "in parens") {
            // U+0029 RIGHT PARENTHESIS ())
            // Append c to current descriptor. Set state to in descriptor.
            if (c === ")") {
              currentDescriptor = currentDescriptor + c;
              state = "in descriptor"; // EOF
              // Append current descriptor to descriptors. Jump to the step labeled
              // descriptor parser.
            } else if (c === "") {
              descriptors.push(currentDescriptor);
              parseDescriptors();
              return; // Anything else
              // Append c to current descriptor.
            } else {
              currentDescriptor = currentDescriptor + c;
            } // After descriptor

          } else if (state === "after descriptor") {
            // Do the following, depending on the value of c:
            // Space character: Stay in this state.
            if (isSpace(c)) ;else if (c === "") {
              parseDescriptors();
              return; // Anything else
              // Set state to in descriptor. Set position to the previous character in input.
            } else {
              state = "in descriptor";
              pos -= 1;
            }
          } // Advance position to the next character in input.


          pos += 1; // Repeat this step.
        } // (close while true loop)

      }
      /**
       * Adds descriptor properties to a candidate, pushes to the candidates array
       * @return undefined
       */
      // Declared outside of the while loop so that it's only created once.


      function parseDescriptors() {
        // 9. Descriptor parser: Let error be no.
        var pError = false,
            // 10. Let width be absent.
        // 11. Let density be absent.
        // 12. Let future-compat-h be absent. (We're implementing it now as h)
        w,
            d,
            h,
            i,
            candidate = {},
            desc,
            lastChar,
            value,
            intVal,
            floatVal; // 13. For each descriptor in descriptors, run the appropriate set of steps
        // from the following list:

        for (i = 0; i < descriptors.length; i++) {
          desc = descriptors[i];
          lastChar = desc[desc.length - 1];
          value = desc.substring(0, desc.length - 1);
          intVal = parseInt(value, 10);
          floatVal = parseFloat(value); // If the descriptor consists of a valid non-negative integer followed by
          // a U+0077 LATIN SMALL LETTER W character

          if (regexNonNegativeInteger.test(value) && lastChar === "w") {
            // If width and density are not both absent, then let error be yes.
            if (w || d) {
              pError = true;
            } // Apply the rules for parsing non-negative integers to the descriptor.
            // If the result is zero, let error be yes.
            // Otherwise, let width be the result.


            if (intVal === 0) {
              pError = true;
            } else {
              w = intVal;
            } // If the descriptor consists of a valid floating-point number followed by
            // a U+0078 LATIN SMALL LETTER X character

          } else if (regexFloatingPoint.test(value) && lastChar === "x") {
            // If width, density and future-compat-h are not all absent, then let error
            // be yes.
            if (w || d || h) {
              pError = true;
            } // Apply the rules for parsing floating-point number values to the descriptor.
            // If the result is less than zero, let error be yes. Otherwise, let density
            // be the result.


            if (floatVal < 0) {
              pError = true;
            } else {
              d = floatVal;
            } // If the descriptor consists of a valid non-negative integer followed by
            // a U+0068 LATIN SMALL LETTER H character

          } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
            // If height and density are not both absent, then let error be yes.
            if (h || d) {
              pError = true;
            } // Apply the rules for parsing non-negative integers to the descriptor.
            // If the result is zero, let error be yes. Otherwise, let future-compat-h
            // be the result.


            if (intVal === 0) {
              pError = true;
            } else {
              h = intVal;
            } // Anything else, Let error be yes.

          } else {
            pError = true;
          }
        } // (close step 13 for loop)
        // 15. If error is still no, then append a new image source to candidates whose
        // URL is url, associated with a width width if not absent and a pixel
        // density density if not absent. Otherwise, there is a parse error.


        if (!pError) {
          candidate.url = url;

          if (w) {
            candidate.w = w;
          }

          if (d) {
            candidate.d = d;
          }

          if (h) {
            candidate.h = h;
          }

          candidates.push(candidate);
        } else if (console && console.log) {
          console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        }
      } // (close parseDescriptors fn)

    };
  });
});
var p = process || {},
    argv = p.argv || [],
    env = p.env || {};
var isColorSupported = !(!!env.NO_COLOR || argv.includes("--no-color")) && (!!env.FORCE_COLOR || argv.includes("--color") || p.platform === "win32" || (p.stdout || {}).isTTY && env.TERM !== "dumb" || !!env.CI);

var formatter = function formatter(open, close) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : open;
  return function (input) {
    var string = "" + input,
        index = string.indexOf(close, open.length);
    return ~index ? open + replaceClose(string, close, replace, index) + close : open + string + close;
  };
};

var replaceClose = function replaceClose(string, close, replace, index) {
  var result = "",
      cursor = 0;

  do {
    result += string.substring(cursor, index) + replace;
    cursor = index + close.length;
    index = string.indexOf(close, cursor);
  } while (~index);

  return result + string.substring(cursor);
};

var createColors = function createColors() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isColorSupported;
  var f = enabled ? formatter : function () {
    return String;
  };
  return {
    isColorSupported: enabled,
    reset: f("\x1b[0m", "\x1b[0m"),
    bold: f("\x1b[1m", "\x1b[22m", "\x1b[22m\x1b[1m"),
    dim: f("\x1b[2m", "\x1b[22m", "\x1b[22m\x1b[2m"),
    italic: f("\x1b[3m", "\x1b[23m"),
    underline: f("\x1b[4m", "\x1b[24m"),
    inverse: f("\x1b[7m", "\x1b[27m"),
    hidden: f("\x1b[8m", "\x1b[28m"),
    strikethrough: f("\x1b[9m", "\x1b[29m"),
    black: f("\x1b[30m", "\x1b[39m"),
    red: f("\x1b[31m", "\x1b[39m"),
    green: f("\x1b[32m", "\x1b[39m"),
    yellow: f("\x1b[33m", "\x1b[39m"),
    blue: f("\x1b[34m", "\x1b[39m"),
    magenta: f("\x1b[35m", "\x1b[39m"),
    cyan: f("\x1b[36m", "\x1b[39m"),
    white: f("\x1b[37m", "\x1b[39m"),
    gray: f("\x1b[90m", "\x1b[39m"),
    bgBlack: f("\x1b[40m", "\x1b[49m"),
    bgRed: f("\x1b[41m", "\x1b[49m"),
    bgGreen: f("\x1b[42m", "\x1b[49m"),
    bgYellow: f("\x1b[43m", "\x1b[49m"),
    bgBlue: f("\x1b[44m", "\x1b[49m"),
    bgMagenta: f("\x1b[45m", "\x1b[49m"),
    bgCyan: f("\x1b[46m", "\x1b[49m"),
    bgWhite: f("\x1b[47m", "\x1b[49m"),
    blackBright: f("\x1b[90m", "\x1b[39m"),
    redBright: f("\x1b[91m", "\x1b[39m"),
    greenBright: f("\x1b[92m", "\x1b[39m"),
    yellowBright: f("\x1b[93m", "\x1b[39m"),
    blueBright: f("\x1b[94m", "\x1b[39m"),
    magentaBright: f("\x1b[95m", "\x1b[39m"),
    cyanBright: f("\x1b[96m", "\x1b[39m"),
    whiteBright: f("\x1b[97m", "\x1b[39m"),
    bgBlackBright: f("\x1b[100m", "\x1b[49m"),
    bgRedBright: f("\x1b[101m", "\x1b[49m"),
    bgGreenBright: f("\x1b[102m", "\x1b[49m"),
    bgYellowBright: f("\x1b[103m", "\x1b[49m"),
    bgBlueBright: f("\x1b[104m", "\x1b[49m"),
    bgMagentaBright: f("\x1b[105m", "\x1b[49m"),
    bgCyanBright: f("\x1b[106m", "\x1b[49m"),
    bgWhiteBright: f("\x1b[107m", "\x1b[49m")
  };
};

var picocolors = createColors();
var createColors_1 = createColors;
picocolors.createColors = createColors_1;
var SINGLE_QUOTE = "'".charCodeAt(0);
var DOUBLE_QUOTE = '"'.charCodeAt(0);
var BACKSLASH = '\\'.charCodeAt(0);
var SLASH = '/'.charCodeAt(0);
var NEWLINE = '\n'.charCodeAt(0);
var SPACE = ' '.charCodeAt(0);
var FEED = '\f'.charCodeAt(0);
var TAB = '\t'.charCodeAt(0);
var CR = '\r'.charCodeAt(0);
var OPEN_SQUARE = '['.charCodeAt(0);
var CLOSE_SQUARE = ']'.charCodeAt(0);
var OPEN_PARENTHESES = '('.charCodeAt(0);
var CLOSE_PARENTHESES = ')'.charCodeAt(0);
var OPEN_CURLY = '{'.charCodeAt(0);
var CLOSE_CURLY = '}'.charCodeAt(0);
var SEMICOLON = ';'.charCodeAt(0);
var ASTERISK = '*'.charCodeAt(0);
var COLON = ':'.charCodeAt(0);
var AT = '@'.charCodeAt(0);
var RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var RE_HEX_ESCAPE = /[\da-f]/i;

var tokenize = function tokenizer(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var css = input.css.valueOf();
  var ignore = options.ignoreErrors;
  var code, content, escape, next, quote;
  var currentToken, escaped, escapePos, n, prev;
  var length = css.length;
  var pos = 0;
  var buffer = [];
  var returned = [];

  function position() {
    return pos;
  }

  function unclosed(what) {
    throw input.error('Unclosed ' + what, pos);
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop();
    if (pos >= length) return;
    var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css.charCodeAt(pos);

    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED:
        {
          next = pos;

          do {
            next += 1;
            code = css.charCodeAt(next);
          } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);

          currentToken = ['space', css.slice(pos, next)];
          pos = next - 1;
          break;
        }

      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES:
        {
          var controlChar = String.fromCharCode(code);
          currentToken = [controlChar, controlChar, pos];
          break;
        }

      case OPEN_PARENTHESES:
        {
          prev = buffer.length ? buffer.pop()[1] : '';
          n = css.charCodeAt(pos + 1);

          if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
            next = pos;

            do {
              escaped = false;
              next = css.indexOf(')', next + 1);

              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos;
                  break;
                } else {
                  unclosed('bracket');
                }
              }

              escapePos = next;

              while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);

            currentToken = ['brackets', css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            next = css.indexOf(')', pos + 1);
            content = css.slice(pos, next + 1);

            if (next === -1 || RE_BAD_BRACKET.test(content)) {
              currentToken = ['(', '(', pos];
            } else {
              currentToken = ['brackets', content, pos, next];
              pos = next;
            }
          }

          break;
        }

      case SINGLE_QUOTE:
      case DOUBLE_QUOTE:
        {
          quote = code === SINGLE_QUOTE ? "'" : '"';
          next = pos;

          do {
            escaped = false;
            next = css.indexOf(quote, next + 1);

            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos + 1;
                break;
              } else {
                unclosed('string');
              }
            }

            escapePos = next;

            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);

          currentToken = ['string', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case AT:
        {
          RE_AT_END.lastIndex = pos + 1;
          RE_AT_END.test(css);

          if (RE_AT_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_AT_END.lastIndex - 2;
          }

          currentToken = ['at-word', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case BACKSLASH:
        {
          next = pos;
          escape = true;

          while (css.charCodeAt(next + 1) === BACKSLASH) {
            next += 1;
            escape = !escape;
          }

          code = css.charCodeAt(next + 1);

          if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
            next += 1;

            if (RE_HEX_ESCAPE.test(css.charAt(next))) {
              while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
                next += 1;
              }

              if (css.charCodeAt(next + 1) === SPACE) {
                next += 1;
              }
            }
          }

          currentToken = ['word', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      default:
        {
          if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
            next = css.indexOf('*/', pos + 2) + 1;

            if (next === 0) {
              if (ignore || ignoreUnclosed) {
                next = css.length;
              } else {
                unclosed('comment');
              }
            }

            currentToken = ['comment', css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            RE_WORD_END.lastIndex = pos + 1;
            RE_WORD_END.test(css);

            if (RE_WORD_END.lastIndex === 0) {
              next = css.length - 1;
            } else {
              next = RE_WORD_END.lastIndex - 2;
            }

            currentToken = ['word', css.slice(pos, next + 1), pos, next];
            buffer.push(currentToken);
            pos = next;
          }

          break;
        }
    }

    pos++;
    return currentToken;
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back: back,
    endOfFile: endOfFile,
    nextToken: nextToken,
    position: position
  };
};

var Input$1;

function registerInput(dependant) {
  Input$1 = dependant;
}

var HIGHLIGHT_THEME = {
  ';': picocolors.yellow,
  ':': picocolors.yellow,
  '(': picocolors.cyan,
  ')': picocolors.cyan,
  '[': picocolors.yellow,
  ']': picocolors.yellow,
  '{': picocolors.yellow,
  '}': picocolors.yellow,
  'at-word': picocolors.cyan,
  'brackets': picocolors.cyan,
  'call': picocolors.cyan,
  'class': picocolors.yellow,
  'comment': picocolors.gray,
  'hash': picocolors.magenta,
  'string': picocolors.green
};

function getTokenType(_ref4, processor) {
  var _ref5 = _slicedToArray2(_ref4, 2),
      type = _ref5[0],
      value = _ref5[1];

  if (type === 'word') {
    if (value[0] === '.') {
      return 'class';
    }

    if (value[0] === '#') {
      return 'hash';
    }
  }

  if (!processor.endOfFile()) {
    var next = processor.nextToken();
    processor.back(next);
    if (next[0] === 'brackets' || next[0] === '(') return 'call';
  }

  return type;
}

function terminalHighlight(css) {
  var processor = tokenize(new Input$1(css), {
    ignoreErrors: true
  });
  var result = '';

  var _loop = function _loop() {
    var token = processor.nextToken();
    var color = HIGHLIGHT_THEME[getTokenType(token, processor)];

    if (color) {
      result += token[1].split(/\r?\n/).map(function (i) {
        return color(i);
      }).join('\n');
    } else {
      result += token[1];
    }
  };

  while (!processor.endOfFile()) {
    _loop();
  }

  return result;
}

terminalHighlight.registerInput = registerInput;
var terminalHighlight_1 = terminalHighlight;

var CssSyntaxError = /*#__PURE__*/function (_Error) {
  _inherits2(CssSyntaxError, _Error);

  var _super10 = _createSuper2(CssSyntaxError);

  function CssSyntaxError(message, line, column, source, file, plugin) {
    var _this15;

    _classCallCheck2(this, CssSyntaxError);

    _this15 = _super10.call(this, message);
    _this15.name = 'CssSyntaxError';
    _this15.reason = message;

    if (file) {
      _this15.file = file;
    }

    if (source) {
      _this15.source = source;
    }

    if (plugin) {
      _this15.plugin = plugin;
    }

    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
      if (typeof line === 'number') {
        _this15.line = line;
        _this15.column = column;
      } else {
        _this15.line = line.line;
        _this15.column = line.column;
        _this15.endLine = column.line;
        _this15.endColumn = column.column;
      }
    }

    _this15.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized2(_this15), CssSyntaxError);
    }

    return _this15;
  }

  _createClass2(CssSyntaxError, [{
    key: "setMessage",
    value: function setMessage() {
      this.message = this.plugin ? this.plugin + ': ' : '';
      this.message += this.file ? this.file : '<css input>';

      if (typeof this.line !== 'undefined') {
        this.message += ':' + this.line + ':' + this.column;
      }

      this.message += ': ' + this.reason;
    }
  }, {
    key: "showSourceCode",
    value: function showSourceCode(color) {
      var _this16 = this;

      if (!this.source) return '';
      var css = this.source;
      if (color == null) color = picocolors.isColorSupported;

      var aside = function aside(text) {
        return text;
      };

      var mark = function mark(text) {
        return text;
      };

      var highlight = function highlight(text) {
        return text;
      };

      if (color) {
        var _picocolors$createCol = picocolors.createColors(true),
            bold = _picocolors$createCol.bold,
            gray = _picocolors$createCol.gray,
            red = _picocolors$createCol.red;

        mark = function mark(text) {
          return bold(red(text));
        };

        aside = function aside(text) {
          return gray(text);
        };

        if (terminalHighlight_1) {
          highlight = function highlight(text) {
            return terminalHighlight_1(text);
          };
        }
      }

      var lines = css.split(/\r?\n/);
      var start = Math.max(this.line - 3, 0);
      var end = Math.min(this.line + 2, lines.length);
      var maxWidth = String(end).length;
      return lines.slice(start, end).map(function (line, index) {
        var number = start + 1 + index;
        var gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';

        if (number === _this16.line) {
          if (line.length > 160) {
            var padding = 20;
            var subLineStart = Math.max(0, _this16.column - padding);
            var subLineEnd = Math.max(_this16.column + padding, _this16.endColumn + padding);
            var subLine = line.slice(subLineStart, subLineEnd);

            var _spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, Math.min(_this16.column - 1, padding - 1)).replace(/[^\t]/g, ' ');

            return mark('>') + aside(gutter) + highlight(subLine) + '\n ' + _spacing + mark('^');
          }

          var spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, _this16.column - 1).replace(/[^\t]/g, ' ');
          return mark('>') + aside(gutter) + highlight(line) + '\n ' + spacing + mark('^');
        }

        return ' ' + aside(gutter) + highlight(line);
      }).join('\n');
    }
  }, {
    key: "toString",
    value: function toString() {
      var code = this.showSourceCode();

      if (code) {
        code = '\n\n' + code + '\n';
      }

      return this.name + ': ' + this.message + code;
    }
  }]);

  return CssSyntaxError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var cssSyntaxError = CssSyntaxError;
CssSyntaxError.default = CssSyntaxError;
var DEFAULT_RAW = {
  after: '\n',
  beforeClose: '\n',
  beforeComment: '\n',
  beforeDecl: '\n',
  beforeOpen: ' ',
  beforeRule: '\n',
  colon: ': ',
  commentLeft: ' ',
  commentRight: ' ',
  emptyBody: '',
  indent: '    ',
  semicolon: false
};

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

var Stringifier = /*#__PURE__*/function () {
  function Stringifier(builder) {
    _classCallCheck2(this, Stringifier);

    this.builder = builder;
  }

  _createClass2(Stringifier, [{
    key: "atrule",
    value: function atrule(node, semicolon) {
      var name = '@' + node.name;
      var params = node.params ? this.rawValue(node, 'params') : '';

      if (typeof node.raws.afterName !== 'undefined') {
        name += node.raws.afterName;
      } else if (params) {
        name += ' ';
      }

      if (node.nodes) {
        this.block(node, name + params);
      } else {
        var end = (node.raws.between || '') + (semicolon ? ';' : '');
        this.builder(name + params + end, node);
      }
    }
  }, {
    key: "beforeAfter",
    value: function beforeAfter(node, detect) {
      var value;

      if (node.type === 'decl') {
        value = this.raw(node, null, 'beforeDecl');
      } else if (node.type === 'comment') {
        value = this.raw(node, null, 'beforeComment');
      } else if (detect === 'before') {
        value = this.raw(node, null, 'beforeRule');
      } else {
        value = this.raw(node, null, 'beforeClose');
      }

      var buf = node.parent;
      var depth = 0;

      while (buf && buf.type !== 'root') {
        depth += 1;
        buf = buf.parent;
      }

      if (value.includes('\n')) {
        var indent = this.raw(node, null, 'indent');

        if (indent.length) {
          for (var step = 0; step < depth; step++) {
            value += indent;
          }
        }
      }

      return value;
    }
  }, {
    key: "block",
    value: function block(node, start) {
      var between = this.raw(node, 'between', 'beforeOpen');
      this.builder(start + between + '{', node, 'start');
      var after;

      if (node.nodes && node.nodes.length) {
        this.body(node);
        after = this.raw(node, 'after');
      } else {
        after = this.raw(node, 'after', 'emptyBody');
      }

      if (after) this.builder(after);
      this.builder('}', node, 'end');
    }
  }, {
    key: "body",
    value: function body(node) {
      var last = node.nodes.length - 1;

      while (last > 0) {
        if (node.nodes[last].type !== 'comment') break;
        last -= 1;
      }

      var semicolon = this.raw(node, 'semicolon');

      for (var i = 0; i < node.nodes.length; i++) {
        var child = node.nodes[i];
        var before = this.raw(child, 'before');
        if (before) this.builder(before);
        this.stringify(child, last !== i || semicolon);
      }
    }
  }, {
    key: "comment",
    value: function comment(node) {
      var left = this.raw(node, 'left', 'commentLeft');
      var right = this.raw(node, 'right', 'commentRight');
      this.builder('/*' + left + node.text + right + '*/', node);
    }
  }, {
    key: "decl",
    value: function decl(node, semicolon) {
      var between = this.raw(node, 'between', 'colon');
      var string = node.prop + between + this.rawValue(node, 'value');

      if (node.important) {
        string += node.raws.important || ' !important';
      }

      if (semicolon) string += ';';
      this.builder(string, node);
    }
  }, {
    key: "document",
    value: function document(node) {
      this.body(node);
    }
  }, {
    key: "raw",
    value: function raw(node, own, detect) {
      var value;
      if (!detect) detect = own; // Already had

      if (own) {
        value = node.raws[own];
        if (typeof value !== 'undefined') return value;
      }

      var parent = node.parent;

      if (detect === 'before') {
        // Hack for first rule in CSS
        if (!parent || parent.type === 'root' && parent.first === node) {
          return '';
        } // `root` nodes in `document` should use only their own raws


        if (parent && parent.type === 'document') {
          return '';
        }
      } // Floating child without parent


      if (!parent) return DEFAULT_RAW[detect]; // Detect style by other nodes

      var root = node.root();
      if (!root.rawCache) root.rawCache = {};

      if (typeof root.rawCache[detect] !== 'undefined') {
        return root.rawCache[detect];
      }

      if (detect === 'before' || detect === 'after') {
        return this.beforeAfter(node, detect);
      } else {
        var method = 'raw' + capitalize(detect);

        if (this[method]) {
          value = this[method](root, node);
        } else {
          root.walk(function (i) {
            value = i.raws[own];
            if (typeof value !== 'undefined') return false;
          });
        }
      }

      if (typeof value === 'undefined') value = DEFAULT_RAW[detect];
      root.rawCache[detect] = value;
      return value;
    }
  }, {
    key: "rawBeforeClose",
    value: function rawBeforeClose(root) {
      var value;
      root.walk(function (i) {
        if (i.nodes && i.nodes.length > 0) {
          if (typeof i.raws.after !== 'undefined') {
            value = i.raws.after;

            if (value.includes('\n')) {
              value = value.replace(/[^\n]+$/, '');
            }

            return false;
          }
        }
      });
      if (value) value = value.replace(/\S/g, '');
      return value;
    }
  }, {
    key: "rawBeforeComment",
    value: function rawBeforeComment(root, node) {
      var value;
      root.walkComments(function (i) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;

          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }

          return false;
        }
      });

      if (typeof value === 'undefined') {
        value = this.raw(node, null, 'beforeDecl');
      } else if (value) {
        value = value.replace(/\S/g, '');
      }

      return value;
    }
  }, {
    key: "rawBeforeDecl",
    value: function rawBeforeDecl(root, node) {
      var value;
      root.walkDecls(function (i) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;

          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }

          return false;
        }
      });

      if (typeof value === 'undefined') {
        value = this.raw(node, null, 'beforeRule');
      } else if (value) {
        value = value.replace(/\S/g, '');
      }

      return value;
    }
  }, {
    key: "rawBeforeOpen",
    value: function rawBeforeOpen(root) {
      var value;
      root.walk(function (i) {
        if (i.type !== 'decl') {
          value = i.raws.between;
          if (typeof value !== 'undefined') return false;
        }
      });
      return value;
    }
  }, {
    key: "rawBeforeRule",
    value: function rawBeforeRule(root) {
      var value;
      root.walk(function (i) {
        if (i.nodes && (i.parent !== root || root.first !== i)) {
          if (typeof i.raws.before !== 'undefined') {
            value = i.raws.before;

            if (value.includes('\n')) {
              value = value.replace(/[^\n]+$/, '');
            }

            return false;
          }
        }
      });
      if (value) value = value.replace(/\S/g, '');
      return value;
    }
  }, {
    key: "rawColon",
    value: function rawColon(root) {
      var value;
      root.walkDecls(function (i) {
        if (typeof i.raws.between !== 'undefined') {
          value = i.raws.between.replace(/[^\s:]/g, '');
          return false;
        }
      });
      return value;
    }
  }, {
    key: "rawEmptyBody",
    value: function rawEmptyBody(root) {
      var value;
      root.walk(function (i) {
        if (i.nodes && i.nodes.length === 0) {
          value = i.raws.after;
          if (typeof value !== 'undefined') return false;
        }
      });
      return value;
    }
  }, {
    key: "rawIndent",
    value: function rawIndent(root) {
      if (root.raws.indent) return root.raws.indent;
      var value;
      root.walk(function (i) {
        var p = i.parent;

        if (p && p !== root && p.parent && p.parent === root) {
          if (typeof i.raws.before !== 'undefined') {
            var parts = i.raws.before.split('\n');
            value = parts[parts.length - 1];
            value = value.replace(/\S/g, '');
            return false;
          }
        }
      });
      return value;
    }
  }, {
    key: "rawSemicolon",
    value: function rawSemicolon(root) {
      var value;
      root.walk(function (i) {
        if (i.nodes && i.nodes.length && i.last.type === 'decl') {
          value = i.raws.semicolon;
          if (typeof value !== 'undefined') return false;
        }
      });
      return value;
    }
  }, {
    key: "rawValue",
    value: function rawValue(node, prop) {
      var value = node[prop];
      var raw = node.raws[prop];

      if (raw && raw.value === value) {
        return raw.raw;
      }

      return value;
    }
  }, {
    key: "root",
    value: function root(node) {
      this.body(node);
      if (node.raws.after) this.builder(node.raws.after);
    }
  }, {
    key: "rule",
    value: function rule(node) {
      this.block(node, this.rawValue(node, 'selector'));

      if (node.raws.ownSemicolon) {
        this.builder(node.raws.ownSemicolon, node, 'end');
      }
    }
  }, {
    key: "stringify",
    value: function stringify(node, semicolon) {
      /* c8 ignore start */
      if (!this[node.type]) {
        throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
      }
      /* c8 ignore stop */


      this[node.type](node, semicolon);
    }
  }]);

  return Stringifier;
}();

var stringifier = Stringifier;
Stringifier.default = Stringifier;

function stringify(node, builder) {
  var str = new stringifier(builder);
  str.stringify(node);
}

var stringify_1 = stringify;
stringify.default = stringify;
var isClean$3 = Symbol('isClean');
var my$3 = Symbol('my');
var symbols = {
  isClean: isClean$3,
  my: my$3
};
var isClean$2 = symbols.isClean,
    my$2 = symbols.my;

function cloneNode(obj, parent) {
  var cloned = new obj.constructor();

  for (var i in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      /* c8 ignore next 2 */
      continue;
    }

    if (i === 'proxyCache') continue;
    var value = obj[i];

    var type = _typeof2(value);

    if (i === 'parent' && type === 'object') {
      if (parent) cloned[i] = parent;
    } else if (i === 'source') {
      cloned[i] = value;
    } else if (Array.isArray(value)) {
      cloned[i] = value.map(function (j) {
        return cloneNode(j, cloned);
      });
    } else {
      if (type === 'object' && value !== null) value = cloneNode(value);
      cloned[i] = value;
    }
  }

  return cloned;
}

function sourceOffset(inputCSS, position) {
  // Not all custom syntaxes support `offset` in `source.start` and `source.end`
  if (position && typeof position.offset !== 'undefined') {
    return position.offset;
  }

  var column = 1;
  var line = 1;
  var offset = 0;

  for (var i = 0; i < inputCSS.length; i++) {
    if (line === position.line && column === position.column) {
      offset = i;
      break;
    }

    if (inputCSS[i] === '\n') {
      column = 1;
      line += 1;
    } else {
      column += 1;
    }
  }

  return offset;
}

var Node = /*#__PURE__*/function () {
  function Node() {
    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck2(this, Node);

    this.raws = {};
    this[isClean$2] = false;
    this[my$2] = true;

    for (var _name in defaults) {
      if (_name === 'nodes') {
        this.nodes = [];

        var _iterator3 = _createForOfIteratorHelper(defaults[_name]),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _node4 = _step3.value;

            if (typeof _node4.clone === 'function') {
              this.append(_node4.clone());
            } else {
              this.append(_node4);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else {
        this[_name] = defaults[_name];
      }
    }
  }

  _createClass2(Node, [{
    key: "proxyOf",
    get: function get() {
      return this;
    }
  }, {
    key: "addToError",
    value: function addToError(error) {
      error.postcssNode = this;

      if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
        var s = this.source;
        error.stack = error.stack.replace(/\n\s{4}at /, "$&".concat(s.input.from, ":").concat(s.start.line, ":").concat(s.start.column, "$&"));
      }

      return error;
    }
  }, {
    key: "after",
    value: function after(add) {
      this.parent.insertAfter(this, add);
      return this;
    }
  }, {
    key: "assign",
    value: function assign() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _name2 in overrides) {
        this[_name2] = overrides[_name2];
      }

      return this;
    }
  }, {
    key: "before",
    value: function before(add) {
      this.parent.insertBefore(this, add);
      return this;
    }
  }, {
    key: "cleanRaws",
    value: function cleanRaws(keepBetween) {
      delete this.raws.before;
      delete this.raws.after;
      if (!keepBetween) delete this.raws.between;
    }
  }, {
    key: "clone",
    value: function clone() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cloned = cloneNode(this);

      for (var _name3 in overrides) {
        cloned[_name3] = overrides[_name3];
      }

      return cloned;
    }
  }, {
    key: "cloneAfter",
    value: function cloneAfter() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cloned = this.clone(overrides);
      this.parent.insertAfter(this, cloned);
      return cloned;
    }
  }, {
    key: "cloneBefore",
    value: function cloneBefore() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cloned = this.clone(overrides);
      this.parent.insertBefore(this, cloned);
      return cloned;
    }
  }, {
    key: "error",
    value: function error(message) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.source) {
        var _this$rangeBy = this.rangeBy(opts),
            end = _this$rangeBy.end,
            start = _this$rangeBy.start;

        return this.source.input.error(message, {
          column: start.column,
          line: start.line
        }, {
          column: end.column,
          line: end.line
        }, opts);
      }

      return new cssSyntaxError(message);
    }
  }, {
    key: "getProxyProcessor",
    value: function getProxyProcessor() {
      return {
        get: function get(node, prop) {
          if (prop === 'proxyOf') {
            return node;
          } else if (prop === 'root') {
            return function () {
              return node.root().toProxy();
            };
          } else {
            return node[prop];
          }
        },
        set: function set(node, prop, value) {
          if (node[prop] === value) return true;
          node[prop] = value;

          if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' ||
          /* c8 ignore next */
          prop === 'text') {
            node.markDirty();
          }

          return true;
        }
      };
    }
    /* c8 ignore next 3 */

  }, {
    key: "markClean",
    value: function markClean() {
      this[isClean$2] = true;
    }
  }, {
    key: "markDirty",
    value: function markDirty() {
      if (this[isClean$2]) {
        this[isClean$2] = false;
        var next = this;

        while (next = next.parent) {
          next[isClean$2] = false;
        }
      }
    }
  }, {
    key: "next",
    value: function next() {
      if (!this.parent) return undefined;
      var index = this.parent.index(this);
      return this.parent.nodes[index + 1];
    }
  }, {
    key: "positionBy",
    value: function positionBy(opts) {
      var pos = this.source.start;

      if (opts.index) {
        pos = this.positionInside(opts.index);
      } else if (opts.word) {
        var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        var stringRepresentation = inputString.slice(sourceOffset(inputString, this.source.start), sourceOffset(inputString, this.source.end));

        var _index2 = stringRepresentation.indexOf(opts.word);

        if (_index2 !== -1) pos = this.positionInside(_index2);
      }

      return pos;
    }
  }, {
    key: "positionInside",
    value: function positionInside(index) {
      var column = this.source.start.column;
      var line = this.source.start.line;
      var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
      var offset = sourceOffset(inputString, this.source.start);
      var end = offset + index;

      for (var i = offset; i < end; i++) {
        if (inputString[i] === '\n') {
          column = 1;
          line += 1;
        } else {
          column += 1;
        }
      }

      return {
        column: column,
        line: line
      };
    }
  }, {
    key: "prev",
    value: function prev() {
      if (!this.parent) return undefined;
      var index = this.parent.index(this);
      return this.parent.nodes[index - 1];
    }
  }, {
    key: "rangeBy",
    value: function rangeBy(opts) {
      var start = {
        column: this.source.start.column,
        line: this.source.start.line
      };
      var end = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: start.column + 1,
        line: start.line
      };

      if (opts.word) {
        var inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        var stringRepresentation = inputString.slice(sourceOffset(inputString, this.source.start), sourceOffset(inputString, this.source.end));

        var _index3 = stringRepresentation.indexOf(opts.word);

        if (_index3 !== -1) {
          start = this.positionInside(_index3);
          end = this.positionInside(_index3 + opts.word.length);
        }
      } else {
        if (opts.start) {
          start = {
            column: opts.start.column,
            line: opts.start.line
          };
        } else if (opts.index) {
          start = this.positionInside(opts.index);
        }

        if (opts.end) {
          end = {
            column: opts.end.column,
            line: opts.end.line
          };
        } else if (typeof opts.endIndex === 'number') {
          end = this.positionInside(opts.endIndex);
        } else if (opts.index) {
          end = this.positionInside(opts.index + 1);
        }
      }

      if (end.line < start.line || end.line === start.line && end.column <= start.column) {
        end = {
          column: start.column + 1,
          line: start.line
        };
      }

      return {
        end: end,
        start: start
      };
    }
  }, {
    key: "raw",
    value: function raw(prop, defaultType) {
      var str = new stringifier();
      return str.raw(this, prop, defaultType);
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.parent) {
        this.parent.removeChild(this);
      }

      this.parent = undefined;
      return this;
    }
  }, {
    key: "replaceWith",
    value: function replaceWith() {
      if (this.parent) {
        var bookmark = this;
        var foundSelf = false;

        for (var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          nodes[_key2] = arguments[_key2];
        }

        for (var _i2 = 0, _nodes = nodes; _i2 < _nodes.length; _i2++) {
          var _node5 = _nodes[_i2];

          if (_node5 === this) {
            foundSelf = true;
          } else if (foundSelf) {
            this.parent.insertAfter(bookmark, _node5);
            bookmark = _node5;
          } else {
            this.parent.insertBefore(bookmark, _node5);
          }
        }

        if (!foundSelf) {
          this.remove();
        }
      }

      return this;
    }
  }, {
    key: "root",
    value: function root() {
      var result = this;

      while (result.parent && result.parent.type !== 'document') {
        result = result.parent;
      }

      return result;
    }
  }, {
    key: "toJSON",
    value: function toJSON(_, inputs) {
      var fixed = {};
      var emitInputs = inputs == null;
      inputs = inputs || new Map();
      var inputsNextIndex = 0;

      for (var _name4 in this) {
        if (!Object.prototype.hasOwnProperty.call(this, _name4)) {
          /* c8 ignore next 2 */
          continue;
        }

        if (_name4 === 'parent' || _name4 === 'proxyCache') continue;
        var value = this[_name4];

        if (Array.isArray(value)) {
          fixed[_name4] = value.map(function (i) {
            if (_typeof2(i) === 'object' && i.toJSON) {
              return i.toJSON(null, inputs);
            } else {
              return i;
            }
          });
        } else if (_typeof2(value) === 'object' && value.toJSON) {
          fixed[_name4] = value.toJSON(null, inputs);
        } else if (_name4 === 'source') {
          var inputId = inputs.get(value.input);

          if (inputId == null) {
            inputId = inputsNextIndex;
            inputs.set(value.input, inputsNextIndex);
            inputsNextIndex++;
          }

          fixed[_name4] = {
            end: value.end,
            inputId: inputId,
            start: value.start
          };
        } else {
          fixed[_name4] = value;
        }
      }

      if (emitInputs) {
        fixed.inputs = _toConsumableArray(inputs.keys()).map(function (input) {
          return input.toJSON();
        });
      }

      return fixed;
    }
  }, {
    key: "toProxy",
    value: function toProxy() {
      if (!this.proxyCache) {
        this.proxyCache = new Proxy(this, this.getProxyProcessor());
      }

      return this.proxyCache;
    }
  }, {
    key: "toString",
    value: function toString() {
      var stringifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stringify_1;
      if (stringifier.stringify) stringifier = stringifier.stringify;
      var result = '';
      stringifier(this, function (i) {
        result += i;
      });
      return result;
    }
  }, {
    key: "warn",
    value: function warn(result, text, opts) {
      var data = {
        node: this
      };

      for (var i in opts) {
        data[i] = opts[i];
      }

      return result.warn(text, data);
    }
  }]);

  return Node;
}();

var node = Node;
Node.default = Node;

var Comment = /*#__PURE__*/function (_node6) {
  _inherits2(Comment, _node6);

  var _super11 = _createSuper2(Comment);

  function Comment(defaults) {
    var _this17;

    _classCallCheck2(this, Comment);

    _this17 = _super11.call(this, defaults);
    _this17.type = 'comment';
    return _this17;
  }

  return Comment;
}(node);

var _comment = Comment;
Comment.default = Comment;

var Declaration = /*#__PURE__*/function (_node7) {
  _inherits2(Declaration, _node7);

  var _super12 = _createSuper2(Declaration);

  function Declaration(defaults) {
    var _this18;

    _classCallCheck2(this, Declaration);

    if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }

    _this18 = _super12.call(this, defaults);
    _this18.type = 'decl';
    return _this18;
  }

  _createClass2(Declaration, [{
    key: "variable",
    get: function get() {
      return this.prop.startsWith('--') || this.prop[0] === '$';
    }
  }]);

  return Declaration;
}(node);

var declaration = Declaration;
Declaration.default = Declaration;
var isClean$1 = symbols.isClean,
    my$1 = symbols.my;
var AtRule$1, parse$1, Root$1, Rule$1;

function cleanSource(nodes) {
  return nodes.map(function (i) {
    if (i.nodes) i.nodes = cleanSource(i.nodes);
    delete i.source;
    return i;
  });
}

function markTreeDirty(node) {
  node[isClean$1] = false;

  if (node.proxyOf.nodes) {
    var _iterator4 = _createForOfIteratorHelper(node.proxyOf.nodes),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var i = _step4.value;
        markTreeDirty(i);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
}

var Container = /*#__PURE__*/function (_node8) {
  _inherits2(Container, _node8);

  var _super13 = _createSuper2(Container);

  function Container() {
    _classCallCheck2(this, Container);

    return _super13.apply(this, arguments);
  }

  _createClass2(Container, [{
    key: "first",
    get: function get() {
      if (!this.proxyOf.nodes) return undefined;
      return this.proxyOf.nodes[0];
    }
  }, {
    key: "last",
    get: function get() {
      if (!this.proxyOf.nodes) return undefined;
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
  }, {
    key: "append",
    value: function append() {
      for (var _len3 = arguments.length, children = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        children[_key3] = arguments[_key3];
      }

      for (var _i3 = 0, _children3 = children; _i3 < _children3.length; _i3++) {
        var child = _children3[_i3];
        var nodes = this.normalize(child, this.last);

        var _iterator5 = _createForOfIteratorHelper(nodes),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _node9 = _step5.value;
            this.proxyOf.nodes.push(_node9);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this.markDirty();
      return this;
    }
  }, {
    key: "cleanRaws",
    value: function cleanRaws(keepBetween) {
      _get(_getPrototypeOf2(Container.prototype), "cleanRaws", this).call(this, keepBetween);

      if (this.nodes) {
        var _iterator6 = _createForOfIteratorHelper(this.nodes),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _node10 = _step6.value;

            _node10.cleanRaws(keepBetween);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  }, {
    key: "each",
    value: function each(callback) {
      if (!this.proxyOf.nodes) return undefined;
      var iterator = this.getIterator();
      var index, result;

      while (this.indexes[iterator] < this.proxyOf.nodes.length) {
        index = this.indexes[iterator];
        result = callback(this.proxyOf.nodes[index], index);
        if (result === false) break;
        this.indexes[iterator] += 1;
      }

      delete this.indexes[iterator];
      return result;
    }
  }, {
    key: "every",
    value: function every(condition) {
      return this.nodes.every(condition);
    }
  }, {
    key: "getIterator",
    value: function getIterator() {
      if (!this.lastEach) this.lastEach = 0;
      if (!this.indexes) this.indexes = {};
      this.lastEach += 1;
      var iterator = this.lastEach;
      this.indexes[iterator] = 0;
      return iterator;
    }
  }, {
    key: "getProxyProcessor",
    value: function getProxyProcessor() {
      return {
        get: function get(node, prop) {
          if (prop === 'proxyOf') {
            return node;
          } else if (!node[prop]) {
            return node[prop];
          } else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) {
            return function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }

              return node[prop].apply(node, _toConsumableArray(args.map(function (i) {
                if (typeof i === 'function') {
                  return function (child, index) {
                    return i(child.toProxy(), index);
                  };
                } else {
                  return i;
                }
              })));
            };
          } else if (prop === 'every' || prop === 'some') {
            return function (cb) {
              return node[prop](function (child) {
                for (var _len5 = arguments.length, other = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  other[_key5 - 1] = arguments[_key5];
                }

                return cb.apply(void 0, [child.toProxy()].concat(other));
              });
            };
          } else if (prop === 'root') {
            return function () {
              return node.root().toProxy();
            };
          } else if (prop === 'nodes') {
            return node.nodes.map(function (i) {
              return i.toProxy();
            });
          } else if (prop === 'first' || prop === 'last') {
            return node[prop].toProxy();
          } else {
            return node[prop];
          }
        },
        set: function set(node, prop, value) {
          if (node[prop] === value) return true;
          node[prop] = value;

          if (prop === 'name' || prop === 'params' || prop === 'selector') {
            node.markDirty();
          }

          return true;
        }
      };
    }
  }, {
    key: "index",
    value: function index(child) {
      if (typeof child === 'number') return child;
      if (child.proxyOf) child = child.proxyOf;
      return this.proxyOf.nodes.indexOf(child);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(exist, add) {
      var existIndex = this.index(exist);
      var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
      existIndex = this.index(exist);

      var _iterator7 = _createForOfIteratorHelper(nodes),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _node11 = _step7.value;
          this.proxyOf.nodes.splice(existIndex + 1, 0, _node11);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var index;

      for (var id in this.indexes) {
        index = this.indexes[id];

        if (existIndex < index) {
          this.indexes[id] = index + nodes.length;
        }
      }

      this.markDirty();
      return this;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(exist, add) {
      var existIndex = this.index(exist);
      var type = existIndex === 0 ? 'prepend' : false;
      var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
      existIndex = this.index(exist);

      var _iterator8 = _createForOfIteratorHelper(nodes),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _node12 = _step8.value;
          this.proxyOf.nodes.splice(existIndex, 0, _node12);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var index;

      for (var id in this.indexes) {
        index = this.indexes[id];

        if (existIndex <= index) {
          this.indexes[id] = index + nodes.length;
        }
      }

      this.markDirty();
      return this;
    }
  }, {
    key: "normalize",
    value: function normalize(nodes, sample) {
      var _this19 = this;

      if (typeof nodes === 'string') {
        nodes = cleanSource(parse$1(nodes).nodes);
      } else if (typeof nodes === 'undefined') {
        nodes = [];
      } else if (Array.isArray(nodes)) {
        nodes = nodes.slice(0);

        var _iterator9 = _createForOfIteratorHelper(nodes),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var i = _step9.value;
            if (i.parent) i.parent.removeChild(i, 'ignore');
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      } else if (nodes.type === 'root' && this.type !== 'document') {
        nodes = nodes.nodes.slice(0);

        var _iterator10 = _createForOfIteratorHelper(nodes),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _i4 = _step10.value;
            if (_i4.parent) _i4.parent.removeChild(_i4, 'ignore');
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      } else if (nodes.type) {
        nodes = [nodes];
      } else if (nodes.prop) {
        if (typeof nodes.value === 'undefined') {
          throw new Error('Value field is missed in node creation');
        } else if (typeof nodes.value !== 'string') {
          nodes.value = String(nodes.value);
        }

        nodes = [new declaration(nodes)];
      } else if (nodes.selector || nodes.selectors) {
        nodes = [new Rule$1(nodes)];
      } else if (nodes.name) {
        nodes = [new AtRule$1(nodes)];
      } else if (nodes.text) {
        nodes = [new _comment(nodes)];
      } else {
        throw new Error('Unknown node type in node creation');
      }

      var processed = nodes.map(function (i) {
        /* c8 ignore next */
        if (!i[my$1]) Container.rebuild(i);
        i = i.proxyOf;
        if (i.parent) i.parent.removeChild(i);
        if (i[isClean$1]) markTreeDirty(i);
        if (!i.raws) i.raws = {};

        if (typeof i.raws.before === 'undefined') {
          if (sample && typeof sample.raws.before !== 'undefined') {
            i.raws.before = sample.raws.before.replace(/\S/g, '');
          }
        }

        i.parent = _this19.proxyOf;
        return i;
      });
      return processed;
    }
  }, {
    key: "prepend",
    value: function prepend() {
      for (var _len6 = arguments.length, children = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        children[_key6] = arguments[_key6];
      }

      children = children.reverse();

      var _iterator11 = _createForOfIteratorHelper(children),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var child = _step11.value;
          var nodes = this.normalize(child, this.first, 'prepend').reverse();

          var _iterator12 = _createForOfIteratorHelper(nodes),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _node13 = _step12.value;
              this.proxyOf.nodes.unshift(_node13);
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }

          for (var id in this.indexes) {
            this.indexes[id] = this.indexes[id] + nodes.length;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      this.markDirty();
      return this;
    }
  }, {
    key: "push",
    value: function push(child) {
      child.parent = this;
      this.proxyOf.nodes.push(child);
      return this;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _iterator13 = _createForOfIteratorHelper(this.proxyOf.nodes),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _node14 = _step13.value;
          _node14.parent = undefined;
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      this.proxyOf.nodes = [];
      this.markDirty();
      return this;
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      child = this.index(child);
      this.proxyOf.nodes[child].parent = undefined;
      this.proxyOf.nodes.splice(child, 1);
      var index;

      for (var id in this.indexes) {
        index = this.indexes[id];

        if (index >= child) {
          this.indexes[id] = index - 1;
        }
      }

      this.markDirty();
      return this;
    }
  }, {
    key: "replaceValues",
    value: function replaceValues(pattern, opts, callback) {
      if (!callback) {
        callback = opts;
        opts = {};
      }

      this.walkDecls(function (decl) {
        if (opts.props && !opts.props.includes(decl.prop)) return;
        if (opts.fast && !decl.value.includes(opts.fast)) return;
        decl.value = decl.value.replace(pattern, callback);
      });
      this.markDirty();
      return this;
    }
  }, {
    key: "some",
    value: function some(condition) {
      return this.nodes.some(condition);
    }
  }, {
    key: "walk",
    value: function walk(callback) {
      return this.each(function (child, i) {
        var result;

        try {
          result = callback(child, i);
        } catch (e) {
          throw child.addToError(e);
        }

        if (result !== false && child.walk) {
          result = child.walk(callback);
        }

        return result;
      });
    }
  }, {
    key: "walkAtRules",
    value: function walkAtRules(name, callback) {
      if (!callback) {
        callback = name;
        return this.walk(function (child, i) {
          if (child.type === 'atrule') {
            return callback(child, i);
          }
        });
      }

      if (name instanceof RegExp) {
        return this.walk(function (child, i) {
          if (child.type === 'atrule' && name.test(child.name)) {
            return callback(child, i);
          }
        });
      }

      return this.walk(function (child, i) {
        if (child.type === 'atrule' && child.name === name) {
          return callback(child, i);
        }
      });
    }
  }, {
    key: "walkComments",
    value: function walkComments(callback) {
      return this.walk(function (child, i) {
        if (child.type === 'comment') {
          return callback(child, i);
        }
      });
    }
  }, {
    key: "walkDecls",
    value: function walkDecls(prop, callback) {
      if (!callback) {
        callback = prop;
        return this.walk(function (child, i) {
          if (child.type === 'decl') {
            return callback(child, i);
          }
        });
      }

      if (prop instanceof RegExp) {
        return this.walk(function (child, i) {
          if (child.type === 'decl' && prop.test(child.prop)) {
            return callback(child, i);
          }
        });
      }

      return this.walk(function (child, i) {
        if (child.type === 'decl' && child.prop === prop) {
          return callback(child, i);
        }
      });
    }
  }, {
    key: "walkRules",
    value: function walkRules(selector, callback) {
      if (!callback) {
        callback = selector;
        return this.walk(function (child, i) {
          if (child.type === 'rule') {
            return callback(child, i);
          }
        });
      }

      if (selector instanceof RegExp) {
        return this.walk(function (child, i) {
          if (child.type === 'rule' && selector.test(child.selector)) {
            return callback(child, i);
          }
        });
      }

      return this.walk(function (child, i) {
        if (child.type === 'rule' && child.selector === selector) {
          return callback(child, i);
        }
      });
    }
  }]);

  return Container;
}(node);

Container.registerParse = function (dependant) {
  parse$1 = dependant;
};

Container.registerRule = function (dependant) {
  Rule$1 = dependant;
};

Container.registerAtRule = function (dependant) {
  AtRule$1 = dependant;
};

Container.registerRoot = function (dependant) {
  Root$1 = dependant;
};

var container = Container;
Container.default = Container;
/* c8 ignore start */

Container.rebuild = function (node) {
  if (node.type === 'atrule') {
    Object.setPrototypeOf(node, AtRule$1.prototype);
  } else if (node.type === 'rule') {
    Object.setPrototypeOf(node, Rule$1.prototype);
  } else if (node.type === 'decl') {
    Object.setPrototypeOf(node, declaration.prototype);
  } else if (node.type === 'comment') {
    Object.setPrototypeOf(node, _comment.prototype);
  } else if (node.type === 'root') {
    Object.setPrototypeOf(node, Root$1.prototype);
  }

  node[my$1] = true;

  if (node.nodes) {
    node.nodes.forEach(function (child) {
      Container.rebuild(child);
    });
  }
};

var AtRule = /*#__PURE__*/function (_container) {
  _inherits2(AtRule, _container);

  var _super14 = _createSuper2(AtRule);

  function AtRule(defaults) {
    var _this20;

    _classCallCheck2(this, AtRule);

    _this20 = _super14.call(this, defaults);
    _this20.type = 'atrule';
    return _this20;
  }

  _createClass2(AtRule, [{
    key: "append",
    value: function append() {
      var _get2;

      if (!this.proxyOf.nodes) this.nodes = [];

      for (var _len7 = arguments.length, children = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        children[_key7] = arguments[_key7];
      }

      return (_get2 = _get(_getPrototypeOf2(AtRule.prototype), "append", this)).call.apply(_get2, [this].concat(children));
    }
  }, {
    key: "prepend",
    value: function prepend() {
      var _get3;

      if (!this.proxyOf.nodes) this.nodes = [];

      for (var _len8 = arguments.length, children = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        children[_key8] = arguments[_key8];
      }

      return (_get3 = _get(_getPrototypeOf2(AtRule.prototype), "prepend", this)).call.apply(_get3, [this].concat(children));
    }
  }]);

  return AtRule;
}(container);

var atRule = AtRule;
AtRule.default = AtRule;
container.registerAtRule(AtRule);
var LazyResult$2, Processor$2;

var Document = /*#__PURE__*/function (_container2) {
  _inherits2(Document, _container2);

  var _super15 = _createSuper2(Document);

  function Document(defaults) {
    var _this21;

    _classCallCheck2(this, Document);

    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    _this21 = _super15.call(this, _objectSpread({
      type: 'document'
    }, defaults));

    if (!_this21.nodes) {
      _this21.nodes = [];
    }

    return _this21;
  }

  _createClass2(Document, [{
    key: "toResult",
    value: function toResult() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var lazy = new LazyResult$2(new Processor$2(), this, opts);
      return lazy.stringify();
    }
  }]);

  return Document;
}(container);

Document.registerLazyResult = function (dependant) {
  LazyResult$2 = dependant;
};

Document.registerProcessor = function (dependant) {
  Processor$2 = dependant;
};

var document$1 = Document;
Document.default = Document; // This alphabet uses `A-Za-z0-9_-` symbols.
// The order of characters is optimized for better gzip and brotli compression.
// References to the same file (works both for gzip and brotli):
// `'use`, `andom`, and `rict'`
// References to the brotli default dictionary:
// `-26T`, `1983`, `40px`, `75px`, `bush`, `jack`, `mind`, `very`, and `wolf`

var urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

var customAlphabet = function customAlphabet(alphabet) {
  var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
  return function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
    var id = ''; // A compact alternative for `for (var i = 0; i < step; i++)`.

    var i = size | 0;

    while (i--) {
      // `| 0` is more compact and faster than `Math.floor()`.
      id += alphabet[Math.random() * alphabet.length | 0];
    }

    return id;
  };
};

var nanoid$1 = function nanoid$1() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  var id = ''; // A compact alternative for `for (var i = 0; i < step; i++)`.

  var i = size | 0;

  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[Math.random() * 64 | 0];
  }

  return id;
};

var nonSecure = /*#__PURE__*/Object.freeze({
  __proto__: null,
  nanoid: nanoid$1,
  customAlphabet: customAlphabet
});
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */

var encode$1 = function encode$1(number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }

  throw new TypeError("Must be between 0 and 63: " + number);
};
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */


var decode$1 = function decode$1(charCode) {
  var bigA = 65; // 'A'

  var bigZ = 90; // 'Z'

  var littleA = 97; // 'a'

  var littleZ = 122; // 'z'

  var zero = 48; // '0'

  var nine = 57; // '9'

  var plus = 43; // '+'

  var slash = 47; // '/'

  var littleOffset = 26;
  var numberOffset = 52; // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ

  if (bigA <= charCode && charCode <= bigZ) {
    return charCode - bigA;
  } // 26 - 51: abcdefghijklmnopqrstuvwxyz


  if (littleA <= charCode && charCode <= littleZ) {
    return charCode - littleA + littleOffset;
  } // 52 - 61: 0123456789


  if (zero <= charCode && charCode <= nine) {
    return charCode - zero + numberOffset;
  } // 62: +


  if (charCode == plus) {
    return 62;
  } // 63: /


  if (charCode == slash) {
    return 63;
  } // Invalid base64 digit.


  return -1;
};

var base64 = {
  encode: encode$1,
  decode: decode$1
};
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5; // binary: 100000

var VLQ_BASE = 1 << VLQ_BASE_SHIFT; // binary: 011111

var VLQ_BASE_MASK = VLQ_BASE - 1; // binary: 100000

var VLQ_CONTINUATION_BIT = VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */

function toVLQSigned(aValue) {
  return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */


function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative ? -shifted : shifted;
}
/**
 * Returns the base 64 VLQ encoded value.
 */


var encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;
  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;

    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }

    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */


var decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));

    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

var base64Vlq = {
  encode: encode,
  decode: decode
};
var util = createCommonjsModule(function (module, exports) {
  /* -*- Mode: js; js-indent-level: 2; -*- */

  /*
   * Copyright 2011 Mozilla Foundation and contributors
   * Licensed under the New BSD license. See LICENSE or:
   * http://opensource.org/licenses/BSD-3-Clause
   */

  /**
   * This is a helper function for getting values from parameter/options
   * objects.
   *
   * @param args The object we are extracting values from
   * @param name The name of the property we are getting.
   * @param defaultValue An optional value to return if the property is missing
   * from the object. If this is not specified and the property is missing, an
   * error will be thrown.
   */
  function getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) {
      return aArgs[aName];
    } else if (arguments.length === 3) {
      return aDefaultValue;
    } else {
      throw new Error('"' + aName + '" is a required argument.');
    }
  }

  exports.getArg = getArg;
  var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
  var dataUrlRegexp = /^data:.+\,.+$/;

  function urlParse(aUrl) {
    var match = aUrl.match(urlRegexp);

    if (!match) {
      return null;
    }

    return {
      scheme: match[1],
      auth: match[2],
      host: match[3],
      port: match[4],
      path: match[5]
    };
  }

  exports.urlParse = urlParse;

  function urlGenerate(aParsedUrl) {
    var url = '';

    if (aParsedUrl.scheme) {
      url += aParsedUrl.scheme + ':';
    }

    url += '//';

    if (aParsedUrl.auth) {
      url += aParsedUrl.auth + '@';
    }

    if (aParsedUrl.host) {
      url += aParsedUrl.host;
    }

    if (aParsedUrl.port) {
      url += ":" + aParsedUrl.port;
    }

    if (aParsedUrl.path) {
      url += aParsedUrl.path;
    }

    return url;
  }

  exports.urlGenerate = urlGenerate;
  var MAX_CACHED_INPUTS = 32;
  /**
   * Takes some function `f(input) -> result` and returns a memoized version of
   * `f`.
   *
   * We keep at most `MAX_CACHED_INPUTS` memoized results of `f` alive. The
   * memoization is a dumb-simple, linear least-recently-used cache.
   */

  function lruMemoize(f) {
    var cache = [];
    return function (input) {
      for (var i = 0; i < cache.length; i++) {
        if (cache[i].input === input) {
          var temp = cache[0];
          cache[0] = cache[i];
          cache[i] = temp;
          return cache[0].result;
        }
      }

      var result = f(input);
      cache.unshift({
        input: input,
        result: result
      });

      if (cache.length > MAX_CACHED_INPUTS) {
        cache.pop();
      }

      return result;
    };
  }
  /**
   * Normalizes a path, or the path portion of a URL:
   *
   * - Replaces consecutive slashes with one slash.
   * - Removes unnecessary '.' parts.
   * - Removes unnecessary '<dir>/..' parts.
   *
   * Based on code in the Node.js 'path' core module.
   *
   * @param aPath The path or url to normalize.
   */


  var normalize = lruMemoize(function normalize(aPath) {
    var path = aPath;
    var url = urlParse(aPath);

    if (url) {
      if (!url.path) {
        return aPath;
      }

      path = url.path;
    }

    var isAbsolute = exports.isAbsolute(path); // Split the path into parts between `/` characters. This is much faster than
    // using `.split(/\/+/g)`.

    var parts = [];
    var start = 0;
    var i = 0;

    while (true) {
      start = i;
      i = path.indexOf("/", start);

      if (i === -1) {
        parts.push(path.slice(start));
        break;
      } else {
        parts.push(path.slice(start, i));

        while (i < path.length && path[i] === "/") {
          i++;
        }
      }
    }

    for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
      part = parts[i];

      if (part === '.') {
        parts.splice(i, 1);
      } else if (part === '..') {
        up++;
      } else if (up > 0) {
        if (part === '') {
          // The first part is blank if the path is absolute. Trying to go
          // above the root is a no-op. Therefore we can remove all '..' parts
          // directly after the root.
          parts.splice(i + 1, up);
          up = 0;
        } else {
          parts.splice(i, 2);
          up--;
        }
      }
    }

    path = parts.join('/');

    if (path === '') {
      path = isAbsolute ? '/' : '.';
    }

    if (url) {
      url.path = path;
      return urlGenerate(url);
    }

    return path;
  });
  exports.normalize = normalize;
  /**
   * Joins two paths/URLs.
   *
   * @param aRoot The root path or URL.
   * @param aPath The path or URL to be joined with the root.
   *
   * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
   *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
   *   first.
   * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
   *   is updated with the result and aRoot is returned. Otherwise the result
   *   is returned.
   *   - If aPath is absolute, the result is aPath.
   *   - Otherwise the two paths are joined with a slash.
   * - Joining for example 'http://' and 'www.example.com' is also supported.
   */

  function join(aRoot, aPath) {
    if (aRoot === "") {
      aRoot = ".";
    }

    if (aPath === "") {
      aPath = ".";
    }

    var aPathUrl = urlParse(aPath);
    var aRootUrl = urlParse(aRoot);

    if (aRootUrl) {
      aRoot = aRootUrl.path || '/';
    } // `join(foo, '//www.example.org')`


    if (aPathUrl && !aPathUrl.scheme) {
      if (aRootUrl) {
        aPathUrl.scheme = aRootUrl.scheme;
      }

      return urlGenerate(aPathUrl);
    }

    if (aPathUrl || aPath.match(dataUrlRegexp)) {
      return aPath;
    } // `join('http://', 'www.example.com')`


    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
      aRootUrl.host = aPath;
      return urlGenerate(aRootUrl);
    }

    var joined = aPath.charAt(0) === '/' ? aPath : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

    if (aRootUrl) {
      aRootUrl.path = joined;
      return urlGenerate(aRootUrl);
    }

    return joined;
  }

  exports.join = join;

  exports.isAbsolute = function (aPath) {
    return aPath.charAt(0) === '/' || urlRegexp.test(aPath);
  };
  /**
   * Make a path relative to a URL or another path.
   *
   * @param aRoot The root path or URL.
   * @param aPath The path or URL to be made relative to aRoot.
   */


  function relative(aRoot, aPath) {
    if (aRoot === "") {
      aRoot = ".";
    }

    aRoot = aRoot.replace(/\/$/, ''); // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.

    var level = 0;

    while (aPath.indexOf(aRoot + '/') !== 0) {
      var index = aRoot.lastIndexOf("/");

      if (index < 0) {
        return aPath;
      } // If the only part of the root that is left is the scheme (i.e. http://,
      // file:///, etc.), one or more slashes (/), or simply nothing at all, we
      // have exhausted all components, so the path is not relative to the root.


      aRoot = aRoot.slice(0, index);

      if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
        return aPath;
      }

      ++level;
    } // Make sure we add a "../" for each component we removed from the root.


    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
  }

  exports.relative = relative;

  var supportsNullProto = function () {
    var obj = Object.create(null);
    return !('__proto__' in obj);
  }();

  function identity(s) {
    return s;
  }
  /**
   * Because behavior goes wacky when you set `__proto__` on objects, we
   * have to prefix all the strings in our set with an arbitrary character.
   *
   * See https://github.com/mozilla/source-map/pull/31 and
   * https://github.com/mozilla/source-map/issues/30
   *
   * @param String aStr
   */


  function toSetString(aStr) {
    if (isProtoString(aStr)) {
      return '$' + aStr;
    }

    return aStr;
  }

  exports.toSetString = supportsNullProto ? identity : toSetString;

  function fromSetString(aStr) {
    if (isProtoString(aStr)) {
      return aStr.slice(1);
    }

    return aStr;
  }

  exports.fromSetString = supportsNullProto ? identity : fromSetString;

  function isProtoString(s) {
    if (!s) {
      return false;
    }

    var length = s.length;

    if (length < 9
    /* "__proto__".length */
    ) {
        return false;
      }

    if (s.charCodeAt(length - 1) !== 95
    /* '_' */
    || s.charCodeAt(length - 2) !== 95
    /* '_' */
    || s.charCodeAt(length - 3) !== 111
    /* 'o' */
    || s.charCodeAt(length - 4) !== 116
    /* 't' */
    || s.charCodeAt(length - 5) !== 111
    /* 'o' */
    || s.charCodeAt(length - 6) !== 114
    /* 'r' */
    || s.charCodeAt(length - 7) !== 112
    /* 'p' */
    || s.charCodeAt(length - 8) !== 95
    /* '_' */
    || s.charCodeAt(length - 9) !== 95
    /* '_' */
    ) {
        return false;
      }

    for (var i = length - 10; i >= 0; i--) {
      if (s.charCodeAt(i) !== 36
      /* '$' */
      ) {
          return false;
        }
    }

    return true;
  }
  /**
   * Comparator between two mappings where the original positions are compared.
   *
   * Optionally pass in `true` as `onlyCompareGenerated` to consider two
   * mappings with the same original source/line/column, but different generated
   * line and column the same. Useful when searching for a mapping with a
   * stubbed out mapping.
   */


  function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = strcmp(mappingA.source, mappingB.source);

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalLine - mappingB.originalLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalColumn - mappingB.originalColumn;

    if (cmp !== 0 || onlyCompareOriginal) {
      return cmp;
    }

    cmp = mappingA.generatedColumn - mappingB.generatedColumn;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.generatedLine - mappingB.generatedLine;

    if (cmp !== 0) {
      return cmp;
    }

    return strcmp(mappingA.name, mappingB.name);
  }

  exports.compareByOriginalPositions = compareByOriginalPositions;

  function compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
    var cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalColumn - mappingB.originalColumn;

    if (cmp !== 0 || onlyCompareOriginal) {
      return cmp;
    }

    cmp = mappingA.generatedColumn - mappingB.generatedColumn;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.generatedLine - mappingB.generatedLine;

    if (cmp !== 0) {
      return cmp;
    }

    return strcmp(mappingA.name, mappingB.name);
  }

  exports.compareByOriginalPositionsNoSource = compareByOriginalPositionsNoSource;
  /**
   * Comparator between two mappings with deflated source and name indices where
   * the generated positions are compared.
   *
   * Optionally pass in `true` as `onlyCompareGenerated` to consider two
   * mappings with the same generated line and column, but different
   * source/name/original line and column the same. Useful when searching for a
   * mapping with a stubbed out mapping.
   */

  function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.generatedColumn - mappingB.generatedColumn;

    if (cmp !== 0 || onlyCompareGenerated) {
      return cmp;
    }

    cmp = strcmp(mappingA.source, mappingB.source);

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalLine - mappingB.originalLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalColumn - mappingB.originalColumn;

    if (cmp !== 0) {
      return cmp;
    }

    return strcmp(mappingA.name, mappingB.name);
  }

  exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

  function compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedColumn - mappingB.generatedColumn;

    if (cmp !== 0 || onlyCompareGenerated) {
      return cmp;
    }

    cmp = strcmp(mappingA.source, mappingB.source);

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalLine - mappingB.originalLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalColumn - mappingB.originalColumn;

    if (cmp !== 0) {
      return cmp;
    }

    return strcmp(mappingA.name, mappingB.name);
  }

  exports.compareByGeneratedPositionsDeflatedNoLine = compareByGeneratedPositionsDeflatedNoLine;

  function strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) {
      return 0;
    }

    if (aStr1 === null) {
      return 1; // aStr2 !== null
    }

    if (aStr2 === null) {
      return -1; // aStr1 !== null
    }

    if (aStr1 > aStr2) {
      return 1;
    }

    return -1;
  }
  /**
   * Comparator between two mappings with inflated source and name strings where
   * the generated positions are compared.
   */


  function compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.generatedColumn - mappingB.generatedColumn;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = strcmp(mappingA.source, mappingB.source);

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalLine - mappingB.originalLine;

    if (cmp !== 0) {
      return cmp;
    }

    cmp = mappingA.originalColumn - mappingB.originalColumn;

    if (cmp !== 0) {
      return cmp;
    }

    return strcmp(mappingA.name, mappingB.name);
  }

  exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
  /**
   * Strip any JSON XSSI avoidance prefix from the string (as documented
   * in the source maps specification), and then parse the string as
   * JSON.
   */

  function parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
  }

  exports.parseSourceMapInput = parseSourceMapInput;
  /**
   * Compute the URL of a source given the the source root, the source's
   * URL, and the source map's URL.
   */

  function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || '';

    if (sourceRoot) {
      // This follows what Chrome does.
      if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') {
        sourceRoot += '/';
      } // The spec says:
      //   Line 4: An optional source root, useful for relocating source
      //   files on a server or removing repeated values in the
      //   “sources” entry.  This value is prepended to the individual
      //   entries in the “source” field.


      sourceURL = sourceRoot + sourceURL;
    } // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).


    if (sourceMapURL) {
      var parsed = urlParse(sourceMapURL);

      if (!parsed) {
        throw new Error("sourceMapURL could not be parsed");
      }

      if (parsed.path) {
        // Strip the last path component, but keep the "/".
        var index = parsed.path.lastIndexOf('/');

        if (index >= 0) {
          parsed.path = parsed.path.substring(0, index + 1);
        }
      }

      sourceURL = join(urlGenerate(parsed), sourceURL);
    }

    return normalize(sourceURL);
  }

  exports.computeSourceURL = computeSourceURL;
});
util.getArg;
util.urlParse;
util.urlGenerate;
util.normalize;
util.join;
util.isAbsolute;
util.relative;
util.toSetString;
util.fromSetString;
util.compareByOriginalPositions;
util.compareByOriginalPositionsNoSource;
util.compareByGeneratedPositionsDeflated;
util.compareByGeneratedPositionsDeflatedNoLine;
util.compareByGeneratedPositionsInflated;
util.parseSourceMapInput;
util.computeSourceURL;
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var has$1 = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */

function ArraySet$2() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */


ArraySet$2.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet$2();

  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }

  return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */


ArraySet$2.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */


ArraySet$2.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has$1.call(this._set, sStr);
  var idx = this._array.length;

  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }

  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */


ArraySet$2.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util.toSetString(aStr);
    return has$1.call(this._set, sStr);
  }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */


ArraySet$2.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);

    if (idx >= 0) {
      return idx;
    }
  } else {
    var sStr = util.toSetString(aStr);

    if (has$1.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */


ArraySet$2.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }

  throw new Error('No element indexed by ' + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */


ArraySet$2.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

var ArraySet_1 = ArraySet$2;
var arraySet = {
  ArraySet: ArraySet_1
};
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */

function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */


function MappingList$1() {
  this._array = [];
  this._sorted = true; // Serves as infimum

  this._last = {
    generatedLine: -1,
    generatedColumn: 0
  };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */


MappingList$1.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
  this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */


MappingList$1.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;

    this._array.push(aMapping);
  } else {
    this._sorted = false;

    this._array.push(aMapping);
  }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */


MappingList$1.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);

    this._sorted = true;
  }

  return this._array;
};

var MappingList_1 = MappingList$1;
var mappingList = {
  MappingList: MappingList_1
};
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var ArraySet$1 = arraySet.ArraySet;
var MappingList = mappingList.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */

function SourceMapGenerator$5(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }

  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._ignoreInvalidMapping = util.getArg(aArgs, 'ignoreInvalidMapping', false);
  this._sources = new ArraySet$1();
  this._names = new ArraySet$1();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator$5.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */

SourceMapGenerator$5.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer, generatorOps) {
  var sourceRoot = aSourceMapConsumer.sourceRoot;
  var generator = new SourceMapGenerator$5(Object.assign(generatorOps || {}, {
    file: aSourceMapConsumer.file,
    sourceRoot: sourceRoot
  }));
  aSourceMapConsumer.eachMapping(function (mapping) {
    var newMapping = {
      generated: {
        line: mapping.generatedLine,
        column: mapping.generatedColumn
      }
    };

    if (mapping.source != null) {
      newMapping.source = mapping.source;

      if (sourceRoot != null) {
        newMapping.source = util.relative(sourceRoot, newMapping.source);
      }

      newMapping.original = {
        line: mapping.originalLine,
        column: mapping.originalColumn
      };

      if (mapping.name != null) {
        newMapping.name = mapping.name;
      }
    }

    generator.addMapping(newMapping);
  });
  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var sourceRelative = sourceFile;

    if (sourceRoot !== null) {
      sourceRelative = util.relative(sourceRoot, sourceFile);
    }

    if (!generator._sources.has(sourceRelative)) {
      generator._sources.add(sourceRelative);
    }

    var content = aSourceMapConsumer.sourceContentFor(sourceFile);

    if (content != null) {
      generator.setSourceContent(sourceFile, content);
    }
  });
  return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */


SourceMapGenerator$5.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
  var generated = util.getArg(aArgs, 'generated');
  var original = util.getArg(aArgs, 'original', null);
  var source = util.getArg(aArgs, 'source', null);
  var name = util.getArg(aArgs, 'name', null);

  if (!this._skipValidation) {
    if (this._validateMapping(generated, original, source, name) === false) {
      return;
    }
  }

  if (source != null) {
    source = String(source);

    if (!this._sources.has(source)) {
      this._sources.add(source);
    }
  }

  if (name != null) {
    name = String(name);

    if (!this._names.has(name)) {
      this._names.add(name);
    }
  }

  this._mappings.add({
    generatedLine: generated.line,
    generatedColumn: generated.column,
    originalLine: original != null && original.line,
    originalColumn: original != null && original.column,
    source: source,
    name: name
  });
};
/**
 * Set the source content for a source file.
 */


SourceMapGenerator$5.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
  var source = aSourceFile;

  if (this._sourceRoot != null) {
    source = util.relative(this._sourceRoot, source);
  }

  if (aSourceContent != null) {
    // Add the source content to the _sourcesContents map.
    // Create a new _sourcesContents map if the property is null.
    if (!this._sourcesContents) {
      this._sourcesContents = Object.create(null);
    }

    this._sourcesContents[util.toSetString(source)] = aSourceContent;
  } else if (this._sourcesContents) {
    // Remove the source file from the _sourcesContents map.
    // If the _sourcesContents map is empty, set the property to null.
    delete this._sourcesContents[util.toSetString(source)];

    if (Object.keys(this._sourcesContents).length === 0) {
      this._sourcesContents = null;
    }
  }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */


SourceMapGenerator$5.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
  var sourceFile = aSourceFile; // If aSourceFile is omitted, we will use the file property of the SourceMap

  if (aSourceFile == null) {
    if (aSourceMapConsumer.file == null) {
      throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' + 'or the source map\'s "file" property. Both were omitted.');
    }

    sourceFile = aSourceMapConsumer.file;
  }

  var sourceRoot = this._sourceRoot; // Make "sourceFile" relative if an absolute Url is passed.

  if (sourceRoot != null) {
    sourceFile = util.relative(sourceRoot, sourceFile);
  } // Applying the SourceMap can add and remove items from the sources and
  // the names array.


  var newSources = new ArraySet$1();
  var newNames = new ArraySet$1(); // Find mappings for the "sourceFile"

  this._mappings.unsortedForEach(function (mapping) {
    if (mapping.source === sourceFile && mapping.originalLine != null) {
      // Check if it can be mapped by the source map, then update the mapping.
      var original = aSourceMapConsumer.originalPositionFor({
        line: mapping.originalLine,
        column: mapping.originalColumn
      });

      if (original.source != null) {
        // Copy mapping
        mapping.source = original.source;

        if (aSourceMapPath != null) {
          mapping.source = util.join(aSourceMapPath, mapping.source);
        }

        if (sourceRoot != null) {
          mapping.source = util.relative(sourceRoot, mapping.source);
        }

        mapping.originalLine = original.line;
        mapping.originalColumn = original.column;

        if (original.name != null) {
          mapping.name = original.name;
        }
      }
    }

    var source = mapping.source;

    if (source != null && !newSources.has(source)) {
      newSources.add(source);
    }

    var name = mapping.name;

    if (name != null && !newNames.has(name)) {
      newNames.add(name);
    }
  }, this);

  this._sources = newSources;
  this._names = newNames; // Copy sourcesContents of applied map.

  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var content = aSourceMapConsumer.sourceContentFor(sourceFile);

    if (content != null) {
      if (aSourceMapPath != null) {
        sourceFile = util.join(aSourceMapPath, sourceFile);
      }

      if (sourceRoot != null) {
        sourceFile = util.relative(sourceRoot, sourceFile);
      }

      this.setSourceContent(sourceFile, content);
    }
  }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */


SourceMapGenerator$5.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
  // When aOriginal is truthy but has empty values for .line and .column,
  // it is most likely a programmer error. In this case we throw a very
  // specific error message to try to guide them the right way.
  // For example: https://github.com/Polymer/polymer-bundler/pull/519
  if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
    var message = 'original.line and original.column are not numbers -- you probably meant to omit ' + 'the original mapping entirely and only map the generated position. If so, pass ' + 'null for the original mapping instead of an object with empty or null values.';

    if (this._ignoreInvalidMapping) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn(message);
      }

      return false;
    } else {
      throw new Error(message);
    }
  }

  if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
    // Case 1.
    return;
  } else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
    // Cases 2 and 3.
    return;
  } else {
    var message = 'Invalid mapping: ' + JSON.stringify({
      generated: aGenerated,
      source: aSource,
      original: aOriginal,
      name: aName
    });

    if (this._ignoreInvalidMapping) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn(message);
      }

      return false;
    } else {
      throw new Error(message);
    }
  }
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */


SourceMapGenerator$5.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
  var previousGeneratedColumn = 0;
  var previousGeneratedLine = 1;
  var previousOriginalColumn = 0;
  var previousOriginalLine = 0;
  var previousName = 0;
  var previousSource = 0;
  var result = '';
  var next;
  var mapping;
  var nameIdx;
  var sourceIdx;

  var mappings = this._mappings.toArray();

  for (var i = 0, len = mappings.length; i < len; i++) {
    mapping = mappings[i];
    next = '';

    if (mapping.generatedLine !== previousGeneratedLine) {
      previousGeneratedColumn = 0;

      while (mapping.generatedLine !== previousGeneratedLine) {
        next += ';';
        previousGeneratedLine++;
      }
    } else {
      if (i > 0) {
        if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
          continue;
        }

        next += ',';
      }
    }

    next += base64Vlq.encode(mapping.generatedColumn - previousGeneratedColumn);
    previousGeneratedColumn = mapping.generatedColumn;

    if (mapping.source != null) {
      sourceIdx = this._sources.indexOf(mapping.source);
      next += base64Vlq.encode(sourceIdx - previousSource);
      previousSource = sourceIdx; // lines are stored 0-based in SourceMap spec version 3

      next += base64Vlq.encode(mapping.originalLine - 1 - previousOriginalLine);
      previousOriginalLine = mapping.originalLine - 1;
      next += base64Vlq.encode(mapping.originalColumn - previousOriginalColumn);
      previousOriginalColumn = mapping.originalColumn;

      if (mapping.name != null) {
        nameIdx = this._names.indexOf(mapping.name);
        next += base64Vlq.encode(nameIdx - previousName);
        previousName = nameIdx;
      }
    }

    result += next;
  }

  return result;
};

SourceMapGenerator$5.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
  return aSources.map(function (source) {
    if (!this._sourcesContents) {
      return null;
    }

    if (aSourceRoot != null) {
      source = util.relative(aSourceRoot, source);
    }

    var key = util.toSetString(source);
    return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
  }, this);
};
/**
 * Externalize the source map.
 */


SourceMapGenerator$5.prototype.toJSON = function SourceMapGenerator_toJSON() {
  var map = {
    version: this._version,
    sources: this._sources.toArray(),
    names: this._names.toArray(),
    mappings: this._serializeMappings()
  };

  if (this._file != null) {
    map.file = this._file;
  }

  if (this._sourceRoot != null) {
    map.sourceRoot = this._sourceRoot;
  }

  if (this._sourcesContents) {
    map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
  }

  return map;
};
/**
 * Render the source map being generated to a string.
 */


SourceMapGenerator$5.prototype.toString = function SourceMapGenerator_toString() {
  return JSON.stringify(this.toJSON());
};

var SourceMapGenerator_1 = SourceMapGenerator$5;
var sourceMapGenerator = {
  SourceMapGenerator: SourceMapGenerator_1
};
var binarySearch = createCommonjsModule(function (module, exports) {
  /* -*- Mode: js; js-indent-level: 2; -*- */

  /*
   * Copyright 2011 Mozilla Foundation and contributors
   * Licensed under the New BSD license. See LICENSE or:
   * http://opensource.org/licenses/BSD-3-Clause
   */
  exports.GREATEST_LOWER_BOUND = 1;
  exports.LEAST_UPPER_BOUND = 2;
  /**
   * Recursive implementation of binary search.
   *
   * @param aLow Indices here and lower do not contain the needle.
   * @param aHigh Indices here and higher do not contain the needle.
   * @param aNeedle The element being searched for.
   * @param aHaystack The non-empty array being searched.
   * @param aCompare Function which takes two elements and returns -1, 0, or 1.
   * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
   *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
   *     closest element that is smaller than or greater than the one we are
   *     searching for, respectively, if the exact element cannot be found.
   */

  function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);

    if (cmp === 0) {
      // Found the element we are looking for.
      return mid;
    } else if (cmp > 0) {
      // Our needle is greater than aHaystack[mid].
      if (aHigh - mid > 1) {
        // The element is in the upper half.
        return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
      } // The exact needle element was not found in this haystack. Determine if
      // we are in termination case (3) or (2) and return the appropriate thing.


      if (aBias == exports.LEAST_UPPER_BOUND) {
        return aHigh < aHaystack.length ? aHigh : -1;
      } else {
        return mid;
      }
    } else {
      // Our needle is less than aHaystack[mid].
      if (mid - aLow > 1) {
        // The element is in the lower half.
        return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
      } // we are in termination case (3) or (2) and return the appropriate thing.


      if (aBias == exports.LEAST_UPPER_BOUND) {
        return mid;
      } else {
        return aLow < 0 ? -1 : aLow;
      }
    }
  }
  /**
   * This is an implementation of binary search which will always try and return
   * the index of the closest element if there is no exact hit. This is because
   * mappings between original and generated line/col pairs are single points,
   * and there is an implicit region between each of them, so a miss just means
   * that you aren't on the very start of a region.
   *
   * @param aNeedle The element you are looking for.
   * @param aHaystack The array that is being searched.
   * @param aCompare A function which takes the needle and an element in the
   *     array and returns -1, 0, or 1 depending on whether the needle is less
   *     than, equal to, or greater than the element, respectively.
   * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
   *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
   *     closest element that is smaller than or greater than the one we are
   *     searching for, respectively, if the exact element cannot be found.
   *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
   */


  exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) {
      return -1;
    }

    var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || exports.GREATEST_LOWER_BOUND);

    if (index < 0) {
      return -1;
    } // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.


    while (index - 1 >= 0) {
      if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
        break;
      }

      --index;
    }

    return index;
  };
});
binarySearch.GREATEST_LOWER_BOUND;
binarySearch.LEAST_UPPER_BOUND;
binarySearch.search;
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

function SortTemplate(comparator) {
  /**
   * Swap the elements indexed by `x` and `y` in the array `ary`.
   *
   * @param {Array} ary
   *        The array.
   * @param {Number} x
   *        The index of the first item.
   * @param {Number} y
   *        The index of the second item.
   */
  function swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
  }
  /**
   * Returns a random integer within the range `low .. high` inclusive.
   *
   * @param {Number} low
   *        The lower bound on the range.
   * @param {Number} high
   *        The upper bound on the range.
   */


  function randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
  }
  /**
   * The Quick Sort algorithm.
   *
   * @param {Array} ary
   *        An array to sort.
   * @param {function} comparator
   *        Function to use to compare two items.
   * @param {Number} p
   *        Start index of the array
   * @param {Number} r
   *        End index of the array
   */


  function doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
      // (1) Partitioning.
      //
      // The partitioning chooses a pivot between `p` and `r` and moves all
      // elements that are less than or equal to the pivot to the before it, and
      // all the elements that are greater than it after it. The effect is that
      // once partition is done, the pivot is in the exact place it will be when
      // the array is put in sorted order, and it will not need to be moved
      // again. This runs in O(n) time.
      // Always choose a random pivot so that an input array which is reverse
      // sorted does not cause O(n^2) running time.
      var pivotIndex = randomIntInRange(p, r);
      var i = p - 1;
      swap(ary, pivotIndex, r);
      var pivot = ary[r]; // Immediately after `j` is incremented in this loop, the following hold
      // true:
      //
      //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
      //
      //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.

      for (var j = p; j < r; j++) {
        if (comparator(ary[j], pivot, false) <= 0) {
          i += 1;
          swap(ary, i, j);
        }
      }

      swap(ary, i + 1, j);
      var q = i + 1; // (2) Recurse on each half.

      doQuickSort(ary, comparator, p, q - 1);
      doQuickSort(ary, comparator, q + 1, r);
    }
  }

  return doQuickSort;
}

function cloneSort(comparator) {
  var template = SortTemplate.toString();
  var templateFn = new Function("return ".concat(template))();
  return templateFn(comparator);
}
/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */


var sortCache = new WeakMap();

var quickSort_1 = function quickSort_1(ary, comparator) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var doQuickSort = sortCache.get(comparator);

  if (doQuickSort === void 0) {
    doQuickSort = cloneSort(comparator);
    sortCache.set(comparator, doQuickSort);
  }

  doQuickSort(ary, comparator, start, ary.length - 1);
};

var quickSort$1 = {
  quickSort: quickSort_1
};
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var ArraySet = arraySet.ArraySet;
var quickSort = quickSort$1.quickSort;

function SourceMapConsumer$4(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;

  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}

SourceMapConsumer$4.fromSourceMap = function (aSourceMap, aSourceMapURL) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */


SourceMapConsumer$4.prototype._version = 3; // `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer$4.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer$4.prototype, '_generatedMappings', {
  configurable: true,
  enumerable: true,
  get: function get() {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});
SourceMapConsumer$4.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer$4.prototype, '_originalMappings', {
  configurable: true,
  enumerable: true,
  get: function get() {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer$4.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
  var c = aStr.charAt(index);
  return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */


SourceMapConsumer$4.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  throw new Error("Subclasses must implement _parseMappings");
};

SourceMapConsumer$4.GENERATED_ORDER = 1;
SourceMapConsumer$4.ORIGINAL_ORDER = 2;
SourceMapConsumer$4.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer$4.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */

SourceMapConsumer$4.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
  var context = aContext || null;
  var order = aOrder || SourceMapConsumer$4.GENERATED_ORDER;
  var mappings;

  switch (order) {
    case SourceMapConsumer$4.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;

    case SourceMapConsumer$4.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;

    default:
      throw new Error("Unknown order of iteration.");
  }

  var sourceRoot = this.sourceRoot;
  var boundCallback = aCallback.bind(context);
  var names = this._names;
  var sources = this._sources;
  var sourceMapURL = this._sourceMapURL;

  for (var i = 0, n = mappings.length; i < n; i++) {
    var mapping = mappings[i];
    var source = mapping.source === null ? null : sources.at(mapping.source);

    if (source !== null) {
      source = util.computeSourceURL(sourceRoot, source, sourceMapURL);
    }

    boundCallback({
      source: source,
      generatedLine: mapping.generatedLine,
      generatedColumn: mapping.generatedColumn,
      originalLine: mapping.originalLine,
      originalColumn: mapping.originalColumn,
      name: mapping.name === null ? null : names.at(mapping.name)
    });
  }
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */


SourceMapConsumer$4.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
  var line = util.getArg(aArgs, 'line'); // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
  // returns the index of the closest mapping less than the needle. By
  // setting needle.originalColumn to 0, we thus find the last mapping for
  // the given line, provided such a mapping exists.

  var needle = {
    source: util.getArg(aArgs, 'source'),
    originalLine: line,
    originalColumn: util.getArg(aArgs, 'column', 0)
  };
  needle.source = this._findSourceIndex(needle.source);

  if (needle.source < 0) {
    return [];
  }

  var mappings = [];

  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, binarySearch.LEAST_UPPER_BOUND);

  if (index >= 0) {
    var mapping = this._originalMappings[index];

    if (aArgs.column === undefined) {
      var originalLine = mapping.originalLine; // Iterate until either we run out of mappings, or we run into
      // a mapping for a different line than the one we found. Since
      // mappings are sorted, this is guaranteed to find all mappings for
      // the line we found.

      while (mapping && mapping.originalLine === originalLine) {
        mappings.push({
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        });
        mapping = this._originalMappings[++index];
      }
    } else {
      var originalColumn = mapping.originalColumn; // Iterate until either we run out of mappings, or we run into
      // a mapping for a different line than the one we were searching for.
      // Since mappings are sorted, this is guaranteed to find all mappings for
      // the line we are searching for.

      while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
        mappings.push({
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        });
        mapping = this._originalMappings[++index];
      }
    }
  }

  return mappings;
};

var SourceMapConsumer_1 = SourceMapConsumer$4;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */

function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;

  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sources = util.getArg(sourceMap, 'sources'); // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.

  var names = util.getArg(sourceMap, 'names', []);
  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util.getArg(sourceMap, 'mappings');
  var file = util.getArg(sourceMap, 'file', null); // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  if (sourceRoot) {
    sourceRoot = util.normalize(sourceRoot);
  }

  sources = sources.map(String) // Some source maps produce relative source paths like "./foo.js" instead of
  // "foo.js".  Normalize these first so that future comparisons will succeed.
  // See bugzil.la/1090768.
  .map(util.normalize) // Always ensure that absolute sources are internally stored relative to
  // the source root, if the source root is absolute. Not doing this would
  // be particularly problematic when the source root is a prefix of the
  // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
  .map(function (source) {
    return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
  }); // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.

  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);
  this._absoluteSources = this._sources.toArray().map(function (s) {
    return util.computeSourceURL(sourceRoot, s, aSourceMapURL);
  });
  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this._sourceMapURL = aSourceMapURL;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer$4.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer$4;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */

BasicSourceMapConsumer.prototype._findSourceIndex = function (aSource) {
  var relativeSource = aSource;

  if (this.sourceRoot != null) {
    relativeSource = util.relative(this.sourceRoot, relativeSource);
  }

  if (this._sources.has(relativeSource)) {
    return this._sources.indexOf(relativeSource);
  } // Maybe aSource is an absolute URL as returned by |sources|.  In
  // this case we can't simply undo the transform.


  var i;

  for (i = 0; i < this._absoluteSources.length; ++i) {
    if (this._absoluteSources[i] == aSource) {
      return i;
    }
  }

  return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */


BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
  var smc = Object.create(BasicSourceMapConsumer.prototype);
  var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
  var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
  smc.sourceRoot = aSourceMap._sourceRoot;
  smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
  smc.file = aSourceMap._file;
  smc._sourceMapURL = aSourceMapURL;
  smc._absoluteSources = smc._sources.toArray().map(function (s) {
    return util.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
  }); // Because we are modifying the entries (by converting string sources and
  // names to indices into the sources and names ArraySets), we have to make
  // a copy of the entry or else bad things happen. Shared mutable state
  // strikes again! See github issue #191.

  var generatedMappings = aSourceMap._mappings.toArray().slice();

  var destGeneratedMappings = smc.__generatedMappings = [];
  var destOriginalMappings = smc.__originalMappings = [];

  for (var i = 0, length = generatedMappings.length; i < length; i++) {
    var srcMapping = generatedMappings[i];
    var destMapping = new Mapping();
    destMapping.generatedLine = srcMapping.generatedLine;
    destMapping.generatedColumn = srcMapping.generatedColumn;

    if (srcMapping.source) {
      destMapping.source = sources.indexOf(srcMapping.source);
      destMapping.originalLine = srcMapping.originalLine;
      destMapping.originalColumn = srcMapping.originalColumn;

      if (srcMapping.name) {
        destMapping.name = names.indexOf(srcMapping.name);
      }

      destOriginalMappings.push(destMapping);
    }

    destGeneratedMappings.push(destMapping);
  }

  quickSort(smc.__originalMappings, util.compareByOriginalPositions);
  return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */


BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */

Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function get() {
    return this._absoluteSources.slice();
  }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */

function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */


var compareGenerated = util.compareByGeneratedPositionsDeflatedNoLine;

function sortGenerated(array, start) {
  var l = array.length;
  var n = array.length - start;

  if (n <= 1) {
    return;
  } else if (n == 2) {
    var a = array[start];
    var b = array[start + 1];

    if (compareGenerated(a, b) > 0) {
      array[start] = b;
      array[start + 1] = a;
    }
  } else if (n < 20) {
    for (var i = start; i < l; i++) {
      for (var j = i; j > start; j--) {
        var _a2 = array[j - 1];
        var _b2 = array[j];

        if (compareGenerated(_a2, _b2) <= 0) {
          break;
        }

        array[j - 1] = _b2;
        array[j] = _a2;
      }
    }
  } else {
    quickSort(array, compareGenerated, start);
  }
}

BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  var _ref6;

  var generatedLine = 1;
  var previousGeneratedColumn = 0;
  var previousOriginalLine = 0;
  var previousOriginalColumn = 0;
  var previousSource = 0;
  var previousName = 0;
  var length = aStr.length;
  var index = 0;
  var temp = {};
  var originalMappings = [];
  var generatedMappings = [];
  var mapping, segment, end, value;
  var subarrayStart = 0;

  while (index < length) {
    if (aStr.charAt(index) === ';') {
      generatedLine++;
      index++;
      previousGeneratedColumn = 0;
      sortGenerated(generatedMappings, subarrayStart);
      subarrayStart = generatedMappings.length;
    } else if (aStr.charAt(index) === ',') {
      index++;
    } else {
      mapping = new Mapping();
      mapping.generatedLine = generatedLine;

      for (end = index; end < length; end++) {
        if (this._charIsMappingSeparator(aStr, end)) {
          break;
        }
      }

      aStr.slice(index, end);
      segment = [];

      while (index < end) {
        base64Vlq.decode(aStr, index, temp);
        value = temp.value;
        index = temp.rest;
        segment.push(value);
      }

      if (segment.length === 2) {
        throw new Error('Found a source, but no line and column');
      }

      if (segment.length === 3) {
        throw new Error('Found a source and line, but no column');
      } // Generated column.


      mapping.generatedColumn = previousGeneratedColumn + segment[0];
      previousGeneratedColumn = mapping.generatedColumn;

      if (segment.length > 1) {
        // Original source.
        mapping.source = previousSource + segment[1];
        previousSource += segment[1]; // Original line.

        mapping.originalLine = previousOriginalLine + segment[2];
        previousOriginalLine = mapping.originalLine; // Lines are stored 0-based

        mapping.originalLine += 1; // Original column.

        mapping.originalColumn = previousOriginalColumn + segment[3];
        previousOriginalColumn = mapping.originalColumn;

        if (segment.length > 4) {
          // Original name.
          mapping.name = previousName + segment[4];
          previousName += segment[4];
        }
      }

      generatedMappings.push(mapping);

      if (typeof mapping.originalLine === 'number') {
        var currentSource = mapping.source;

        while (originalMappings.length <= currentSource) {
          originalMappings.push(null);
        }

        if (originalMappings[currentSource] === null) {
          originalMappings[currentSource] = [];
        }

        originalMappings[currentSource].push(mapping);
      }
    }
  }

  sortGenerated(generatedMappings, subarrayStart);
  this.__generatedMappings = generatedMappings;

  for (var i = 0; i < originalMappings.length; i++) {
    if (originalMappings[i] != null) {
      quickSort(originalMappings[i], util.compareByOriginalPositionsNoSource);
    }
  }

  this.__originalMappings = (_ref6 = []).concat.apply(_ref6, originalMappings);
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */


BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
  // To return the position we are searching for, we must first find the
  // mapping for the given position and then return the opposite position it
  // points to. Because the mappings are sorted, we can use binary search to
  // find the best mapping.
  if (aNeedle[aLineName] <= 0) {
    throw new TypeError('Line must be greater than or equal to 1, got ' + aNeedle[aLineName]);
  }

  if (aNeedle[aColumnName] < 0) {
    throw new TypeError('Column must be greater than or equal to 0, got ' + aNeedle[aColumnName]);
  }

  return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */


BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
  for (var index = 0; index < this._generatedMappings.length; ++index) {
    var mapping = this._generatedMappings[index]; // Mappings do not contain a field for the last generated columnt. We
    // can come up with an optimistic estimate, however, by assuming that
    // mappings are contiguous (i.e. given two consecutive mappings, the
    // first mapping ends where the second one starts).

    if (index + 1 < this._generatedMappings.length) {
      var nextMapping = this._generatedMappings[index + 1];

      if (mapping.generatedLine === nextMapping.generatedLine) {
        mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
        continue;
      }
    } // The last mapping for each line spans the entire line.


    mapping.lastGeneratedColumn = Infinity;
  }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */


BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
  var needle = {
    generatedLine: util.getArg(aArgs, 'line'),
    generatedColumn: util.getArg(aArgs, 'column')
  };

  var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", util.compareByGeneratedPositionsDeflated, util.getArg(aArgs, 'bias', SourceMapConsumer$4.GREATEST_LOWER_BOUND));

  if (index >= 0) {
    var mapping = this._generatedMappings[index];

    if (mapping.generatedLine === needle.generatedLine) {
      var source = util.getArg(mapping, 'source', null);

      if (source !== null) {
        source = this._sources.at(source);
        source = util.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
      }

      var name = util.getArg(mapping, 'name', null);

      if (name !== null) {
        name = this._names.at(name);
      }

      return {
        source: source,
        line: util.getArg(mapping, 'originalLine', null),
        column: util.getArg(mapping, 'originalColumn', null),
        name: name
      };
    }
  }

  return {
    source: null,
    line: null,
    column: null,
    name: null
  };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */


BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
  if (!this.sourcesContent) {
    return false;
  }

  return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function (sc) {
    return sc == null;
  });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */


BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
  if (!this.sourcesContent) {
    return null;
  }

  var index = this._findSourceIndex(aSource);

  if (index >= 0) {
    return this.sourcesContent[index];
  }

  var relativeSource = aSource;

  if (this.sourceRoot != null) {
    relativeSource = util.relative(this.sourceRoot, relativeSource);
  }

  var url;

  if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
    // XXX: file:// URIs and absolute paths lead to unexpected behavior for
    // many users. We can help them out when they expect file:// URIs to
    // behave like it would if they were running a local HTTP server. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
    var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");

    if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
      return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
    }

    if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) {
      return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
  } // This function is used recursively from
  // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
  // don't want to throw if we can't find the source - we just want to
  // return null, so we provide a flag to exit gracefully.


  if (nullOnMissing) {
    return null;
  } else {
    throw new Error('"' + relativeSource + '" is not in the SourceMap.');
  }
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */


BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
  var source = util.getArg(aArgs, 'source');
  source = this._findSourceIndex(source);

  if (source < 0) {
    return {
      line: null,
      column: null,
      lastColumn: null
    };
  }

  var needle = {
    source: source,
    originalLine: util.getArg(aArgs, 'line'),
    originalColumn: util.getArg(aArgs, 'column')
  };

  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, util.getArg(aArgs, 'bias', SourceMapConsumer$4.GREATEST_LOWER_BOUND));

  if (index >= 0) {
    var mapping = this._originalMappings[index];

    if (mapping.source === needle.source) {
      return {
        line: util.getArg(mapping, 'generatedLine', null),
        column: util.getArg(mapping, 'generatedColumn', null),
        lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
      };
    }
  }

  return {
    line: null,
    column: null,
    lastColumn: null
  };
};

var BasicSourceMapConsumer_1 = BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */

function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;

  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sections = util.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new ArraySet();
  this._names = new ArraySet();
  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }

    var offset = util.getArg(s, 'offset');
    var offsetLine = util.getArg(offset, 'line');
    var offsetColumn = util.getArg(offset, 'column');

    if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }

    lastOffset = offset;
    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer$4(util.getArg(s, 'map'), aSourceMapURL)
    };
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer$4.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer$4;
/**
 * The version of the source mapping spec that we are consuming.
 */

IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */

Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function get() {
    var sources = [];

    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }

    return sources;
  }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */

IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
  var needle = {
    generatedLine: util.getArg(aArgs, 'line'),
    generatedColumn: util.getArg(aArgs, 'column')
  }; // Find the section containing the generated position we're trying to map
  // to an original position.

  var sectionIndex = binarySearch.search(needle, this._sections, function (needle, section) {
    var cmp = needle.generatedLine - section.generatedOffset.generatedLine;

    if (cmp) {
      return cmp;
    }

    return needle.generatedColumn - section.generatedOffset.generatedColumn;
  });
  var section = this._sections[sectionIndex];

  if (!section) {
    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  }

  return section.consumer.originalPositionFor({
    line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
    column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
    bias: aArgs.bias
  });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */


IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
  return this._sections.every(function (s) {
    return s.consumer.hasContentsOfAllSources();
  });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */


IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i];
    var content = section.consumer.sourceContentFor(aSource, true);

    if (content || content === '') {
      return content;
    }
  }

  if (nullOnMissing) {
    return null;
  } else {
    throw new Error('"' + aSource + '" is not in the SourceMap.');
  }
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */


IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i]; // Only consider this section if the requested source is in the list of
    // sources of the consumer.

    if (section.consumer._findSourceIndex(util.getArg(aArgs, 'source')) === -1) {
      continue;
    }

    var generatedPosition = section.consumer.generatedPositionFor(aArgs);

    if (generatedPosition) {
      var ret = {
        line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
        column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
      };
      return ret;
    }
  }

  return {
    line: null,
    column: null
  };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */


IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
  this.__generatedMappings = [];
  this.__originalMappings = [];

  for (var i = 0; i < this._sections.length; i++) {
    var section = this._sections[i];
    var sectionMappings = section.consumer._generatedMappings;

    for (var j = 0; j < sectionMappings.length; j++) {
      var mapping = sectionMappings[j];

      var source = section.consumer._sources.at(mapping.source);

      if (source !== null) {
        source = util.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
      }

      this._sources.add(source);

      source = this._sources.indexOf(source);
      var name = null;

      if (mapping.name) {
        name = section.consumer._names.at(mapping.name);

        this._names.add(name);

        name = this._names.indexOf(name);
      } // The mappings coming from the consumer for the section have
      // generated positions relative to the start of the section, so we
      // need to offset them to be relative to the start of the concatenated
      // generated file.


      var adjustedMapping = {
        source: source,
        generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
        generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: name
      };

      this.__generatedMappings.push(adjustedMapping);

      if (typeof adjustedMapping.originalLine === 'number') {
        this.__originalMappings.push(adjustedMapping);
      }
    }
  }

  quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
  quickSort(this.__originalMappings, util.compareByOriginalPositions);
};

var IndexedSourceMapConsumer_1 = IndexedSourceMapConsumer;
var sourceMapConsumer = {
  SourceMapConsumer: SourceMapConsumer_1,
  BasicSourceMapConsumer: BasicSourceMapConsumer_1,
  IndexedSourceMapConsumer: IndexedSourceMapConsumer_1
};
/* -*- Mode: js; js-indent-level: 2; -*- */

/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator$4 = sourceMapGenerator.SourceMapGenerator; // Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).

var REGEX_NEWLINE = /(\r?\n)/; // Newline character code for charCodeAt() comparisons

var NEWLINE_CODE = 10; // Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!

var isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */

function SourceNode$1(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */


SourceNode$1.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
  // The SourceNode we want to fill with the generated code
  // and the SourceMap
  var node = new SourceNode$1(); // All even indices of this array are one line of the generated code,
  // while all odd indices are the newlines between two adjacent lines
  // (since `REGEX_NEWLINE` captures its match).
  // Processed fragments are accessed by calling `shiftNextLine`.

  var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
  var remainingLinesIndex = 0;

  var shiftNextLine = function shiftNextLine() {
    var lineContents = getNextLine(); // The last line of a file might not have a newline.

    var newLine = getNextLine() || "";
    return lineContents + newLine;

    function getNextLine() {
      return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
    }
  }; // We need to remember the position of "remainingLines"


  var lastGeneratedLine = 1,
      lastGeneratedColumn = 0; // The generate SourceNodes we need a code range.
  // To extract it current and last mapping is used.
  // Here we store the last mapping.

  var lastMapping = null;
  aSourceMapConsumer.eachMapping(function (mapping) {
    if (lastMapping !== null) {
      // We add the code from "lastMapping" to "mapping":
      // First check if there is a new line in between.
      if (lastGeneratedLine < mapping.generatedLine) {
        // Associate first line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        lastGeneratedLine++;
        lastGeneratedColumn = 0; // The remaining code is added without mapping
      } else {
        // There is no new line in between.
        // Associate the code between "lastGeneratedColumn" and
        // "mapping.generatedColumn" with "lastMapping"
        var nextLine = remainingLines[remainingLinesIndex] || '';
        var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
        addMappingWithCode(lastMapping, code); // No more remaining code, continue

        lastMapping = mapping;
        return;
      }
    } // We add the generated code until the first mapping
    // to the SourceNode without any mapping.
    // Each line is added as separate string.


    while (lastGeneratedLine < mapping.generatedLine) {
      node.add(shiftNextLine());
      lastGeneratedLine++;
    }

    if (lastGeneratedColumn < mapping.generatedColumn) {
      var nextLine = remainingLines[remainingLinesIndex] || '';
      node.add(nextLine.substr(0, mapping.generatedColumn));
      remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
      lastGeneratedColumn = mapping.generatedColumn;
    }

    lastMapping = mapping;
  }, this); // We have processed all mappings.

  if (remainingLinesIndex < remainingLines.length) {
    if (lastMapping) {
      // Associate the remaining code in the current line with "lastMapping"
      addMappingWithCode(lastMapping, shiftNextLine());
    } // and add the remaining lines without any mapping


    node.add(remainingLines.splice(remainingLinesIndex).join(""));
  } // Copy sourcesContent into SourceNode


  aSourceMapConsumer.sources.forEach(function (sourceFile) {
    var content = aSourceMapConsumer.sourceContentFor(sourceFile);

    if (content != null) {
      if (aRelativePath != null) {
        sourceFile = util.join(aRelativePath, sourceFile);
      }

      node.setSourceContent(sourceFile, content);
    }
  });
  return node;

  function addMappingWithCode(mapping, code) {
    if (mapping === null || mapping.source === undefined) {
      node.add(code);
    } else {
      var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
      node.add(new SourceNode$1(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
    }
  }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */


SourceNode$1.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  } else {
    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
  }

  return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */


SourceNode$1.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length - 1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  } else {
    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
  }

  return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */


SourceNode$1.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;

  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];

    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    } else {
      if (chunk !== '') {
        aFn(chunk, {
          source: this.source,
          line: this.line,
          column: this.column,
          name: this.name
        });
      }
    }
  }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */


SourceNode$1.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;

  if (len > 0) {
    newChildren = [];

    for (i = 0; i < len - 1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }

    newChildren.push(this.children[i]);
    this.children = newChildren;
  }

  return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */


SourceNode$1.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];

  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  } else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  } else {
    this.children.push(''.replace(aPattern, aReplacement));
  }

  return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */


SourceNode$1.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
  this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */


SourceNode$1.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
  for (var i = 0, len = this.children.length; i < len; i++) {
    if (this.children[i][isSourceNode]) {
      this.children[i].walkSourceContents(aFn);
    }
  }

  var sources = Object.keys(this.sourceContents);

  for (var i = 0, len = sources.length; i < len; i++) {
    aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
  }
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */


SourceNode$1.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */


SourceNode$1.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator$4(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;

    if (original.source !== null && original.line !== null && original.column !== null) {
      if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }

      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }

    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0; // Mappings end at eol

        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });
  return {
    code: generated.code,
    map: map
  };
};

var SourceNode_1 = SourceNode$1;
var sourceNode = {
  SourceNode: SourceNode_1
};
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator$3 = sourceMapGenerator.SourceMapGenerator;
var SourceMapConsumer$3 = sourceMapConsumer.SourceMapConsumer;
var SourceNode = sourceNode.SourceNode;
var sourceMap = {
  SourceMapGenerator: SourceMapGenerator$3,
  SourceMapConsumer: SourceMapConsumer$3,
  SourceNode: SourceNode
};
var existsSync = fs.existsSync,
    readFileSync = fs.readFileSync;
var dirname$1 = path.dirname,
    join = path.join;
var SourceMapConsumer$2 = sourceMap.SourceMapConsumer,
    SourceMapGenerator$2 = sourceMap.SourceMapGenerator;

function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, 'base64').toString();
  } else {
    /* c8 ignore next 2 */
    return window.atob(str);
  }
}

var PreviousMap = /*#__PURE__*/function () {
  function PreviousMap(css, opts) {
    _classCallCheck2(this, PreviousMap);

    if (opts.map === false) return;
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, 'data:');
    var prev = opts.map ? opts.map.prev : undefined;
    var text = this.loadMap(opts.from, prev);

    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }

    if (this.mapFile) this.root = dirname$1(this.mapFile);
    if (text) this.text = text;
  }

  _createClass2(PreviousMap, [{
    key: "consumer",
    value: function consumer() {
      if (!this.consumerCache) {
        this.consumerCache = new SourceMapConsumer$2(this.text);
      }

      return this.consumerCache;
    }
  }, {
    key: "decodeInline",
    value: function decodeInline(text) {
      var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
      var baseUri = /^data:application\/json;base64,/;
      var charsetUri = /^data:application\/json;charset=utf-?8,/;
      var uri = /^data:application\/json,/;
      var uriMatch = text.match(charsetUri) || text.match(uri);

      if (uriMatch) {
        return decodeURIComponent(text.substr(uriMatch[0].length));
      }

      var baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);

      if (baseUriMatch) {
        return fromBase64(text.substr(baseUriMatch[0].length));
      }

      var encoding = text.match(/data:application\/json;([^,]+),/)[1];
      throw new Error('Unsupported source map encoding ' + encoding);
    }
  }, {
    key: "getAnnotationURL",
    value: function getAnnotationURL(sourceMapString) {
      return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
    }
  }, {
    key: "isMap",
    value: function isMap(map) {
      if (_typeof2(map) !== 'object') return false;
      return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
    }
  }, {
    key: "loadAnnotation",
    value: function loadAnnotation(css) {
      var comments = css.match(/\/\*\s*# sourceMappingURL=/g);
      if (!comments) return; // sourceMappingURLs from comments, strings, etc.

      var start = css.lastIndexOf(comments.pop());
      var end = css.indexOf('*/', start);

      if (start > -1 && end > -1) {
        // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
      }
    }
  }, {
    key: "loadFile",
    value: function loadFile(path) {
      this.root = dirname$1(path);

      if (existsSync(path)) {
        this.mapFile = path;
        return readFileSync(path, 'utf-8').toString().trim();
      }
    }
  }, {
    key: "loadMap",
    value: function loadMap(file, prev) {
      if (prev === false) return false;

      if (prev) {
        if (typeof prev === 'string') {
          return prev;
        } else if (typeof prev === 'function') {
          var prevPath = prev(file);

          if (prevPath) {
            var map = this.loadFile(prevPath);

            if (!map) {
              throw new Error('Unable to load previous source map: ' + prevPath.toString());
            }

            return map;
          }
        } else if (prev instanceof SourceMapConsumer$2) {
          return SourceMapGenerator$2.fromSourceMap(prev).toString();
        } else if (prev instanceof SourceMapGenerator$2) {
          return prev.toString();
        } else if (this.isMap(prev)) {
          return JSON.stringify(prev);
        } else {
          throw new Error('Unsupported previous source map format: ' + prev.toString());
        }
      } else if (this.inline) {
        return this.decodeInline(this.annotation);
      } else if (this.annotation) {
        var _map = this.annotation;
        if (file) _map = join(dirname$1(file), _map);
        return this.loadFile(_map);
      }
    }
  }, {
    key: "startWith",
    value: function startWith(string, start) {
      if (!string) return false;
      return string.substr(0, start.length) === start;
    }
  }, {
    key: "withContent",
    value: function withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }]);

  return PreviousMap;
}();

var previousMap = PreviousMap;
PreviousMap.default = PreviousMap;
var nanoid = nonSecure.nanoid;
var isAbsolute = path.isAbsolute,
    resolve$1 = path.resolve;
var SourceMapConsumer$1 = sourceMap.SourceMapConsumer,
    SourceMapGenerator$1 = sourceMap.SourceMapGenerator;
var fileURLToPath = url.fileURLToPath,
    pathToFileURL$1 = url.pathToFileURL;
var fromOffsetCache = Symbol('fromOffsetCache');
var sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
var pathAvailable$1 = Boolean(resolve$1 && isAbsolute);

var Input = /*#__PURE__*/function () {
  function Input(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, Input);

    if (css === null || typeof css === 'undefined' || _typeof2(css) === 'object' && !css.toString) {
      throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
    }

    this.css = css.toString();

    if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    this.document = this.css;
    if (opts.document) this.document = opts.document.toString();

    if (opts.from) {
      if (!pathAvailable$1 || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve$1(opts.from);
      }
    }

    if (pathAvailable$1 && sourceMapAvailable$1) {
      var map = new previousMap(this.css, opts);

      if (map.text) {
        this.map = map;
        var file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }

    if (!this.file) {
      this.id = '<input css ' + nanoid(6) + '>';
    }

    if (this.map) this.map.file = this.from;
  }

  _createClass2(Input, [{
    key: "from",
    get: function get() {
      return this.file || this.id;
    }
  }, {
    key: "error",
    value: function error(message, line, column) {
      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var endColumn, endLine, result;

      if (line && _typeof2(line) === 'object') {
        var start = line;
        var end = column;

        if (typeof start.offset === 'number') {
          var pos = this.fromOffset(start.offset);
          line = pos.line;
          column = pos.col;
        } else {
          line = start.line;
          column = start.column;
        }

        if (typeof end.offset === 'number') {
          var _pos = this.fromOffset(end.offset);

          endLine = _pos.line;
          endColumn = _pos.col;
        } else {
          endLine = end.line;
          endColumn = end.column;
        }
      } else if (!column) {
        var _pos2 = this.fromOffset(line);

        line = _pos2.line;
        column = _pos2.col;
      }

      var origin = this.origin(line, column, endLine, endColumn);

      if (origin) {
        result = new cssSyntaxError(message, origin.endLine === undefined ? origin.line : {
          column: origin.column,
          line: origin.line
        }, origin.endLine === undefined ? origin.column : {
          column: origin.endColumn,
          line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
      } else {
        result = new cssSyntaxError(message, endLine === undefined ? line : {
          column: column,
          line: line
        }, endLine === undefined ? column : {
          column: endColumn,
          line: endLine
        }, this.css, this.file, opts.plugin);
      }

      result.input = {
        column: column,
        endColumn: endColumn,
        endLine: endLine,
        line: line,
        source: this.css
      };

      if (this.file) {
        if (pathToFileURL$1) {
          result.input.url = pathToFileURL$1(this.file).toString();
        }

        result.input.file = this.file;
      }

      return result;
    }
  }, {
    key: "fromOffset",
    value: function fromOffset(offset) {
      var lastLine, lineToIndex;

      if (!this[fromOffsetCache]) {
        var lines = this.css.split('\n');
        lineToIndex = new Array(lines.length);
        var prevIndex = 0;

        for (var i = 0, l = lines.length; i < l; i++) {
          lineToIndex[i] = prevIndex;
          prevIndex += lines[i].length + 1;
        }

        this[fromOffsetCache] = lineToIndex;
      } else {
        lineToIndex = this[fromOffsetCache];
      }

      lastLine = lineToIndex[lineToIndex.length - 1];
      var min = 0;

      if (offset >= lastLine) {
        min = lineToIndex.length - 1;
      } else {
        var max = lineToIndex.length - 2;
        var mid;

        while (min < max) {
          mid = min + (max - min >> 1);

          if (offset < lineToIndex[mid]) {
            max = mid - 1;
          } else if (offset >= lineToIndex[mid + 1]) {
            min = mid + 1;
          } else {
            min = mid;
            break;
          }
        }
      }

      return {
        col: offset - lineToIndex[min] + 1,
        line: min + 1
      };
    }
  }, {
    key: "mapResolve",
    value: function mapResolve(file) {
      if (/^\w+:\/\//.test(file)) {
        return file;
      }

      return resolve$1(this.map.consumer().sourceRoot || this.map.root || '.', file);
    }
  }, {
    key: "origin",
    value: function origin(line, column, endLine, endColumn) {
      if (!this.map) return false;
      var consumer = this.map.consumer();
      var from = consumer.originalPositionFor({
        column: column,
        line: line
      });
      if (!from.source) return false;
      var to;

      if (typeof endLine === 'number') {
        to = consumer.originalPositionFor({
          column: endColumn,
          line: endLine
        });
      }

      var fromUrl;

      if (isAbsolute(from.source)) {
        fromUrl = pathToFileURL$1(from.source);
      } else {
        fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile));
      }

      var result = {
        column: from.column,
        endColumn: to && to.column,
        endLine: to && to.line,
        line: from.line,
        url: fromUrl.toString()
      };

      if (fromUrl.protocol === 'file:') {
        if (fileURLToPath) {
          result.file = fileURLToPath(fromUrl);
        } else {
          /* c8 ignore next 2 */
          throw new Error("file: protocol is not available in this PostCSS build");
        }
      }

      var source = consumer.sourceContentFor(from.source);
      if (source) result.source = source;
      return result;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};

      for (var _i5 = 0, _arr2 = ['hasBOM', 'css', 'file', 'id']; _i5 < _arr2.length; _i5++) {
        var _name5 = _arr2[_i5];

        if (this[_name5] != null) {
          json[_name5] = this[_name5];
        }
      }

      if (this.map) {
        json.map = _objectSpread({}, this.map);

        if (json.map.consumerCache) {
          json.map.consumerCache = undefined;
        }
      }

      return json;
    }
  }]);

  return Input;
}();

var input = Input;
Input.default = Input;

if (terminalHighlight_1 && terminalHighlight_1.registerInput) {
  terminalHighlight_1.registerInput(Input);
}

var LazyResult$1, Processor$1;

var Root = /*#__PURE__*/function (_container3) {
  _inherits2(Root, _container3);

  var _super16 = _createSuper2(Root);

  function Root(defaults) {
    var _this22;

    _classCallCheck2(this, Root);

    _this22 = _super16.call(this, defaults);
    _this22.type = 'root';
    if (!_this22.nodes) _this22.nodes = [];
    return _this22;
  }

  _createClass2(Root, [{
    key: "normalize",
    value: function normalize(child, sample, type) {
      var nodes = _get(_getPrototypeOf2(Root.prototype), "normalize", this).call(this, child);

      if (sample) {
        if (type === 'prepend') {
          if (this.nodes.length > 1) {
            sample.raws.before = this.nodes[1].raws.before;
          } else {
            delete sample.raws.before;
          }
        } else if (this.first !== sample) {
          var _iterator14 = _createForOfIteratorHelper(nodes),
              _step14;

          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _node15 = _step14.value;
              _node15.raws.before = sample.raws.before;
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        }
      }

      return nodes;
    }
  }, {
    key: "removeChild",
    value: function removeChild(child, ignore) {
      var index = this.index(child);

      if (!ignore && index === 0 && this.nodes.length > 1) {
        this.nodes[1].raws.before = this.nodes[index].raws.before;
      }

      return _get(_getPrototypeOf2(Root.prototype), "removeChild", this).call(this, child);
    }
  }, {
    key: "toResult",
    value: function toResult() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var lazy = new LazyResult$1(new Processor$1(), this, opts);
      return lazy.stringify();
    }
  }]);

  return Root;
}(container);

Root.registerLazyResult = function (dependant) {
  LazyResult$1 = dependant;
};

Root.registerProcessor = function (dependant) {
  Processor$1 = dependant;
};

var root = Root;
Root.default = Root;
container.registerRoot(Root);
var list = {
  comma: function comma(string) {
    return list.split(string, [','], true);
  },
  space: function space(string) {
    var spaces = [' ', '\n', '\t'];
    return list.split(string, spaces);
  },
  split: function split(string, separators, last) {
    var array = [];
    var current = '';
    var split = false;
    var func = 0;
    var inQuote = false;
    var prevQuote = '';
    var escape = false;

    var _iterator15 = _createForOfIteratorHelper(string),
        _step15;

    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var letter = _step15.value;

        if (escape) {
          escape = false;
        } else if (letter === '\\') {
          escape = true;
        } else if (inQuote) {
          if (letter === prevQuote) {
            inQuote = false;
          }
        } else if (letter === '"' || letter === "'") {
          inQuote = true;
          prevQuote = letter;
        } else if (letter === '(') {
          func += 1;
        } else if (letter === ')') {
          if (func > 0) func -= 1;
        } else if (func === 0) {
          if (separators.includes(letter)) split = true;
        }

        if (split) {
          if (current !== '') array.push(current.trim());
          current = '';
          split = false;
        } else {
          current += letter;
        }
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }

    if (last || current !== '') array.push(current.trim());
    return array;
  }
};
var list_1 = list;
list.default = list;

var Rule = /*#__PURE__*/function (_container4) {
  _inherits2(Rule, _container4);

  var _super17 = _createSuper2(Rule);

  function Rule(defaults) {
    var _this23;

    _classCallCheck2(this, Rule);

    _this23 = _super17.call(this, defaults);
    _this23.type = 'rule';
    if (!_this23.nodes) _this23.nodes = [];
    return _this23;
  }

  _createClass2(Rule, [{
    key: "selectors",
    get: function get() {
      return list_1.comma(this.selector);
    },
    set: function set(values) {
      var match = this.selector ? this.selector.match(/,\s*/) : null;
      var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
      this.selector = values.join(sep);
    }
  }]);

  return Rule;
}(container);

var _rule = Rule;
Rule.default = Rule;
container.registerRule(Rule);

function fromJSON(json, inputs) {
  if (Array.isArray(json)) return json.map(function (n) {
    return fromJSON(n);
  });

  var ownInputs = json.inputs,
      defaults = _objectWithoutProperties(json, _excluded);

  if (ownInputs) {
    inputs = [];

    var _iterator16 = _createForOfIteratorHelper(ownInputs),
        _step16;

    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var input$1 = _step16.value;

        var inputHydrated = _objectSpread(_objectSpread({}, input$1), {}, {
          __proto__: input.prototype
        });

        if (inputHydrated.map) {
          inputHydrated.map = _objectSpread(_objectSpread({}, inputHydrated.map), {}, {
            __proto__: previousMap.prototype
          });
        }

        inputs.push(inputHydrated);
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
  }

  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(function (n) {
      return fromJSON(n, inputs);
    });
  }

  if (defaults.source) {
    var _defaults$source = defaults.source,
        inputId = _defaults$source.inputId,
        source = _objectWithoutProperties(_defaults$source, _excluded2);

    defaults.source = source;

    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }

  if (defaults.type === 'root') {
    return new root(defaults);
  } else if (defaults.type === 'decl') {
    return new declaration(defaults);
  } else if (defaults.type === 'rule') {
    return new _rule(defaults);
  } else if (defaults.type === 'comment') {
    return new _comment(defaults);
  } else if (defaults.type === 'atrule') {
    return new atRule(defaults);
  } else {
    throw new Error('Unknown node type: ' + json.type);
  }
}

var fromJSON_1 = fromJSON;
fromJSON.default = fromJSON;
var dirname = path.dirname,
    relative = path.relative,
    resolve = path.resolve,
    sep = path.sep;
var SourceMapConsumer = sourceMap.SourceMapConsumer,
    SourceMapGenerator = sourceMap.SourceMapGenerator;
var pathToFileURL = url.pathToFileURL;
var sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
var pathAvailable = Boolean(dirname && resolve && relative && sep);

var MapGenerator = /*#__PURE__*/function () {
  function MapGenerator(stringify, root, opts, cssString) {
    _classCallCheck2(this, MapGenerator);

    this.stringify = stringify;
    this.mapOpts = opts.map || {};
    this.root = root;
    this.opts = opts;
    this.css = cssString;
    this.originalCSS = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    this.memoizedFileURLs = new Map();
    this.memoizedPaths = new Map();
    this.memoizedURLs = new Map();
  }

  _createClass2(MapGenerator, [{
    key: "addAnnotation",
    value: function addAnnotation() {
      var content;

      if (this.isInline()) {
        content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
      } else if (typeof this.mapOpts.annotation === 'string') {
        content = this.mapOpts.annotation;
      } else if (typeof this.mapOpts.annotation === 'function') {
        content = this.mapOpts.annotation(this.opts.to, this.root);
      } else {
        content = this.outputFile() + '.map';
      }

      var eol = '\n';
      if (this.css.includes('\r\n')) eol = '\r\n';
      this.css += eol + '/*# sourceMappingURL=' + content + ' */';
    }
  }, {
    key: "applyPrevMaps",
    value: function applyPrevMaps() {
      var _iterator17 = _createForOfIteratorHelper(this.previous()),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var prev = _step17.value;
          var from = this.toUrl(this.path(prev.file));

          var _root = prev.root || dirname(prev.file);

          var map = void 0;

          if (this.mapOpts.sourcesContent === false) {
            map = new SourceMapConsumer(prev.text);

            if (map.sourcesContent) {
              map.sourcesContent = null;
            }
          } else {
            map = prev.consumer();
          }

          this.map.applySourceMap(map, from, this.toUrl(this.path(_root)));
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "clearAnnotation",
    value: function clearAnnotation() {
      if (this.mapOpts.annotation === false) return;

      if (this.root) {
        var _node16;

        for (var i = this.root.nodes.length - 1; i >= 0; i--) {
          _node16 = this.root.nodes[i];
          if (_node16.type !== 'comment') continue;

          if (_node16.text.startsWith('# sourceMappingURL=')) {
            this.root.removeChild(i);
          }
        }
      } else if (this.css) {
        this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, '');
      }
    }
  }, {
    key: "generate",
    value: function generate() {
      this.clearAnnotation();

      if (pathAvailable && sourceMapAvailable && this.isMap()) {
        return this.generateMap();
      } else {
        var _result = '';
        this.stringify(this.root, function (i) {
          _result += i;
        });
        return [_result];
      }
    }
  }, {
    key: "generateMap",
    value: function generateMap() {
      if (this.root) {
        this.generateString();
      } else if (this.previous().length === 1) {
        var prev = this.previous()[0].consumer();
        prev.file = this.outputFile();
        this.map = SourceMapGenerator.fromSourceMap(prev, {
          ignoreInvalidMapping: true
        });
      } else {
        this.map = new SourceMapGenerator({
          file: this.outputFile(),
          ignoreInvalidMapping: true
        });
        this.map.addMapping({
          generated: {
            column: 0,
            line: 1
          },
          original: {
            column: 0,
            line: 1
          },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
        });
      }

      if (this.isSourcesContent()) this.setSourcesContent();
      if (this.root && this.previous().length > 0) this.applyPrevMaps();
      if (this.isAnnotation()) this.addAnnotation();

      if (this.isInline()) {
        return [this.css];
      } else {
        return [this.css, this.map];
      }
    }
  }, {
    key: "generateString",
    value: function generateString() {
      var _this24 = this;

      this.css = '';
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      var line = 1;
      var column = 1;
      var noSource = '<no source>';
      var mapping = {
        generated: {
          column: 0,
          line: 0
        },
        original: {
          column: 0,
          line: 0
        },
        source: ''
      };
      var last, lines;
      this.stringify(this.root, function (str, node, type) {
        _this24.css += str;

        if (node && type !== 'end') {
          mapping.generated.line = line;
          mapping.generated.column = column - 1;

          if (node.source && node.source.start) {
            mapping.source = _this24.sourcePath(node);
            mapping.original.line = node.source.start.line;
            mapping.original.column = node.source.start.column - 1;

            _this24.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;

            _this24.map.addMapping(mapping);
          }
        }

        lines = str.match(/\n/g);

        if (lines) {
          line += lines.length;
          last = str.lastIndexOf('\n');
          column = str.length - last;
        } else {
          column += str.length;
        }

        if (node && type !== 'start') {
          var _p = node.parent || {
            raws: {}
          };

          var childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;

          if (!childless || node !== _p.last || _p.raws.semicolon) {
            if (node.source && node.source.end) {
              mapping.source = _this24.sourcePath(node);
              mapping.original.line = node.source.end.line;
              mapping.original.column = node.source.end.column - 1;
              mapping.generated.line = line;
              mapping.generated.column = column - 2;

              _this24.map.addMapping(mapping);
            } else {
              mapping.source = noSource;
              mapping.original.line = 1;
              mapping.original.column = 0;
              mapping.generated.line = line;
              mapping.generated.column = column - 1;

              _this24.map.addMapping(mapping);
            }
          }
        }
      });
    }
  }, {
    key: "isAnnotation",
    value: function isAnnotation() {
      if (this.isInline()) {
        return true;
      }

      if (typeof this.mapOpts.annotation !== 'undefined') {
        return this.mapOpts.annotation;
      }

      if (this.previous().length) {
        return this.previous().some(function (i) {
          return i.annotation;
        });
      }

      return true;
    }
  }, {
    key: "isInline",
    value: function isInline() {
      if (typeof this.mapOpts.inline !== 'undefined') {
        return this.mapOpts.inline;
      }

      var annotation = this.mapOpts.annotation;

      if (typeof annotation !== 'undefined' && annotation !== true) {
        return false;
      }

      if (this.previous().length) {
        return this.previous().some(function (i) {
          return i.inline;
        });
      }

      return true;
    }
  }, {
    key: "isMap",
    value: function isMap() {
      if (typeof this.opts.map !== 'undefined') {
        return !!this.opts.map;
      }

      return this.previous().length > 0;
    }
  }, {
    key: "isSourcesContent",
    value: function isSourcesContent() {
      if (typeof this.mapOpts.sourcesContent !== 'undefined') {
        return this.mapOpts.sourcesContent;
      }

      if (this.previous().length) {
        return this.previous().some(function (i) {
          return i.withContent();
        });
      }

      return true;
    }
  }, {
    key: "outputFile",
    value: function outputFile() {
      if (this.opts.to) {
        return this.path(this.opts.to);
      } else if (this.opts.from) {
        return this.path(this.opts.from);
      } else {
        return 'to.css';
      }
    }
  }, {
    key: "path",
    value: function path(file) {
      if (this.mapOpts.absolute) return file;
      if (file.charCodeAt(0) === 60
      /* `<` */
      ) return file;
      if (/^\w+:\/\//.test(file)) return file;
      var cached = this.memoizedPaths.get(file);
      if (cached) return cached;
      var from = this.opts.to ? dirname(this.opts.to) : '.';

      if (typeof this.mapOpts.annotation === 'string') {
        from = dirname(resolve(from, this.mapOpts.annotation));
      }

      var path = relative(from, file);
      this.memoizedPaths.set(file, path);
      return path;
    }
  }, {
    key: "previous",
    value: function previous() {
      var _this25 = this;

      if (!this.previousMaps) {
        this.previousMaps = [];

        if (this.root) {
          this.root.walk(function (node) {
            if (node.source && node.source.input.map) {
              var map = node.source.input.map;

              if (!_this25.previousMaps.includes(map)) {
                _this25.previousMaps.push(map);
              }
            }
          });
        } else {
          var input$1 = new input(this.originalCSS, this.opts);
          if (input$1.map) this.previousMaps.push(input$1.map);
        }
      }

      return this.previousMaps;
    }
  }, {
    key: "setSourcesContent",
    value: function setSourcesContent() {
      var _this26 = this;

      var already = {};

      if (this.root) {
        this.root.walk(function (node) {
          if (node.source) {
            var from = node.source.input.from;

            if (from && !already[from]) {
              already[from] = true;
              var fromUrl = _this26.usesFileUrls ? _this26.toFileUrl(from) : _this26.toUrl(_this26.path(from));

              _this26.map.setSourceContent(fromUrl, node.source.input.css);
            }
          }
        });
      } else if (this.css) {
        var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
        this.map.setSourceContent(from, this.css);
      }
    }
  }, {
    key: "sourcePath",
    value: function sourcePath(node) {
      if (this.mapOpts.from) {
        return this.toUrl(this.mapOpts.from);
      } else if (this.usesFileUrls) {
        return this.toFileUrl(node.source.input.from);
      } else {
        return this.toUrl(this.path(node.source.input.from));
      }
    }
  }, {
    key: "toBase64",
    value: function toBase64(str) {
      if (Buffer) {
        return Buffer.from(str).toString('base64');
      } else {
        return window.btoa(unescape(encodeURIComponent(str)));
      }
    }
  }, {
    key: "toFileUrl",
    value: function toFileUrl(path) {
      var cached = this.memoizedFileURLs.get(path);
      if (cached) return cached;

      if (pathToFileURL) {
        var fileURL = pathToFileURL(path).toString();
        this.memoizedFileURLs.set(path, fileURL);
        return fileURL;
      } else {
        throw new Error('`map.absolute` option is not available in this PostCSS build');
      }
    }
  }, {
    key: "toUrl",
    value: function toUrl(path) {
      var cached = this.memoizedURLs.get(path);
      if (cached) return cached;

      if (sep === '\\') {
        path = path.replace(/\\/g, '/');
      }

      var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
      this.memoizedURLs.set(path, url);
      return url;
    }
  }]);

  return MapGenerator;
}();

var mapGenerator = MapGenerator;
var SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};

function findLastWithPosition(tokens) {
  for (var i = tokens.length - 1; i >= 0; i--) {
    var token = tokens[i];
    var pos = token[3] || token[2];
    if (pos) return pos;
  }
}

var Parser = /*#__PURE__*/function () {
  function Parser(input) {
    _classCallCheck2(this, Parser);

    this.input = input;
    this.root = new root();
    this.current = this.root;
    this.spaces = '';
    this.semicolon = false;
    this.createTokenizer();
    this.root.source = {
      input: input,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }

  _createClass2(Parser, [{
    key: "atrule",
    value: function atrule(token) {
      var node = new atRule();
      node.name = token[1].slice(1);

      if (node.name === '') {
        this.unnamedAtrule(node, token);
      }

      this.init(node, token[2]);
      var type;
      var prev;
      var shift;
      var last = false;
      var open = false;
      var params = [];
      var brackets = [];

      while (!this.tokenizer.endOfFile()) {
        token = this.tokenizer.nextToken();
        type = token[0];

        if (type === '(' || type === '[') {
          brackets.push(type === '(' ? ')' : ']');
        } else if (type === '{' && brackets.length > 0) {
          brackets.push('}');
        } else if (type === brackets[brackets.length - 1]) {
          brackets.pop();
        }

        if (brackets.length === 0) {
          if (type === ';') {
            node.source.end = this.getPosition(token[2]);
            node.source.end.offset++;
            this.semicolon = true;
            break;
          } else if (type === '{') {
            open = true;
            break;
          } else if (type === '}') {
            if (params.length > 0) {
              shift = params.length - 1;
              prev = params[shift];

              while (prev && prev[0] === 'space') {
                prev = params[--shift];
              }

              if (prev) {
                node.source.end = this.getPosition(prev[3] || prev[2]);
                node.source.end.offset++;
              }
            }

            this.end(token);
            break;
          } else {
            params.push(token);
          }
        } else {
          params.push(token);
        }

        if (this.tokenizer.endOfFile()) {
          last = true;
          break;
        }
      }

      node.raws.between = this.spacesAndCommentsFromEnd(params);

      if (params.length) {
        node.raws.afterName = this.spacesAndCommentsFromStart(params);
        this.raw(node, 'params', params);

        if (last) {
          token = params[params.length - 1];
          node.source.end = this.getPosition(token[3] || token[2]);
          node.source.end.offset++;
          this.spaces = node.raws.between;
          node.raws.between = '';
        }
      } else {
        node.raws.afterName = '';
        node.params = '';
      }

      if (open) {
        node.nodes = [];
        this.current = node;
      }
    }
  }, {
    key: "checkMissedSemicolon",
    value: function checkMissedSemicolon(tokens) {
      var colon = this.colon(tokens);
      if (colon === false) return;
      var founded = 0;
      var token;

      for (var j = colon - 1; j >= 0; j--) {
        token = tokens[j];

        if (token[0] !== 'space') {
          founded += 1;
          if (founded === 2) break;
        }
      } // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
      // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
      // And because we need it after that one we do +1 to get the next one.


      throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
    }
  }, {
    key: "colon",
    value: function colon(tokens) {
      var brackets = 0;
      var prev, token, type;

      var _iterator18 = _createForOfIteratorHelper(tokens.entries()),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _ref9 = _step18.value;

          var _ref8 = _slicedToArray2(_ref9, 2);

          var i = _ref8[0];
          var element = _ref8[1];
          token = element;
          type = token[0];

          if (type === '(') {
            brackets += 1;
          }

          if (type === ')') {
            brackets -= 1;
          }

          if (brackets === 0 && type === ':') {
            if (!prev) {
              this.doubleColon(token);
            } else if (prev[0] === 'word' && prev[1] === 'progid') {
              continue;
            } else {
              return i;
            }
          }

          prev = token;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      return false;
    }
  }, {
    key: "comment",
    value: function comment(token) {
      var node = new _comment();
      this.init(node, token[2]);
      node.source.end = this.getPosition(token[3] || token[2]);
      node.source.end.offset++;
      var text = token[1].slice(2, -2);

      if (/^\s*$/.test(text)) {
        node.text = '';
        node.raws.left = text;
        node.raws.right = '';
      } else {
        var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
        node.text = match[2];
        node.raws.left = match[1];
        node.raws.right = match[3];
      }
    }
  }, {
    key: "createTokenizer",
    value: function createTokenizer() {
      this.tokenizer = tokenize(this.input);
    }
  }, {
    key: "decl",
    value: function decl(tokens, customProperty) {
      var node = new declaration();
      this.init(node, tokens[0][2]);
      var last = tokens[tokens.length - 1];

      if (last[0] === ';') {
        this.semicolon = true;
        tokens.pop();
      }

      node.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition(tokens));
      node.source.end.offset++;

      while (tokens[0][0] !== 'word') {
        if (tokens.length === 1) this.unknownWord(tokens);
        node.raws.before += tokens.shift()[1];
      }

      node.source.start = this.getPosition(tokens[0][2]);
      node.prop = '';

      while (tokens.length) {
        var type = tokens[0][0];

        if (type === ':' || type === 'space' || type === 'comment') {
          break;
        }

        node.prop += tokens.shift()[1];
      }

      node.raws.between = '';
      var token;

      while (tokens.length) {
        token = tokens.shift();

        if (token[0] === ':') {
          node.raws.between += token[1];
          break;
        } else {
          if (token[0] === 'word' && /\w/.test(token[1])) {
            this.unknownWord([token]);
          }

          node.raws.between += token[1];
        }
      }

      if (node.prop[0] === '_' || node.prop[0] === '*') {
        node.raws.before += node.prop[0];
        node.prop = node.prop.slice(1);
      }

      var firstSpaces = [];
      var next;

      while (tokens.length) {
        next = tokens[0][0];
        if (next !== 'space' && next !== 'comment') break;
        firstSpaces.push(tokens.shift());
      }

      this.precheckMissedSemicolon(tokens);

      for (var i = tokens.length - 1; i >= 0; i--) {
        token = tokens[i];

        if (token[1].toLowerCase() === '!important') {
          node.important = true;
          var string = this.stringFrom(tokens, i);
          string = this.spacesFromEnd(tokens) + string;
          if (string !== ' !important') node.raws.important = string;
          break;
        } else if (token[1].toLowerCase() === 'important') {
          var cache = tokens.slice(0);
          var str = '';

          for (var j = i; j > 0; j--) {
            var _type = cache[j][0];

            if (str.trim().startsWith('!') && _type !== 'space') {
              break;
            }

            str = cache.pop()[1] + str;
          }

          if (str.trim().startsWith('!')) {
            node.important = true;
            node.raws.important = str;
            tokens = cache;
          }
        }

        if (token[0] !== 'space' && token[0] !== 'comment') {
          break;
        }
      }

      var hasWord = tokens.some(function (i) {
        return i[0] !== 'space' && i[0] !== 'comment';
      });

      if (hasWord) {
        node.raws.between += firstSpaces.map(function (i) {
          return i[1];
        }).join('');
        firstSpaces = [];
      }

      this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);

      if (node.value.includes(':') && !customProperty) {
        this.checkMissedSemicolon(tokens);
      }
    }
  }, {
    key: "doubleColon",
    value: function doubleColon(token) {
      throw this.input.error('Double colon', {
        offset: token[2]
      }, {
        offset: token[2] + token[1].length
      });
    }
  }, {
    key: "emptyRule",
    value: function emptyRule(token) {
      var node = new _rule();
      this.init(node, token[2]);
      node.selector = '';
      node.raws.between = '';
      this.current = node;
    }
  }, {
    key: "end",
    value: function end(token) {
      if (this.current.nodes && this.current.nodes.length) {
        this.current.raws.semicolon = this.semicolon;
      }

      this.semicolon = false;
      this.current.raws.after = (this.current.raws.after || '') + this.spaces;
      this.spaces = '';

      if (this.current.parent) {
        this.current.source.end = this.getPosition(token[2]);
        this.current.source.end.offset++;
        this.current = this.current.parent;
      } else {
        this.unexpectedClose(token);
      }
    }
  }, {
    key: "endFile",
    value: function endFile() {
      if (this.current.parent) this.unclosedBlock();

      if (this.current.nodes && this.current.nodes.length) {
        this.current.raws.semicolon = this.semicolon;
      }

      this.current.raws.after = (this.current.raws.after || '') + this.spaces;
      this.root.source.end = this.getPosition(this.tokenizer.position());
    }
  }, {
    key: "freeSemicolon",
    value: function freeSemicolon(token) {
      this.spaces += token[1];

      if (this.current.nodes) {
        var prev = this.current.nodes[this.current.nodes.length - 1];

        if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
          prev.raws.ownSemicolon = this.spaces;
          this.spaces = '';
          prev.source.end = this.getPosition(token[2]);
          prev.source.end.offset += prev.raws.ownSemicolon.length;
        }
      }
    } // Helpers

  }, {
    key: "getPosition",
    value: function getPosition(offset) {
      var pos = this.input.fromOffset(offset);
      return {
        column: pos.col,
        line: pos.line,
        offset: offset
      };
    }
  }, {
    key: "init",
    value: function init(node, offset) {
      this.current.push(node);
      node.source = {
        input: this.input,
        start: this.getPosition(offset)
      };
      node.raws.before = this.spaces;
      this.spaces = '';
      if (node.type !== 'comment') this.semicolon = false;
    }
  }, {
    key: "other",
    value: function other(start) {
      var end = false;
      var type = null;
      var colon = false;
      var bracket = null;
      var brackets = [];
      var customProperty = start[1].startsWith('--');
      var tokens = [];
      var token = start;

      while (token) {
        type = token[0];
        tokens.push(token);

        if (type === '(' || type === '[') {
          if (!bracket) bracket = token;
          brackets.push(type === '(' ? ')' : ']');
        } else if (customProperty && colon && type === '{') {
          if (!bracket) bracket = token;
          brackets.push('}');
        } else if (brackets.length === 0) {
          if (type === ';') {
            if (colon) {
              this.decl(tokens, customProperty);
              return;
            } else {
              break;
            }
          } else if (type === '{') {
            this.rule(tokens);
            return;
          } else if (type === '}') {
            this.tokenizer.back(tokens.pop());
            end = true;
            break;
          } else if (type === ':') {
            colon = true;
          }
        } else if (type === brackets[brackets.length - 1]) {
          brackets.pop();
          if (brackets.length === 0) bracket = null;
        }

        token = this.tokenizer.nextToken();
      }

      if (this.tokenizer.endOfFile()) end = true;
      if (brackets.length > 0) this.unclosedBracket(bracket);

      if (end && colon) {
        if (!customProperty) {
          while (tokens.length) {
            token = tokens[tokens.length - 1][0];
            if (token !== 'space' && token !== 'comment') break;
            this.tokenizer.back(tokens.pop());
          }
        }

        this.decl(tokens, customProperty);
      } else {
        this.unknownWord(tokens);
      }
    }
  }, {
    key: "parse",
    value: function parse() {
      var token;

      while (!this.tokenizer.endOfFile()) {
        token = this.tokenizer.nextToken();

        switch (token[0]) {
          case 'space':
            this.spaces += token[1];
            break;

          case ';':
            this.freeSemicolon(token);
            break;

          case '}':
            this.end(token);
            break;

          case 'comment':
            this.comment(token);
            break;

          case 'at-word':
            this.atrule(token);
            break;

          case '{':
            this.emptyRule(token);
            break;

          default:
            this.other(token);
            break;
        }
      }

      this.endFile();
    }
  }, {
    key: "precheckMissedSemicolon",
    value: function precheckMissedSemicolon()
    /* tokens */
    {// Hook for Safe Parser
    }
  }, {
    key: "raw",
    value: function raw(node, prop, tokens, customProperty) {
      var token, type;
      var length = tokens.length;
      var value = '';
      var clean = true;
      var next, prev;

      for (var i = 0; i < length; i += 1) {
        token = tokens[i];
        type = token[0];

        if (type === 'space' && i === length - 1 && !customProperty) {
          clean = false;
        } else if (type === 'comment') {
          prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
          next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';

          if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
            if (value.slice(-1) === ',') {
              clean = false;
            } else {
              value += token[1];
            }
          } else {
            clean = false;
          }
        } else {
          value += token[1];
        }
      }

      if (!clean) {
        var raw = tokens.reduce(function (all, i) {
          return all + i[1];
        }, '');
        node.raws[prop] = {
          raw: raw,
          value: value
        };
      }

      node[prop] = value;
    }
  }, {
    key: "rule",
    value: function rule(tokens) {
      tokens.pop();
      var node = new _rule();
      this.init(node, tokens[0][2]);
      node.raws.between = this.spacesAndCommentsFromEnd(tokens);
      this.raw(node, 'selector', tokens);
      this.current = node;
    }
  }, {
    key: "spacesAndCommentsFromEnd",
    value: function spacesAndCommentsFromEnd(tokens) {
      var lastTokenType;
      var spaces = '';

      while (tokens.length) {
        lastTokenType = tokens[tokens.length - 1][0];
        if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
        spaces = tokens.pop()[1] + spaces;
      }

      return spaces;
    } // Errors

  }, {
    key: "spacesAndCommentsFromStart",
    value: function spacesAndCommentsFromStart(tokens) {
      var next;
      var spaces = '';

      while (tokens.length) {
        next = tokens[0][0];
        if (next !== 'space' && next !== 'comment') break;
        spaces += tokens.shift()[1];
      }

      return spaces;
    }
  }, {
    key: "spacesFromEnd",
    value: function spacesFromEnd(tokens) {
      var lastTokenType;
      var spaces = '';

      while (tokens.length) {
        lastTokenType = tokens[tokens.length - 1][0];
        if (lastTokenType !== 'space') break;
        spaces = tokens.pop()[1] + spaces;
      }

      return spaces;
    }
  }, {
    key: "stringFrom",
    value: function stringFrom(tokens, from) {
      var result = '';

      for (var i = from; i < tokens.length; i++) {
        result += tokens[i][1];
      }

      tokens.splice(from, tokens.length - from);
      return result;
    }
  }, {
    key: "unclosedBlock",
    value: function unclosedBlock() {
      var pos = this.current.source.start;
      throw this.input.error('Unclosed block', pos.line, pos.column);
    }
  }, {
    key: "unclosedBracket",
    value: function unclosedBracket(bracket) {
      throw this.input.error('Unclosed bracket', {
        offset: bracket[2]
      }, {
        offset: bracket[2] + 1
      });
    }
  }, {
    key: "unexpectedClose",
    value: function unexpectedClose(token) {
      throw this.input.error('Unexpected }', {
        offset: token[2]
      }, {
        offset: token[2] + 1
      });
    }
  }, {
    key: "unknownWord",
    value: function unknownWord(tokens) {
      throw this.input.error('Unknown word ' + tokens[0][1], {
        offset: tokens[0][2]
      }, {
        offset: tokens[0][2] + tokens[0][1].length
      });
    }
  }, {
    key: "unnamedAtrule",
    value: function unnamedAtrule(node, token) {
      throw this.input.error('At-rule without name', {
        offset: token[2]
      }, {
        offset: token[2] + token[1].length
      });
    }
  }]);

  return Parser;
}();

var parser = Parser;

function parse(css, opts) {
  var input$1 = new input(css, opts);
  var parser$1 = new parser(input$1);

  try {
    parser$1.parse();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      if (e.name === 'CssSyntaxError' && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
        } else if (/\.sass/i.test(opts.from)) {
          e.message += '\nYou tried to parse Sass with ' + 'the standard CSS parser; ' + 'try again with the postcss-sass parser';
        } else if (/\.less$/i.test(opts.from)) {
          e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
        }
      }
    }

    throw e;
  }

  return parser$1.root;
}

var parse_1 = parse;
parse.default = parse;
container.registerParse(parse);

var Warning = /*#__PURE__*/function () {
  function Warning(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, Warning);

    this.type = 'warning';
    this.text = text;

    if (opts.node && opts.node.source) {
      var range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }

    for (var opt in opts) {
      this[opt] = opts[opt];
    }
  }

  _createClass2(Warning, [{
    key: "toString",
    value: function toString() {
      if (this.node) {
        return this.node.error(this.text, {
          index: this.index,
          plugin: this.plugin,
          word: this.word
        }).message;
      }

      if (this.plugin) {
        return this.plugin + ': ' + this.text;
      }

      return this.text;
    }
  }]);

  return Warning;
}();

var warning = Warning;
Warning.default = Warning;

var Result = /*#__PURE__*/function () {
  function Result(processor, root, opts) {
    _classCallCheck2(this, Result);

    this.processor = processor;
    this.messages = [];
    this.root = root;
    this.opts = opts;
    this.css = undefined;
    this.map = undefined;
  }

  _createClass2(Result, [{
    key: "content",
    get: function get() {
      return this.css;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.css;
    }
  }, {
    key: "warn",
    value: function warn(text) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!opts.plugin) {
        if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
          opts.plugin = this.lastPlugin.postcssPlugin;
        }
      }

      var warning$1 = new warning(text, opts);
      this.messages.push(warning$1);
      return warning$1;
    }
  }, {
    key: "warnings",
    value: function warnings() {
      return this.messages.filter(function (i) {
        return i.type === 'warning';
      });
    }
  }]);

  return Result;
}();

var result = Result;
Result.default = Result;
/* eslint-disable no-console */

var printed = {};

var warnOnce = function warnOnce(message) {
  if (printed[message]) return;
  printed[message] = true;

  if (typeof console !== 'undefined' && console.warn) {
    console.warn(message);
  }
};

var isClean = symbols.isClean,
    my = symbols.my;
var TYPE_TO_CLASS_NAME = {
  atrule: 'AtRule',
  comment: 'Comment',
  decl: 'Declaration',
  document: 'Document',
  root: 'Root',
  rule: 'Rule'
};
var PLUGIN_PROPS = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};
var NOT_VISITORS = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};
var CHILDREN = 0;

function isPromise(obj) {
  return _typeof2(obj) === 'object' && typeof obj.then === 'function';
}

function getEvents(node) {
  var key = false;
  var type = TYPE_TO_CLASS_NAME[node.type];

  if (node.type === 'decl') {
    key = node.prop.toLowerCase();
  } else if (node.type === 'atrule') {
    key = node.name.toLowerCase();
  }

  if (key && node.append) {
    return [type, type + '-' + key, CHILDREN, type + 'Exit', type + 'Exit-' + key];
  } else if (key) {
    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key];
  } else if (node.append) {
    return [type, CHILDREN, type + 'Exit'];
  } else {
    return [type, type + 'Exit'];
  }
}

function toStack(node) {
  var events;

  if (node.type === 'document') {
    events = ['Document', CHILDREN, 'DocumentExit'];
  } else if (node.type === 'root') {
    events = ['Root', CHILDREN, 'RootExit'];
  } else {
    events = getEvents(node);
  }

  return {
    eventIndex: 0,
    events: events,
    iterator: 0,
    node: node,
    visitorIndex: 0,
    visitors: []
  };
}

function cleanMarks(node) {
  node[isClean] = false;
  if (node.nodes) node.nodes.forEach(function (i) {
    return cleanMarks(i);
  });
  return node;
}

var postcss$1 = {};

var LazyResult = /*#__PURE__*/function () {
  function LazyResult(processor, css, opts) {
    var _this27 = this;

    _classCallCheck2(this, LazyResult);

    this.stringified = false;
    this.processed = false;
    var root;

    if (_typeof2(css) === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) {
      root = cleanMarks(css);
    } else if (css instanceof LazyResult || css instanceof result) {
      root = cleanMarks(css.root);

      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      var _parser = parse_1;
      if (opts.syntax) _parser = opts.syntax.parse;
      if (opts.parser) _parser = opts.parser;
      if (_parser.parse) _parser = _parser.parse;

      try {
        root = _parser(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root && !root[my]) {
        /* c8 ignore next 2 */
        container.rebuild(root);
      }
    }

    this.result = new result(processor, root, opts);
    this.helpers = _objectSpread(_objectSpread({}, postcss$1), {}, {
      postcss: postcss$1,
      result: this.result
    });
    this.plugins = this.processor.plugins.map(function (plugin) {
      if (_typeof2(plugin) === 'object' && plugin.prepare) {
        return _objectSpread(_objectSpread({}, plugin), plugin.prepare(_this27.result));
      } else {
        return plugin;
      }
    });
  }

  _createClass2(LazyResult, [{
    key: "content",
    get: function get() {
      return this.stringify().content;
    }
  }, {
    key: "css",
    get: function get() {
      return this.stringify().css;
    }
  }, {
    key: "map",
    get: function get() {
      return this.stringify().map;
    }
  }, {
    key: "messages",
    get: function get() {
      return this.sync().messages;
    }
  }, {
    key: "opts",
    get: function get() {
      return this.result.opts;
    }
  }, {
    key: "processor",
    get: function get() {
      return this.result.processor;
    }
  }, {
    key: "root",
    get: function get() {
      return this.sync().root;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return 'LazyResult';
    }
  }, {
    key: "async",
    value: function async() {
      if (this.error) return Promise.reject(this.error);
      if (this.processed) return Promise.resolve(this.result);

      if (!this.processing) {
        this.processing = this.runAsync();
      }

      return this.processing;
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.async().catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
  }, {
    key: "getAsyncError",
    value: function getAsyncError() {
      throw new Error('Use process(css).then(cb) to work with async plugins');
    }
  }, {
    key: "handleError",
    value: function handleError(error, node) {
      var plugin = this.result.lastPlugin;

      try {
        if (node) node.addToError(error);
        this.error = error;

        if (error.name === 'CssSyntaxError' && !error.plugin) {
          error.plugin = plugin.postcssPlugin;
          error.setMessage();
        } else if (plugin.postcssVersion) {
          if (process.env.NODE_ENV !== 'production') {
            var pluginName = plugin.postcssPlugin;
            var pluginVer = plugin.postcssVersion;
            var runtimeVer = this.result.processor.version;
            var a = pluginVer.split('.');
            var b = runtimeVer.split('.');

            if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
              // eslint-disable-next-line no-console
              console.error('Unknown error from PostCSS plugin. Your current PostCSS ' + 'version is ' + runtimeVer + ', but ' + pluginName + ' uses ' + pluginVer + '. Perhaps this is the source of the error below.');
            }
          }
        }
      } catch (err) {
        /* c8 ignore next 3 */
        // eslint-disable-next-line no-console
        if (console && console.error) console.error(err);
      }

      return error;
    }
  }, {
    key: "prepareVisitors",
    value: function prepareVisitors() {
      var _this28 = this;

      this.listeners = {};

      var add = function add(plugin, type, cb) {
        if (!_this28.listeners[type]) _this28.listeners[type] = [];

        _this28.listeners[type].push([plugin, cb]);
      };

      var _iterator19 = _createForOfIteratorHelper(this.plugins),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var plugin = _step19.value;

          if (_typeof2(plugin) === 'object') {
            for (var event in plugin) {
              if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
                throw new Error("Unknown event ".concat(event, " in ").concat(plugin.postcssPlugin, ". ") + "Try to update PostCSS (".concat(this.processor.version, " now)."));
              }

              if (!NOT_VISITORS[event]) {
                if (_typeof2(plugin[event]) === 'object') {
                  for (var _filter in plugin[event]) {
                    if (_filter === '*') {
                      add(plugin, event, plugin[event][_filter]);
                    } else {
                      add(plugin, event + '-' + _filter.toLowerCase(), plugin[event][_filter]);
                    }
                  }
                } else if (typeof plugin[event] === 'function') {
                  add(plugin, event, plugin[event]);
                }
              }
            }
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      this.hasListener = Object.keys(this.listeners).length > 0;
    }
  }, {
    key: "runAsync",
    value: function () {
      var _runAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this29 = this;

        var i, plugin, promise, _root2, stack, _promise, _node17, _iterator20, _step20, _loop2, _ref11;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.plugin = 0;
                i = 0;

              case 2:
                if (!(i < this.plugins.length)) {
                  _context2.next = 17;
                  break;
                }

                plugin = this.plugins[i];
                promise = this.runOnRoot(plugin);

                if (!isPromise(promise)) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 6;
                _context2.next = 9;
                return promise;

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);
                throw this.handleError(_context2.t0);

              case 14:
                i++;
                _context2.next = 2;
                break;

              case 17:
                this.prepareVisitors();

                if (!this.hasListener) {
                  _context2.next = 56;
                  break;
                }

                _root2 = this.result.root;

              case 20:
                if (_root2[isClean]) {
                  _context2.next = 39;
                  break;
                }

                _root2[isClean] = true;
                stack = [toStack(_root2)];

              case 23:
                if (!(stack.length > 0)) {
                  _context2.next = 37;
                  break;
                }

                _promise = this.visitTick(stack);

                if (!isPromise(_promise)) {
                  _context2.next = 35;
                  break;
                }

                _context2.prev = 26;
                _context2.next = 29;
                return _promise;

              case 29:
                _context2.next = 35;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2["catch"](26);
                _node17 = stack[stack.length - 1].node;
                throw this.handleError(_context2.t1, _node17);

              case 35:
                _context2.next = 23;
                break;

              case 37:
                _context2.next = 20;
                break;

              case 39:
                if (!this.listeners.OnceExit) {
                  _context2.next = 56;
                  break;
                }

                _iterator20 = _createForOfIteratorHelper(this.listeners.OnceExit);
                _context2.prev = 41;
                _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _ref10, plugin, visitor, roots;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _ref10 = _step20.value;
                          _ref11 = _slicedToArray2(_ref10, 2);
                          plugin = _ref11[0];
                          visitor = _ref11[1];
                          _this29.result.lastPlugin = plugin;
                          _context.prev = 5;

                          if (!(_root2.type === 'document')) {
                            _context.next = 12;
                            break;
                          }

                          roots = _root2.nodes.map(function (subRoot) {
                            return visitor(subRoot, _this29.helpers);
                          });
                          _context.next = 10;
                          return Promise.all(roots);

                        case 10:
                          _context.next = 14;
                          break;

                        case 12:
                          _context.next = 14;
                          return visitor(_root2, _this29.helpers);

                        case 14:
                          _context.next = 19;
                          break;

                        case 16:
                          _context.prev = 16;
                          _context.t0 = _context["catch"](5);
                          throw _this29.handleError(_context.t0);

                        case 19:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[5, 16]]);
                });

                _iterator20.s();

              case 44:
                if ((_step20 = _iterator20.n()).done) {
                  _context2.next = 48;
                  break;
                }

                return _context2.delegateYield(_loop2(), "t2", 46);

              case 46:
                _context2.next = 44;
                break;

              case 48:
                _context2.next = 53;
                break;

              case 50:
                _context2.prev = 50;
                _context2.t3 = _context2["catch"](41);

                _iterator20.e(_context2.t3);

              case 53:
                _context2.prev = 53;

                _iterator20.f();

                return _context2.finish(53);

              case 56:
                this.processed = true;
                return _context2.abrupt("return", this.stringify());

              case 58:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11], [26, 31], [41, 50, 53, 56]]);
      }));

      function runAsync() {
        return _runAsync.apply(this, arguments);
      }

      return runAsync;
    }()
  }, {
    key: "runOnRoot",
    value: function runOnRoot(plugin) {
      var _this30 = this;

      this.result.lastPlugin = plugin;

      try {
        if (_typeof2(plugin) === 'object' && plugin.Once) {
          if (this.result.root.type === 'document') {
            var roots = this.result.root.nodes.map(function (root) {
              return plugin.Once(root, _this30.helpers);
            });

            if (isPromise(roots[0])) {
              return Promise.all(roots);
            }

            return roots;
          }

          return plugin.Once(this.result.root, this.helpers);
        } else if (typeof plugin === 'function') {
          return plugin(this.result.root, this.result);
        }
      } catch (error) {
        throw this.handleError(error);
      }
    }
  }, {
    key: "stringify",
    value: function stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = true;
      this.sync();
      var opts = this.result.opts;
      var str = stringify_1;
      if (opts.syntax) str = opts.syntax.stringify;
      if (opts.stringifier) str = opts.stringifier;
      if (str.stringify) str = str.stringify;
      var map = new mapGenerator(str, this.result.root, this.result.opts);
      var data = map.generate();
      this.result.css = data[0];
      this.result.map = data[1];
      return this.result;
    }
  }, {
    key: "sync",
    value: function sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      this.processed = true;

      if (this.processing) {
        throw this.getAsyncError();
      }

      var _iterator21 = _createForOfIteratorHelper(this.plugins),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var plugin = _step21.value;
          var promise = this.runOnRoot(plugin);

          if (isPromise(promise)) {
            throw this.getAsyncError();
          }
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      this.prepareVisitors();

      if (this.hasListener) {
        var _root3 = this.result.root;

        while (!_root3[isClean]) {
          _root3[isClean] = true;
          this.walkSync(_root3);
        }

        if (this.listeners.OnceExit) {
          if (_root3.type === 'document') {
            var _iterator22 = _createForOfIteratorHelper(_root3.nodes),
                _step22;

            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var subRoot = _step22.value;
                this.visitSync(this.listeners.OnceExit, subRoot);
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }
          } else {
            this.visitSync(this.listeners.OnceExit, _root3);
          }
        }
      }

      return this.result;
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== 'production') {
        if (!('from' in this.opts)) {
          warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
        }
      }

      return this.async().then(onFulfilled, onRejected);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.css;
    }
  }, {
    key: "visitSync",
    value: function visitSync(visitors, node) {
      var _iterator23 = _createForOfIteratorHelper(visitors),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _ref14 = _step23.value;

          var _ref13 = _slicedToArray2(_ref14, 2);

          var plugin = _ref13[0];
          var visitor = _ref13[1];
          this.result.lastPlugin = plugin;
          var promise = void 0;

          try {
            promise = visitor(node, this.helpers);
          } catch (e) {
            throw this.handleError(e, node.proxyOf);
          }

          if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
            return true;
          }

          if (isPromise(promise)) {
            throw this.getAsyncError();
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "visitTick",
    value: function visitTick(stack) {
      var visit = stack[stack.length - 1];
      var node = visit.node,
          visitors = visit.visitors;

      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
        stack.pop();
        return;
      }

      if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
        var _visitors$visit$visit = _slicedToArray2(visitors[visit.visitorIndex], 2),
            plugin = _visitors$visit$visit[0],
            visitor = _visitors$visit$visit[1];

        visit.visitorIndex += 1;

        if (visit.visitorIndex === visitors.length) {
          visit.visitors = [];
          visit.visitorIndex = 0;
        }

        this.result.lastPlugin = plugin;

        try {
          return visitor(node.toProxy(), this.helpers);
        } catch (e) {
          throw this.handleError(e, node);
        }
      }

      if (visit.iterator !== 0) {
        var iterator = visit.iterator;
        var child;

        while (child = node.nodes[node.indexes[iterator]]) {
          node.indexes[iterator] += 1;

          if (!child[isClean]) {
            child[isClean] = true;
            stack.push(toStack(child));
            return;
          }
        }

        visit.iterator = 0;
        delete node.indexes[iterator];
      }

      var events = visit.events;

      while (visit.eventIndex < events.length) {
        var event = events[visit.eventIndex];
        visit.eventIndex += 1;

        if (event === CHILDREN) {
          if (node.nodes && node.nodes.length) {
            node[isClean] = true;
            visit.iterator = node.getIterator();
          }

          return;
        } else if (this.listeners[event]) {
          visit.visitors = this.listeners[event];
          return;
        }
      }

      stack.pop();
    }
  }, {
    key: "walkSync",
    value: function walkSync(node) {
      var _this31 = this;

      node[isClean] = true;
      var events = getEvents(node);

      var _iterator24 = _createForOfIteratorHelper(events),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var event = _step24.value;

          if (event === CHILDREN) {
            if (node.nodes) {
              node.each(function (child) {
                if (!child[isClean]) _this31.walkSync(child);
              });
            }
          } else {
            var visitors = this.listeners[event];

            if (visitors) {
              if (this.visitSync(visitors, node.toProxy())) return;
            }
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }
  }, {
    key: "warnings",
    value: function warnings() {
      return this.sync().warnings();
    }
  }]);

  return LazyResult;
}();

LazyResult.registerPostcss = function (dependant) {
  postcss$1 = dependant;
};

var lazyResult = LazyResult;
LazyResult.default = LazyResult;
root.registerLazyResult(LazyResult);
document$1.registerLazyResult(LazyResult);

var NoWorkResult = /*#__PURE__*/function () {
  function NoWorkResult(processor, css, opts) {
    _classCallCheck2(this, NoWorkResult);

    css = css.toString();
    this.stringified = false;
    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    var root;
    var str = stringify_1;
    this.result = new result(this._processor, root, this._opts);
    this.result.css = css;
    var self = this;
    Object.defineProperty(this.result, 'root', {
      get: function get() {
        return self.root;
      }
    });
    var map = new mapGenerator(str, root, this._opts, css);

    if (map.isMap()) {
      var _map$generate = map.generate(),
          _map$generate2 = _slicedToArray2(_map$generate, 2),
          generatedCSS = _map$generate2[0],
          generatedMap = _map$generate2[1];

      if (generatedCSS) {
        this.result.css = generatedCSS;
      }

      if (generatedMap) {
        this.result.map = generatedMap;
      }
    } else {
      map.clearAnnotation();
      this.result.css = map.css;
    }
  }

  _createClass2(NoWorkResult, [{
    key: "content",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "css",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "map",
    get: function get() {
      return this.result.map;
    }
  }, {
    key: "messages",
    get: function get() {
      return [];
    }
  }, {
    key: "opts",
    get: function get() {
      return this.result.opts;
    }
  }, {
    key: "processor",
    get: function get() {
      return this.result.processor;
    }
  }, {
    key: "root",
    get: function get() {
      if (this._root) {
        return this._root;
      }

      var root;
      var parser = parse_1;

      try {
        root = parser(this._css, this._opts);
      } catch (error) {
        this.error = error;
      }

      if (this.error) {
        throw this.error;
      } else {
        this._root = root;
        return root;
      }
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return 'NoWorkResult';
    }
  }, {
    key: "async",
    value: function async() {
      if (this.error) return Promise.reject(this.error);
      return Promise.resolve(this.result);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.async().catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
  }, {
    key: "sync",
    value: function sync() {
      if (this.error) throw this.error;
      return this.result;
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== 'production') {
        if (!('from' in this._opts)) {
          warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
        }
      }

      return this.async().then(onFulfilled, onRejected);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._css;
    }
  }, {
    key: "warnings",
    value: function warnings() {
      return [];
    }
  }]);

  return NoWorkResult;
}();

var noWorkResult = NoWorkResult;
NoWorkResult.default = NoWorkResult;

var Processor = /*#__PURE__*/function () {
  function Processor() {
    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck2(this, Processor);

    this.version = '8.5.3';
    this.plugins = this.normalize(plugins);
  }

  _createClass2(Processor, [{
    key: "normalize",
    value: function normalize(plugins) {
      var normalized = [];

      var _iterator25 = _createForOfIteratorHelper(plugins),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var i = _step25.value;

          if (i.postcss === true) {
            i = i();
          } else if (i.postcss) {
            i = i.postcss;
          }

          if (_typeof2(i) === 'object' && Array.isArray(i.plugins)) {
            normalized = normalized.concat(i.plugins);
          } else if (_typeof2(i) === 'object' && i.postcssPlugin) {
            normalized.push(i);
          } else if (typeof i === 'function') {
            normalized.push(i);
          } else if (_typeof2(i) === 'object' && (i.parse || i.stringify)) {
            if (process.env.NODE_ENV !== 'production') {
              throw new Error('PostCSS syntaxes cannot be used as plugins. Instead, please use ' + 'one of the syntax/parser/stringifier options as outlined ' + 'in your PostCSS runner documentation.');
            }
          } else {
            throw new Error(i + ' is not a PostCSS plugin');
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      return normalized;
    }
  }, {
    key: "process",
    value: function process(css) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
        return new noWorkResult(this, css, opts);
      } else {
        return new lazyResult(this, css, opts);
      }
    }
  }, {
    key: "use",
    value: function use(plugin) {
      this.plugins = this.plugins.concat(this.normalize([plugin]));
      return this;
    }
  }]);

  return Processor;
}();

var processor = Processor;
Processor.default = Processor;
root.registerProcessor(Processor);
document$1.registerProcessor(Processor);

function postcss() {
  for (var _len9 = arguments.length, plugins = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    plugins[_key9] = arguments[_key9];
  }

  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }

  return new processor(plugins);
}

postcss.plugin = function plugin(name, initializer) {
  var warningPrinted = false;

  function creator() {
    // eslint-disable-next-line no-console
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true; // eslint-disable-next-line no-console

      console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');

      if (process.env.LANG && process.env.LANG.startsWith('cn')) {
        /* c8 ignore next 7 */
        // eslint-disable-next-line no-console
        console.warn(name + ': 里面 postcss.plugin 被弃用. 迁移指南:\n' + 'https://www.w3ctech.com/topic/2226');
      }
    }

    var transformer = initializer.apply(void 0, arguments);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new processor().version;
    return transformer;
  }

  var cache;
  Object.defineProperty(creator, 'postcss', {
    get: function get() {
      if (!cache) cache = creator();
      return cache;
    }
  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts);
  };

  return creator;
};

postcss.stringify = stringify_1;
postcss.parse = parse_1;
postcss.fromJSON = fromJSON_1;
postcss.list = list_1;

postcss.comment = function (defaults) {
  return new _comment(defaults);
};

postcss.atRule = function (defaults) {
  return new atRule(defaults);
};

postcss.decl = function (defaults) {
  return new declaration(defaults);
};

postcss.rule = function (defaults) {
  return new _rule(defaults);
};

postcss.root = function (defaults) {
  return new root(defaults);
};

postcss.document = function (defaults) {
  return new document$1(defaults);
};

postcss.CssSyntaxError = cssSyntaxError;
postcss.Declaration = declaration;
postcss.Container = container;
postcss.Processor = processor;
postcss.Document = document$1;
postcss.Comment = _comment;
postcss.Warning = warning;
postcss.AtRule = atRule;
postcss.Result = result;
postcss.Input = input;
postcss.Rule = _rule;
postcss.Root = root;
postcss.Node = node;
lazyResult.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
var require$$0 = getCjsExportFromNamespace(isPlainObject$2);
var isPlainObject = require$$0.isPlainObject;
var postcssParse = postcss_1.parse; // Tags that can conceivably represent stand-alone media.

var mediaTags = ['img', 'audio', 'video', 'picture', 'svg', 'object', 'map', 'iframe', 'embed']; // Tags that are inherently vulnerable to being used in XSS attacks.

var vulnerableTags = ['script', 'style'];

function each(obj, cb) {
  if (obj) {
    Object.keys(obj).forEach(function (key) {
      cb(obj[key], key);
    });
  }
} // Avoid false positives with .__proto__, .hasOwnProperty, etc.


function has(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
} // Returns those elements of `a` for which `cb(a)` returns truthy


function filter(a, cb) {
  var n = [];
  each(a, function (v) {
    if (cb(v)) {
      n.push(v);
    }
  });
  return n;
}

function isEmptyObject(obj) {
  for (var key in obj) {
    if (has(obj, key)) {
      return false;
    }
  }

  return true;
}

function stringifySrcset(parsedSrcset) {
  return parsedSrcset.map(function (part) {
    if (!part.url) {
      throw new Error('URL missing');
    }

    return part.url + (part.w ? " ".concat(part.w, "w") : '') + (part.h ? " ".concat(part.h, "h") : '') + (part.d ? " ".concat(part.d, "x") : '');
  }).join(', ');
}

var sanitizeHtml_1 = sanitizeHtml; // A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.

var VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/; // Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  if (html == null) {
    return '';
  }

  if (typeof html === 'number') {
    html = html.toString();
  }

  var result = ''; // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.

  var tempResult = '';

  function Frame(tag, attribs) {
    var that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text

    this.mediaChildren = [];

    this.updateParentNodeText = function () {
      if (stack.length) {
        var parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };

    this.updateParentNodeMediaChildren = function () {
      if (stack.length && mediaTags.includes(this.tag)) {
        var parentFrame = stack[stack.length - 1];
        parentFrame.mediaChildren.push(this.tag);
      }
    };
  }

  options = Object.assign({}, sanitizeHtml.defaults, options);
  options.parser = Object.assign({}, htmlParserDefaults, options.parser);

  var tagAllowed = function tagAllowed(name) {
    return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
  }; // vulnerableTags


  vulnerableTags.forEach(function (tag) {
    if (tagAllowed(tag) && !options.allowVulnerableTags) {
      console.warn("\n\n\u26A0\uFE0F Your `allowedTags` option includes, `".concat(tag, "`, which is inherently\nvulnerable to XSS attacks. Please remove it from `allowedTags`.\nOr, to disable this warning, add the `allowVulnerableTags` option\nand ensure you are accounting for this risk.\n\n"));
    }
  }); // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.

  var nonTextTagsArray = options.nonTextTags || ['script', 'style', 'textarea', 'option'];
  var allowedAttributesMap;
  var allowedAttributesGlobMap;

  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function (attributes, tag) {
      allowedAttributesMap[tag] = [];
      var globRegex = [];
      attributes.forEach(function (obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });

      if (globRegex.length) {
        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    });
  }

  var allowedClassesMap = {};
  var allowedClassesGlobMap = {};
  var allowedClassesRegexMap = {};
  each(options.allowedClasses, function (classes, tag) {
    // Implicitly allows the class attribute
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }

      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = classes;

    if (Array.isArray(classes)) {
      var globRegex = [];
      allowedClassesMap[tag] = [];
      allowedClassesRegexMap[tag] = [];
      classes.forEach(function (obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else if (obj instanceof RegExp) {
          allowedClassesRegexMap[tag].push(obj);
        } else {
          allowedClassesMap[tag].push(obj);
        }
      });

      if (globRegex.length) {
        allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    }
  });
  var transformTagsMap = {};
  var transformTagsAll;
  each(options.transformTags, function (transform, tag) {
    var transFun;

    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === 'string') {
      transFun = sanitizeHtml.simpleTransform(transform);
    }

    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });
  var depth;
  var stack;
  var skipMap;
  var transformMap;
  var skipText;
  var skipTextDepth;
  var addedText = false;
  initializeState();
  var parser = new esm.Parser({
    onopentag: function onopentag(name, attribs) {
      // If `enforceHtmlBoundary` is `true` and this has found the opening
      // `html` tag, reset the state.
      if (options.enforceHtmlBoundary && name === 'html') {
        initializeState();
      }

      if (skipText) {
        skipTextDepth++;
        return;
      }

      var frame = new Frame(name, attribs);
      stack.push(frame);
      var skip = false;
      var hasText = !!frame.text;
      var transformedTag;

      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);
        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);
        frame.attribs = attribs = transformedTag.attribs;

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (!tagAllowed(name) || options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
        skip = true;
        skipMap[depth] = true;

        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          if (nonTextTagsArray.indexOf(name) !== -1) {
            skipText = true;
            skipTextDepth = 1;
          }
        }

        skipMap[depth] = true;
      }

      depth++;

      if (skip) {
        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          // We want the contents but not this tag
          if (frame.innerText && !hasText) {
            var escaped = escapeHtml(frame.innerText);

            if (options.textFilter) {
              result += options.textFilter(escaped, name);
            } else {
              result += escapeHtml(frame.innerText);
            }

            addedText = true;
          }

          return;
        }

        tempResult = result;
        result = '';
      }

      result += '<' + name;

      if (name === 'script') {
        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
          frame.innerText = '';
        }
      }

      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function (value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            // This prevents part of an attribute name in the output from being
            // interpreted as the end of an attribute, or end of a tag.
            delete frame.attribs[a];
            return;
          } // If the value is empty, check if the attribute is in the allowedEmptyAttributes array.
          // If it is not in the allowedEmptyAttributes array, and it is a known non-boolean attribute, delete it
          // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3


          if (value === '' && !options.allowedEmptyAttributes.includes(a) && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
            delete frame.attribs[a];
            return;
          } // check allowedAttributesMap for the element and attribute and modify the value
          // as necessary if there are specific values defined.


          var passedAllowedAttributesMapCheck = false;

          if (!allowedAttributesMap || has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            var _iterator26 = _createForOfIteratorHelper(allowedAttributesMap[name]),
                _step26;

            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var o = _step26.value;

                if (isPlainObject(o) && o.name && o.name === a) {
                  passedAllowedAttributesMapCheck = true;
                  var newValue = '';

                  if (o.multiple === true) {
                    // verify the values that are allowed
                    var splitStrArray = value.split(' ');

                    var _iterator27 = _createForOfIteratorHelper(splitStrArray),
                        _step27;

                    try {
                      for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                        var s = _step27.value;

                        if (o.values.indexOf(s) !== -1) {
                          if (newValue === '') {
                            newValue = s;
                          } else {
                            newValue += ' ' + s;
                          }
                        }
                      }
                    } catch (err) {
                      _iterator27.e(err);
                    } finally {
                      _iterator27.f();
                    }
                  } else if (o.values.indexOf(value) >= 0) {
                    // verified an allowed value matches the entire attribute value
                    newValue = value;
                  }

                  value = newValue;
                }
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
          }

          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'script' && a === 'src') {
              var allowed = true;

              try {
                var parsed = parseUrl(value);

                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                  var allowedHostname = (options.allowedScriptHostnames || []).find(function (hostname) {
                    return hostname === parsed.url.hostname;
                  });
                  var allowedDomain = (options.allowedScriptDomains || []).find(function (domain) {
                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(".".concat(domain));
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }

              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'iframe' && a === 'src') {
              var _allowed = true;

              try {
                var _parsed = parseUrl(value);

                if (_parsed.isRelativeUrl) {
                  // default value of allowIframeRelativeUrls is true
                  // unless allowedIframeHostnames or allowedIframeDomains specified
                  _allowed = has(options, 'allowIframeRelativeUrls') ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                  var _allowedHostname = (options.allowedIframeHostnames || []).find(function (hostname) {
                    return hostname === _parsed.url.hostname;
                  });

                  var _allowedDomain = (options.allowedIframeDomains || []).find(function (domain) {
                    return _parsed.url.hostname === domain || _parsed.url.hostname.endsWith(".".concat(domain));
                  });

                  _allowed = _allowedHostname || _allowedDomain;
                }
              } catch (e) {
                // Unparseable iframe src
                _allowed = false;
              }

              if (!_allowed) {
                delete frame.attribs[a];
                return;
              }
            }

            if (a === 'srcset') {
              try {
                var _parsed2 = parseSrcset(value);

                _parsed2.forEach(function (value) {
                  if (naughtyHref('srcset', value.url)) {
                    value.evil = true;
                  }
                });

                _parsed2 = filter(_parsed2, function (v) {
                  return !v.evil;
                });

                if (!_parsed2.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = stringifySrcset(filter(_parsed2, function (v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                // Unparseable srcset
                delete frame.attribs[a];
                return;
              }
            }

            if (a === 'class') {
              var allowedSpecificClasses = allowedClassesMap[name];
              var allowedWildcardClasses = allowedClassesMap['*'];
              var allowedSpecificClassesGlob = allowedClassesGlobMap[name];
              var allowedSpecificClassesRegex = allowedClassesRegexMap[name];
              var allowedWildcardClassesRegex = allowedClassesRegexMap['*'];
              var allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
              var allowedClassesGlobs = [allowedSpecificClassesGlob, allowedWildcardClassesGlob].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function (t) {
                return t;
              });

              if (allowedSpecificClasses && allowedWildcardClasses) {
                value = filterClasses(value, cjs(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
              } else {
                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
              }

              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }

            if (a === 'style') {
              if (options.parseStyleAttributes) {
                try {
                  var abstractSyntaxTree = postcssParse(name + ' {' + value + '}', {
                    map: false
                  });
                  var filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                  value = stringifyStyleAttributes(filteredAST);

                  if (value.length === 0) {
                    delete frame.attribs[a];
                    return;
                  }
                } catch (e) {
                  if (typeof window !== 'undefined') {
                    console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
                  }

                  delete frame.attribs[a];
                  return;
                }
              } else if (options.allowedStyles) {
                throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
              }
            }

            result += ' ' + a;

            if (value && value.length) {
              result += '="' + escapeHtml(value, true) + '"';
            } else if (options.allowedEmptyAttributes.includes(a)) {
              result += '=""';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }

      if (options.selfClosing.indexOf(name) !== -1) {
        result += ' />';
      } else {
        result += '>';

        if (frame.innerText && !hasText && !options.textFilter) {
          result += escapeHtml(frame.innerText);
          addedText = true;
        }
      }

      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
    },
    ontext: function ontext(text) {
      if (skipText) {
        return;
      }

      var lastFrame = stack[stack.length - 1];
      var tag;

      if (lastFrame) {
        tag = lastFrame.tag; // If inner text was set by transform function then let's use it

        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if (options.disallowedTagsMode === 'completelyDiscard' && !tagAllowed(tag)) {
        text = '';
      } else if ((options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && (tag === 'script' || tag === 'style')) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        var escaped = escapeHtml(text, false);

        if (options.textFilter && !addedText) {
          result += options.textFilter(escaped, tag);
        } else if (!addedText) {
          result += escaped;
        }
      }

      if (stack.length) {
        var frame = stack[stack.length - 1];
        frame.text += text;
      }
    },
    onclosetag: function onclosetag(name, isImplied) {
      if (skipText) {
        skipTextDepth--;

        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      var frame = stack.pop();

      if (!frame) {
        // Do not crash on bad markup
        return;
      }

      if (frame.tag !== name) {
        // Another case of bad markup.
        // Push to stack, so that it will be used in future closing tags.
        stack.push(frame);
        return;
      }

      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
      depth--;
      var skip = skipMap[depth];

      if (skip) {
        delete skipMap[depth];

        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          frame.updateParentNodeText();
          return;
        }

        tempResult = result;
        result = '';
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
        result = result.substr(0, frame.tagPosition);
        return;
      }

      frame.updateParentNodeMediaChildren();
      frame.updateParentNodeText();

      if ( // Already output />
      options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
      isImplied && !tagAllowed(name) && ['escape', 'recursiveEscape'].indexOf(options.disallowedTagsMode) >= 0) {
        if (skip) {
          result = tempResult;
          tempResult = '';
        }

        return;
      }

      result += '</' + name + '>';

      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }

      addedText = false;
    }
  }, options.parser);
  parser.write(html);
  parser.end();
  return result;

  function initializeState() {
    result = '';
    depth = 0;
    stack = [];
    skipMap = {};
    transformMap = {};
    skipText = false;
    skipTextDepth = 0;
  }

  function escapeHtml(s, quote) {
    if (typeof s !== 'string') {
      s = s + '';
    }

    if (options.parser.decodeEntities) {
      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

      if (quote) {
        s = s.replace(/"/g, '&quot;');
      }
    } // TODO: this is inadequate because it will pass `&0;`. This approach
    // will not work, each & must be considered with regard to whether it
    // is followed by a 100% syntactically valid entity or not, and escaped
    // if it is not. If this bothers you, don't set parser.decodeEntities
    // to false. (The default is true.)


    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
    .replace(/</g, '&lt;').replace(/>/g, '&gt;');

    if (quote) {
      s = s.replace(/"/g, '&quot;');
    }

    return s;
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    // eslint-disable-next-line no-control-regex
    href = href.replace(/[\x00-\x20]+/g, ''); // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through

    while (true) {
      var firstIndex = href.indexOf('<!--');

      if (firstIndex === -1) {
        break;
      }

      var lastIndex = href.indexOf('-->', firstIndex + 4);

      if (lastIndex === -1) {
        break;
      }

      href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
    } // Case insensitive so we don't get faked out by JAVASCRIPT #1
    // Allow more characters after the first so we don't get faked
    // out by certain schemes browsers accept


    var matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);

    if (!matches) {
      // Protocol-relative URL starting with any combination of '/' and '\'
      if (href.match(/^[/\\]{2}/)) {
        return !options.allowProtocolRelative;
      } // No scheme


      return false;
    }

    var scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  function parseUrl(value) {
    value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');

    if (value.startsWith('relative:')) {
      // An attempt to exploit our workaround for base URLs being
      // mandatory for relative URL validation in the WHATWG
      // URL parser, reject it
      throw new Error('relative: exploit attempt');
    } // naughtyHref is in charge of whether protocol relative URLs
    // are cool. Here we are concerned just with allowed hostnames and
    // whether to allow relative URLs.
    //
    // Build a placeholder "base URL" against which any reasonable
    // relative URL may be parsed successfully


    var base = 'relative://relative-site';

    for (var i = 0; i < 100; i++) {
      base += "/".concat(i);
    }

    var parsed = new URL(value, base);
    var isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
    return {
      isRelativeUrl: isRelativeUrl,
      url: parsed
    };
  }
  /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */


  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }

    var astRules = abstractSyntaxTree.nodes[0];
    var selectedRule; // Merge global and tag-specific styles into new AST.

    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
      selectedRule = cjs(allowedStyles[astRules.selector], allowedStyles['*']);
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
    }

    if (selectedRule) {
      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
    }

    return abstractSyntaxTree;
  }
  /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */


  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes.reduce(function (extractedAttributes, attrObject) {
      extractedAttributes.push("".concat(attrObject.prop, ":").concat(attrObject.value).concat(attrObject.important ? ' !important' : ''));
      return extractedAttributes;
    }, []).join(';');
  }
  /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */


  function filterDeclarations(selectedRule) {
    return function (allowedDeclarationsList, attributeObject) {
      // If this property is allowlisted...
      if (has(selectedRule, attributeObject.prop)) {
        var matchesRegex = selectedRule[attributeObject.prop].some(function (regularExpression) {
          return regularExpression.test(attributeObject.value);
        });

        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }

      return allowedDeclarationsList;
    };
  }

  function filterClasses(classes, allowed, allowedGlobs) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }

    classes = classes.split(/\s+/);
    return classes.filter(function (clss) {
      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function (glob) {
        return glob.test(clss);
      });
    }).join(' ');
  }
} // Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish


var htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [// Sections derived from MDN element categories and limited to the more
  // benign categories.
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
  // Content sectioning
  'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'main', 'nav', 'section', // Text content
  'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul', // Inline text semantics
  'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', // Table content
  'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr'],
  // Tags that cannot be boolean
  nonBooleanAttributes: ['abbr', 'accept', 'accept-charset', 'accesskey', 'action', 'allow', 'alt', 'as', 'autocapitalize', 'autocomplete', 'blocking', 'charset', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'coords', 'crossorigin', 'data', 'datetime', 'decoding', 'dir', 'dirname', 'download', 'draggable', 'enctype', 'enterkeyhint', 'fetchpriority', 'for', 'form', 'formaction', 'formenctype', 'formmethod', 'formtarget', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'id', 'imagesizes', 'imagesrcset', 'inputmode', 'integrity', 'is', 'itemid', 'itemprop', 'itemref', 'itemtype', 'kind', 'label', 'lang', 'list', 'loading', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'name', 'nonce', 'optimum', 'pattern', 'ping', 'placeholder', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'referrerpolicy', 'rel', 'rows', 'rowspan', 'sandbox', 'scope', 'shape', 'size', 'sizes', 'slot', 'span', 'spellcheck', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'style', 'tabindex', 'target', 'title', 'translate', 'type', 'usemap', 'value', 'width', 'wrap', // Event handlers
  'onauxclick', 'onafterprint', 'onbeforematch', 'onbeforeprint', 'onbeforeunload', 'onbeforetoggle', 'onblur', 'oncancel', 'oncanplay', 'oncanplaythrough', 'onchange', 'onclick', 'onclose', 'oncontextlost', 'oncontextmenu', 'oncontextrestored', 'oncopy', 'oncuechange', 'oncut', 'ondblclick', 'ondrag', 'ondragend', 'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'ondurationchange', 'onemptied', 'onended', 'onerror', 'onfocus', 'onformdata', 'onhashchange', 'oninput', 'oninvalid', 'onkeydown', 'onkeypress', 'onkeyup', 'onlanguagechange', 'onload', 'onloadeddata', 'onloadedmetadata', 'onloadstart', 'onmessage', 'onmessageerror', 'onmousedown', 'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onoffline', 'ononline', 'onpagehide', 'onpageshow', 'onpaste', 'onpause', 'onplay', 'onplaying', 'onpopstate', 'onprogress', 'onratechange', 'onreset', 'onresize', 'onrejectionhandled', 'onscroll', 'onscrollend', 'onsecuritypolicyviolation', 'onseeked', 'onseeking', 'onselect', 'onslotchange', 'onstalled', 'onstorage', 'onsubmit', 'onsuspend', 'ontimeupdate', 'ontoggle', 'onunhandledrejection', 'onunload', 'onvolumechange', 'onwaiting', 'onwheel'],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading']
  },
  allowedEmptyAttributes: ['alt'],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  // URL schemes we permit
  allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
  parseStyleAttributes: true
};

sanitizeHtml.simpleTransform = function (newTagName, newAttribs, merge) {
  merge = merge === undefined ? true : merge;
  newAttribs = newAttribs || {};
  return function (tagName, attribs) {
    var attrib;

    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};

var defaultOptions = {
  allowedAttributes: {
    a: ['href'],
    img: ['src', 'alt']
  },
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'div', 'span', 'img', 'table', 'tr', 'td', 'ol', 'ul', 'li']
};

var sanitize = function sanitize(dirty, options) {
  return {
    __html: sanitizeHtml_1(dirty, options = _objectSpread2(_objectSpread2({}, defaultOptions), options))
  };
};

var SanitizeHTML = function SanitizeHTML(_ref) {
  var html = _ref.html,
      options = _ref.options,
      className = _ref.className;
  var divClassName = "".concat(className);
  return /*#__PURE__*/React.createElement("div", {
    className: divClassName,
    dangerouslySetInnerHTML: sanitize(html, options)
  });
};

var css_248z$1 = ".tc-navbar_tc_header_wrapper__3t7dw {\n  width: 100%;\n  margin: auto;\n  border-bottom: 1px solid #f3f3f3;\n  /* Button styling */\n  /*\n   Default styles + Mobile first\n   Offscreen menu style\n  */\n  /*\n   Larger screen styling\n   Horizontal menu\n  */ }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_icon__3RiFn {\n    padding-right: 1em;\n    color: #90c141; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb {\n    display: flex;\n    flex-wrap: wrap;\n    clear: both; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_submenu_text__WzQ1A {\n      max-width: 12em;\n      margin: 0;\n      margin-bottom: 0.3em;\n      color: #929392;\n      text-align: left; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_main_category__3yWQM {\n      position: relative;\n      left: -2em;\n      margin: unset;\n      color: #fff;\n      font-size: 1em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_tc_submenu_item__1Konh {\n      width: 100%;\n      margin: 0; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu_wrapper__1Y82c {\n    display: none; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_mobile_submenu_wrapper__1nV3a {\n    display: block;\n    font-size: 1em;\n    text-align: start; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_mobile_submenu_wrapper__1nV3a ul {\n      position: absolute; }\n  .tc-navbar_tc_header_wrapper__3t7dw a {\n    color: #d0d0d0;\n    text-decoration: none;\n    transition: 0.3s ease; }\n    .tc-navbar_tc_header_wrapper__3t7dw a:hover {\n      color: #fff;\n      text-decoration: none; }\n  .tc-navbar_tc_header_wrapper__3t7dw ul {\n    margin: 1em 0;\n    padding: 0;\n    list-style-type: none; }\n    .tc-navbar_tc_header_wrapper__3t7dw ul li {\n      line-height: 1.8em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_toggle__1Pre6 {\n    display: inline-block;\n    padding: 0.70em 15px;\n    color: #929392;\n    font-size: 1em;\n    line-height: 1em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_toggle__1Pre6 span {\n      display: flex;\n      align-items: center; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_toggle__1Pre6:hover,\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_toggle__1Pre6:focus {\n    color: #929392;\n    text-decoration: none; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 999;\n    display: none;\n    height: 100%;\n    overflow: auto; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf a.tc-navbar_mainmenu_item__2B7E8 {\n      text-transform: uppercase; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf ul {\n    min-height: 100%;\n    margin: 0;\n    padding: 3em 0 0;\n    text-align: center;\n    list-style: none;\n    background: #3c3c3c url(\"https://d3c39yxulteaif.cloudfront.net/assets/application/terracycle-logo-main-category-nav-dd2295d67fe6813a3298546bfaf47ee97b8c380288310a7759406b5b557b25bf.png\");\n    background-repeat: no-repeat;\n    background-position: right bottom;\n    /* Hide shadow w/ -8px while 'closed' */\n    -webkit-box-shadow: 8px 0 8px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 8px 0 8px rgba(0, 0, 0, 0.5);\n    box-shadow: 8px 0 8px rgba(0, 0, 0, 0.5); }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf a {\n    display: block;\n    padding: 0.70em 15px;\n    color: #fff;\n    font-size: 1em;\n    line-height: 1em;\n    text-decoration: none; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf .tc-navbar_menu_close__hrede {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 9px 15px; }\n  @supports (position: fixed) {\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf,\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf:target + .tc-navbar_backdrop__lMGSD,\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf[aria-expanded='true'] + .tc-navbar_backdrop__lMGSD {\n      position: fixed; } }\n  .tc-navbar_tc_header_wrapper__3t7dw header {\n    display: flex;\n    align-items: center;\n    height: 3em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_logo__1ixbA {\n    width: 7em;\n    min-width: 7em;\n    height: 3em;\n    background-color: #90c141;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 3em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_search_button__1CvzO {\n    margin: 0.4em;\n    padding: 0.4em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_search_button__1CvzO:hover, .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_search_button__1CvzO:active {\n      background-color: unset; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_paper__1QAvf {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-shadow: unset; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_searchBar_wrapper__2TFAl {\n    display: flex;\n    justify-content: flex-end;\n    margin: 1em;\n    transition: width 0.35s ease-in-out; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_search_input__3N6fn {\n    width: 100%;\n    color: #555555;\n    font-size: 1em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_hidden__2rE7u {\n    width: 0;\n    visibility: hidden; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_searchBar_active__3dZxP {\n    width: 100%;\n    min-width: 10em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_searchBar_hidden__1-XQJ {\n    width: 5em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_wrapper__1qCrs {\n    width: 100%; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu_wrapper__1Y82c {\n    display: inline; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_submenu_wrapper__282TB {\n    display: flex;\n    flex-direction: column-reverse; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_submenu_wrapper__282TB a {\n      margin-bottom: 0.3em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_search_close_icon__lQzX4 {\n    display: none; }\n\n@media (max-width: 900px) {\n  /*\n   On small devices, allow it to toggle...\n  */\n  /*\n   :target for non-JavaScript\n   [aria-expanded] will be used if/when JavaScript is added to improve interaction, though it's completely optional.\n  */\n  .tc-navbar_main_menu__xffEf:target,\n  .tc-navbar_main_menu__xffEf[aria-expanded='true'] {\n    right: 0;\n    display: block;\n    outline: none;\n    -moz-box-shadow: 3px 0 12px rgba(0, 0, 0, 0.25);\n    -webkit-box-shadow: 3px 0 12px rgba(0, 0, 0, 0.25);\n    box-shadow: 3px 0 12px rgba(0, 0, 0, 0.25); }\n  .tc-navbar_main_menu__xffEf:target .tc-navbar_menu_close__hrede,\n  .tc-navbar_main_menu__xffEf[aria-expanded='true'] .tc-navbar_menu_close__hrede {\n    z-index: 1001; }\n  .tc-navbar_main_menu__xffEf:target ul,\n  .tc-navbar_main_menu__xffEf[aria-expanded='true'] ul {\n    position: absolute;\n    left: 0;\n    z-index: 1000;\n    max-width: 20em; }\n  /*\n   We could us `.main_menu:target:after`, but\n   it wouldn't be clickable.\n  */\n  .tc-navbar_main_menu__xffEf:target + .tc-navbar_backdrop__lMGSD,\n  .tc-navbar_main_menu__xffEf[aria-expanded='true'] + .tc-navbar_backdrop__lMGSD {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 998;\n    display: block;\n    width: 100%;\n    height: 100%;\n    background: #000;\n    background: rgba(0, 0, 0, 0.85);\n    cursor: default; }\n  .tc-navbar_mainmenu_item__2B7E8 {\n    background-color: #90c141;\n    pointer-events: none; }\n  .tc-navbar_menu_close_overlay__1B97_ {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 998; }\n  div.tc-navbar_mobile_submenu_wrapper__1nV3a .tc-navbar_tc_submenu__37Bjb .tc-navbar_tc_submenu_item__1Konh .tc-navbar_submenu_wrapper__282TB .tc-navbar_submenu_text__WzQ1A {\n    display: none; }\n  div.tc-navbar_mobile_submenu_wrapper__1nV3a .tc-navbar_tc_submenu__37Bjb .tc-navbar_tc_submenu_item__1Konh .tc-navbar_submenu_wrapper__282TB h3 {\n    display: none; }\n  div.tc-navbar_mobile_submenu_wrapper__1nV3a .tc-navbar_tc_submenu__37Bjb .tc-navbar_tc_submenu_item__1Konh .tc-navbar_submenu_wrapper__282TB a ~ h3 {\n    display: block; }\n  .tc-navbar_tc_header_wrapper__3t7dw header {\n    position: relative; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_main_category__3yWQM {\n    left: unset;\n    margin-bottom: unset;\n    padding: 0.5em 1em;\n    color: #929392;\n    border-bottom: 1px solid #353535; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_submenu_wrapper__282TB {\n    margin-bottom: 1em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_submenu_wrapper__282TB a {\n      padding-left: 3em; }\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf .tc-navbar_menu_close__hrede:hover, .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf .tc-navbar_menu_close__hrede:focus,\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf ul a:hover,\n  .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf ul a:focus {\n    text-decoration: underline;\n    background: #333; }\n  .tc-navbar_searchBar_wrapper__2TFAl {\n    padding-right: 5.5em; }\n    .tc-navbar_searchBar_wrapper__2TFAl .tc-navbar_tc_input_adorment__3KciH {\n      margin: 0;\n      cursor: pointer; }\n    .tc-navbar_searchBar_wrapper__2TFAl .tc-navbar_tc_search_input__3N6fn input {\n      display: none; }\n    .tc-navbar_searchBar_wrapper__2TFAl.tc-navbar_expanded__1xh4D {\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      padding: 0;\n      z-index: 100; }\n      .tc-navbar_searchBar_wrapper__2TFAl.tc-navbar_expanded__1xh4D .tc-navbar_search_close_icon__lQzX4 {\n        display: block;\n        font-size: 1.7em;\n        position: absolute;\n        right: 0.9em;\n        color: #555555;\n        cursor: pointer; }\n      .tc-navbar_searchBar_wrapper__2TFAl.tc-navbar_expanded__1xh4D .tc-navbar_tc_input_adorment__3KciH {\n        position: absolute;\n        left: 1.5em; }\n      .tc-navbar_searchBar_wrapper__2TFAl.tc-navbar_expanded__1xh4D .tc-navbar_tc_search_input__3N6fn input {\n        display: block;\n        height: 2em;\n        padding: 0.5em 4em; }\n  .tc-navbar_hidden_menu__1V9RJ {\n    background-color: #90c141; } }\n\n@media (min-width: 901px) {\n  .tc-navbar_tc_header_wrapper__3t7dw {\n    /* Undo positioning of off-canvas menu */ }\n    .tc-navbar_tc_header_wrapper__3t7dw header {\n      height: 4em;\n      margin: auto 4em;\n      justify-content: space-between; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_logo__1ixbA {\n      width: 8em;\n      min-width: 8em;\n      height: 4em;\n      background-size: 4em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_wrapper__1qCrs {\n      height: 100%; }\n      .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_wrapper__1qCrs nav {\n        height: inherit; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb {\n      display: flex;\n      flex-wrap: wrap;\n      line-height: 1.5em;\n      clear: both;\n      padding: 1em 4em;\n      background: #3c3c3c url(\"https://d3c39yxulteaif.cloudfront.net/assets/application/terracycle-logo-main-category-nav-dd2295d67fe6813a3298546bfaf47ee97b8c380288310a7759406b5b557b25bf.png\");\n      background-repeat: no-repeat;\n      background-position: right bottom; }\n      .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_main_category__3yWQM {\n        position: relative;\n        margin: unset;\n        margin-bottom: 1.5em;\n        padding-left: unset;\n        color: #fff;\n        font-size: 15px;\n        background-color: unset; }\n      .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu__37Bjb .tc-navbar_tc_submenu_item__1Konh {\n        width: auto;\n        margin: 2em; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_tc_submenu_wrapper__1Y82c {\n      display: block; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_mobile_submenu_wrapper__1nV3a {\n      display: none; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_menu_toggle__1Pre6,\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf .tc-navbar_menu_close__hrede {\n      display: none; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf {\n      position: relative;\n      top: auto;\n      left: auto;\n      display: flex;\n      height: auto;\n      transition: width 2s; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf ul {\n      position: inherit;\n      right: 0;\n      display: flex;\n      width: auto;\n      height: auto;\n      /* Undo off-canvas styling */\n      padding: 0;\n      background: none;\n      -webkit-box-shadow: none;\n      -moz-box-shadow: none;\n      box-shadow: none; }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf a {\n      display: flex;\n      align-items: center;\n      height: 100%;\n      padding: 0 1em;\n      color: #929392;\n      border: 0 !important;\n      /* emove borders from off-canvas styling */ }\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_active__1aTEJ:focus,\n    .tc-navbar_tc_header_wrapper__3t7dw .tc-navbar_main_menu__xffEf a:hover {\n      color: #90c141;\n      text-decoration: none;\n      background: #eeeeee;\n      /* emove background from off-canvas styling */ }\n  .tc-navbar_tc_input_adorment__3KciH {\n    margin: -0.7em; }\n  .tc-navbar_searchBar_wrapper__2TFAl {\n    min-width: 15em; }\n    .tc-navbar_searchBar_wrapper__2TFAl .tc-navbar_tc_search_input__3N6fn {\n      height: 2em;\n      padding: 1em;\n      border: 1px solid #d0d0d0; }\n  .tc-navbar_menu_close_overlay__1B97_ {\n    display: none !important; } }\n\n.tc-navbar_hidden_menu__1V9RJ {\n  background-color: #90c141; }\n";
var css = {
  "tc_header_wrapper": "tc-navbar_tc_header_wrapper__3t7dw",
  "icon": "tc-navbar_icon__3RiFn",
  "tc_submenu": "tc-navbar_tc_submenu__37Bjb",
  "submenu_text": "tc-navbar_submenu_text__WzQ1A",
  "main_category": "tc-navbar_main_category__3yWQM",
  "tc_submenu_item": "tc-navbar_tc_submenu_item__1Konh",
  "tc_submenu_wrapper": "tc-navbar_tc_submenu_wrapper__1Y82c",
  "mobile_submenu_wrapper": "tc-navbar_mobile_submenu_wrapper__1nV3a",
  "menu_toggle": "tc-navbar_menu_toggle__1Pre6",
  "main_menu": "tc-navbar_main_menu__xffEf",
  "mainmenu_item": "tc-navbar_mainmenu_item__2B7E8",
  "menu_close": "tc-navbar_menu_close__hrede",
  "backdrop": "tc-navbar_backdrop__lMGSD",
  "tc_logo": "tc-navbar_tc_logo__1ixbA",
  "tc_search_button": "tc-navbar_tc_search_button__1CvzO",
  "tc_paper": "tc-navbar_tc_paper__1QAvf",
  "searchBar_wrapper": "tc-navbar_searchBar_wrapper__2TFAl",
  "tc_search_input": "tc-navbar_tc_search_input__3N6fn",
  "hidden": "tc-navbar_hidden__2rE7u",
  "searchBar_active": "tc-navbar_searchBar_active__3dZxP",
  "searchBar_hidden": "tc-navbar_searchBar_hidden__1-XQJ",
  "menu_wrapper": "tc-navbar_menu_wrapper__1qCrs",
  "submenu_wrapper": "tc-navbar_submenu_wrapper__282TB",
  "search_close_icon": "tc-navbar_search_close_icon__lQzX4",
  "menu_close_overlay": "tc-navbar_menu_close_overlay__1B97_",
  "tc_input_adorment": "tc-navbar_tc_input_adorment__3KciH",
  "expanded": "tc-navbar_expanded__1xh4D",
  "hidden_menu": "tc-navbar_hidden_menu__1V9RJ",
  "active": "tc-navbar_active__1aTEJ"
};
styleInject(css_248z$1);

var TcSearchInput = function TcSearchInput(props) {
  var textInput = useRef(null);

  var keypressed = function keypressed(event) {
    if (event.charCode === 13 && event.target.value) {
      console.log("".concat(props.pathOrigin).concat(props.queryString, "=").concat(encodeURIComponent(event.target.value)));
      window.location = "".concat(props.pathOrigin).concat(props.queryString, "=").concat(encodeURIComponent(event.target.value));
    }
  };

  return /*#__PURE__*/React.createElement(Paper, {
    className: css.tc_paper
  }, /*#__PURE__*/React.createElement(InputBase, {
    className: props.searchBarVisible ? "".concat(css.tc_search_input, " ").concat(css.tc_search_color, " ").concat(css.animated) : "".concat(css.tc_search_input, " ").concat(css.tc_search_color),
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      className: css.tc_input_adorment,
      onClick: function onClick() {
        props.setSearchBar();
        setTimeout(function () {
          textInput.current.focus();
        }, 100);
      },
      position: "end"
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      id: "searchIcon",
      style: {
        fontSize: '1.5em'
      }
    })),
    id: "searchInput",
    inputProps: {
      'aria-label': 'search on page'
    },
    inputRef: textInput,
    onKeyPress: keypressed,
    placeholder: ""
  }), /*#__PURE__*/React.createElement(Close, {
    className: css.search_close_icon
  }));
};

var TcSubMenu = function TcSubMenu(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: css.tc_submenu
  }, props.currentSubmenu.submenuItems.map(function (submenuItem, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.tc_submenu_item,
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: css.submenu_wrapper
    }, submenuItem.submenuLinks.map(function (item) {
      if (item.url) {
        return /*#__PURE__*/React.createElement("a", {
          href: item.url,
          key: item.title,
          target: item.target
        }, item.title);
      }

      return /*#__PURE__*/React.createElement("p", {
        className: css.submenu_text,
        key: item.title
      }, item.title);
    }), /*#__PURE__*/React.createElement("h3", {
      className: css.main_category
    }, /*#__PURE__*/React.createElement("i", {
      className: "".concat(css.icon, " fa fa-").concat(submenuItem.fontIconID)
    }), submenuItem.title)));
  }));
};

var TcNavbar = /*#__PURE__*/function (_React$Component) {
  _inherits(TcNavbar, _React$Component);

  var _super = _createSuper(TcNavbar);

  function TcNavbar(props) {
    var _this;

    _classCallCheck(this, TcNavbar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "togglesubmenu", function (event) {
      if (event.target.id !== _this.state.currentSubmenu) {
        _this.setState({
          currentSubmenu: event.target.id,
          currentSubmenuVisible: true
        });
      } else {
        _this.setState({
          currentSubmenu: undefined,
          currentSubmenuVisible: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenuItems", function () {
      return _this.props.menuItems.map(function (menuitem, key) {
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, /*#__PURE__*/React.createElement("a", {
          className: "".concat(css.mainmenu_item, " ").concat(_this.state.currentSubmenuVisible && css.active),
          href: menuitem.url || '#',
          id: key,
          key: key,
          onClick: _this.togglesubmenu,
          target: menuitem.target
        }, menuitem.title || '-'), /*#__PURE__*/React.createElement("div", {
          className: css.mobile_submenu_wrapper
        }, /*#__PURE__*/React.createElement(TcSubMenu, {
          currentSubmenu: _this.props.menuItems[key]
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubmenu", function () {
      return _this.state.currentSubmenuVisible && /*#__PURE__*/React.createElement("div", {
        className: css.tc_submenu_wrapper
      }, /*#__PURE__*/React.createElement(TcSubMenu, {
        currentSubmenu: _this.props.menuItems[_this.state.currentSubmenu]
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearchBar", function () {
      return /*#__PURE__*/React.createElement(TcSearchInput, {
        pathOrigin: _this.props.pathOrigin,
        queryString: _this.props.queryString || '',
        setSearchBar: function setSearchBar(e) {
          _this.setState({
            searchWrapper: true
          });

          document.querySelector('#searchInput').parentNode.classList.add('Mui-focused');
          document.querySelector('#searchInput').focus();
        }
      });
    });

    _this.state = {
      currentSubmenu: undefined,
      currentSubmenuVisible: false,
      searchWrapper: false
    };
    document.addEventListener('click', function (e) {
      if (e.target.id !== _this.state.currentSubmenu && e.target.id !== 'searchInput' && !$(e.target).closest('#searchIcon').length) {
        _this.setState({
          currentSubmenu: undefined,
          currentSubmenuVisible: false,
          searchWrapper: false
        });
      }
    });
    window.addEventListener('resize', function () {
      _this.setState({
        currentSubmenu: undefined,
        currentSubmenuVisible: false,
        searchWrapper: false
      });
    });
    return _this;
  }

  _createClass(TcNavbar, [{
    key: "render",
    value: function render() {
      var isMenuHidden = this.props.isMenuHidden;
      return /*#__PURE__*/React.createElement("div", {
        className: isMenuHidden ? "".concat(css.tc_header_wrapper, " ").concat(css.hidden_menu) : css.tc_header_wrapper
      }, /*#__PURE__*/React.createElement("header", null, !isMenuHidden ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        "aria-label": "Open main menu",
        className: css.menu_toggle,
        href: "#main-menu",
        id: "main-menu-toggle"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement(Menu, {
        style: {
          fontSize: '1.8em'
        }
      }))), /*#__PURE__*/React.createElement("a", {
        href: this.props.logoUrl
      }, /*#__PURE__*/React.createElement("div", {
        className: css.tc_logo,
        style: {
          backgroundImage: "url(".concat(this.props.logo, ")")
        } || 'unset'
      })), /*#__PURE__*/React.createElement("div", {
        className: this.state.searchWrapper ? css.hidden : css.menu_wrapper
      }, /*#__PURE__*/React.createElement("nav", {
        "aria-label": "Main menu",
        className: css.main_menu,
        id: "main-menu"
      }, /*#__PURE__*/React.createElement("a", {
        "aria-label": "Close main menu",
        className: css.menu_close,
        href: "#",
        id: "main-menu-close"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement(Close, {
        style: {
          fontSize: '1.5em'
        }
      }))), /*#__PURE__*/React.createElement("a", {
        className: css.menu_close_overlay,
        href: "#"
      }), /*#__PURE__*/React.createElement("ul", null, this.renderMenuItems()))), /*#__PURE__*/React.createElement("div", {
        className: this.state.searchWrapper ? "".concat(css.searchBar_wrapper, " ").concat(css.expanded) : css.searchBar_wrapper
      }, this.renderSearchBar(), /*#__PURE__*/React.createElement("a", {
        "aria-hidden": "true",
        className: css.backdrop,
        href: "#main-menu-toggle",
        tabIndex: "-1"
      }))) : /*#__PURE__*/React.createElement("a", {
        href: this.props.logoUrl
      }, /*#__PURE__*/React.createElement("div", {
        className: css.tc_logo,
        style: {
          backgroundImage: "url(".concat(this.props.logo, ")")
        } || 'unset'
      }))), this.renderSubmenu());
    }
  }]);

  return TcNavbar;
}(React.Component);

TcNavbar.defaultProps = {
  isMenuHide: false
};
var css_248z = ".tc-footer_footer__3Hjf9 {\n  font-family: 'Gotham Light', Verdana, sans-serif;\n  bottom: 0;\n  display: block;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  color: #929392;\n  font-size: 14px;\n  line-height: 16px;\n  background-color: #3c3c3c; }\n  .tc-footer_footer__3Hjf9 h4 {\n    font-size: 15px;\n    margin-bottom: 0;\n    margin-top: 0;\n    color: #90c141;\n    text-transform: uppercase; }\n  .tc-footer_footer__3Hjf9 ul {\n    width: 100%;\n    margin: 0;\n    margin-top: 1em;\n    padding: 0;\n    white-space: nowrap;\n    list-style: none; }\n    .tc-footer_footer__3Hjf9 ul li {\n      font-family: 'Gotham Light', Verdana, sans-serif;\n      width: 100%;\n      margin-bottom: 8px;\n      padding: 0;\n      line-height: 16px;\n      cursor: pointer; }\n      .tc-footer_footer__3Hjf9 ul li a {\n        display: inline-block;\n        cursor: pointer;\n        all: unset;\n        color: #929392; }\n        .tc-footer_footer__3Hjf9 ul li a:hover {\n          color: #90c141 !important;\n          text-decoration: unset; }\n  .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between; }\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__logo__image__3kPeX {\n      max-width: 10em;\n      cursor: pointer; }\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__links__3gZxu {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      min-width: 50%;\n      font-size: 14px; }\n      @media (max-width: 800px) {\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__links__3gZxu {\n          flex-direction: column;\n          justify-content: space-around; } }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__links__3gZxu .tc-footer_footer__column__M_FhI {\n        min-width: 6em;\n        margin: 0 2em; }\n        @media (max-width: 599px) {\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__links__3gZxu .tc-footer_footer__column__M_FhI {\n            margin: 0; } }\n  .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S {\n    margin-bottom: 1em; }\n  .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-top: 1em;\n    font-size: 14px;\n    font-family: 'Gotham Light', Verdana, sans-serif;\n    line-height: 2em; }\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S {\n      display: flex;\n      flex-direction: row;\n      align-items: baseline;\n      justify-content: space-between;\n      min-width: 50%; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 {\n        display: flex;\n        flex-direction: row; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu {\n          display: inline-block;\n          width: 2em;\n          height: 2em;\n          margin: 1em 0.4em;\n          text-align: center;\n          background-color: #464646;\n          border-radius: 50%;\n          cursor: pointer;\n          transition: 0.2s; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu a, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu a {\n            color: #929392; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu:hover a, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu:hover a {\n            color: #fff; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-tw__2kqdi:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-tw__2kqdi:hover {\n            background: #00aced; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-fb__2Z6bG:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-fb__2Z6bG:hover {\n            background: #3c5a99; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-yt__3qunP:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-yt__3qunP:hover {\n            background: #ff0000; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-ln__13Zx0:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-ln__13Zx0:hover {\n            background: #0077b5; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-in__2frLb:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu.tc-footer_icon-in__2frLb:hover {\n            background: #405de6; }\n          .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu i, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S .tc-footer_social__icons__3vqY0 .tc-footer_social__icon__wrapper__N9LWu i {\n            line-height: 2em; }\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 {\n      margin-left: 1em;\n      color: #fff;\n      cursor: pointer; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4 a, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4 a:visited, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 a, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 a:visited {\n        font-family: \"Gotham Light\", Verdana, sans-serif !important;\n        padding: 0 10px;\n        border-left: 1px solid #fff;\n        color: #fff; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4 a:first-child, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4 a:visited:first-child, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 a:first-child, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 a:visited:first-child {\n          border-left: 0; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4 a:hover, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 a:hover {\n        color: #90c141; }\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__copyright__text__3Pc1Z, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__copyright__text__3Pc1Z {\n      max-width: 40%; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__copyright__text__3Pc1Z .tc-footer_green__text__36wLs, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__copyright__text__3Pc1Z .tc-footer_green__text__36wLs {\n        font-family: \"Gotham Light\", Verdana, sans-serif !important;\n        color: #90c141;\n        cursor: pointer;\n        font-weight: bolder; }\n  .tc-footer_footer__3Hjf9 .tc-footer_footer__content__9yTt2 {\n    margin: auto;\n    padding: 3em 1em 1em; }\n  @media (min-width: 1200px) {\n    .tc-footer_footer__3Hjf9 .tc-footer_footer__content__9yTt2 {\n      width: 1170px; } }\n  @media (max-width: 800px) {\n    .tc-footer_footer__3Hjf9 {\n      flex-direction: column-reverse;\n      align-items: center;\n      text-align: center; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 {\n        flex-direction: column-reverse;\n        justify-content: space-around; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__first__3ou25 .tc-footer_footer__links__3gZxu .tc-footer_footer__column__M_FhI {\n          margin: 0;\n          margin-bottom: 45px; }\n      .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M {\n        flex-direction: column;\n        align-items: center; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__social__120-S, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__social__120-S {\n          flex-direction: column;\n          align-items: center;\n          max-width: 100%;\n          margin-bottom: 1em; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_footer__copyright__text__3Pc1Z, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_footer__copyright__text__3Pc1Z {\n          max-width: 100%;\n          margin-top: 0;\n          margin-bottom: 1em; }\n        .tc-footer_footer__3Hjf9 .tc-footer_footer__section__second__1I0YB .tc-footer_terms__of__use__VtlW4, .tc-footer_footer__3Hjf9 .tc-footer_footer__section__third__LbD7M .tc-footer_terms__of__use__VtlW4 {\n          max-width: 100%;\n          margin: unset; } }\n";
var footerCss = {
  "footer": "tc-footer_footer__3Hjf9",
  "footer__section__first": "tc-footer_footer__section__first__3ou25",
  "footer__logo__image": "tc-footer_footer__logo__image__3kPeX",
  "footer__links": "tc-footer_footer__links__3gZxu",
  "footer__column": "tc-footer_footer__column__M_FhI",
  "footer__section__second": "tc-footer_footer__section__second__1I0YB",
  "footer__social": "tc-footer_footer__social__120-S",
  "footer__section__third": "tc-footer_footer__section__third__LbD7M",
  "social__icons": "tc-footer_social__icons__3vqY0",
  "social__icon__wrapper": "tc-footer_social__icon__wrapper__N9LWu",
  "icon-tw": "tc-footer_icon-tw__2kqdi",
  "icon-fb": "tc-footer_icon-fb__2Z6bG",
  "icon-yt": "tc-footer_icon-yt__3qunP",
  "icon-ln": "tc-footer_icon-ln__13Zx0",
  "icon-in": "tc-footer_icon-in__2frLb",
  "terms__of__use": "tc-footer_terms__of__use__VtlW4",
  "footer__copyright__text": "tc-footer_footer__copyright__text__3Pc1Z",
  "green__text": "tc-footer_green__text__36wLs",
  "footer__content": "tc-footer_footer__content__9yTt2"
};
styleInject(css_248z);

var TcFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(TcFooter, _React$Component);

  var _super = _createSuper(TcFooter);

  function TcFooter() {
    var _this;

    _classCallCheck(this, TcFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.getElementById('year').innerHTML = new Date().getFullYear();
    });

    _defineProperty(_assertThisInitialized(_this), "renderFooterItems", function () {
      return Object.entries(_this.props.footerItems.footer_titles).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return /*#__PURE__*/React.createElement("div", {
          className: footerCss.footer__column,
          key: key
        }, /*#__PURE__*/React.createElement("h4", null, value), /*#__PURE__*/React.createElement("ul", null, _this.renderSubFooterItems(key)));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubFooterItems", function (titleitem) {
      return Object.values(_this.props.footerItems[titleitem]).map(function (footeritem, key) {
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, (footeritem.link || footeritem.tclink) && footeritem.title && /*#__PURE__*/React.createElement("a", {
          href: footeritem.link ? footeritem.link : footeritem.tclink,
          key: key,
          target: footeritem.link ? "_blank" : ""
        }, footeritem.title));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFooterIcons", function () {
      return Object.values(_this.props.footerItems.footer_icons).map(function (iconitem, key) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(footerCss.social__icon__wrapper, " ").concat(footerCss[iconitem.icon_class]),
          key: key
        }, /*#__PURE__*/React.createElement("a", {
          href: iconitem.link,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-".concat(iconitem.icon_name)
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFooterTerms", function () {
      return Object.values(_this.props.footerItems.footer_terms).map(function (termitem, key) {
        return termitem.cookie_title ? /*#__PURE__*/React.createElement("a", {
          href: "#",
          key: key,
          onClick: _this.cookieClick
        }, termitem.cookie_title) : /*#__PURE__*/React.createElement("a", {
          href: termitem.link || "#",
          key: key
        }, termitem.title);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cookieClick", function (e) {
      e.preventDefault();
      window.cookieConsentInit();
    });

    return _this;
  }

  _createClass(TcFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          footerItems = _this$props.footerItems,
          footerLogo = _this$props.footerLogo;
      return /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__content
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__section__first
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__logo
      }, /*#__PURE__*/React.createElement("a", {
        href: this.props.logoUrl
      }, /*#__PURE__*/React.createElement("img", {
        src: footerLogo,
        alt: "white terracycle logo",
        className: footerCss.footer__logo__image
      }))), /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__links
      }, this.renderFooterItems())), /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__section__second
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__social
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.social__icons
      }, this.renderFooterIcons()))), /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__section__third
      }, /*#__PURE__*/React.createElement(SanitizeHTML, {
        className: 'd-inline',
        html: footerItems.icp_certification
      }), /*#__PURE__*/React.createElement("span", {
        className: footerCss.footer__copyright__text
      }, /*#__PURE__*/React.createElement("a", {
        href: "#"
      }, /*#__PURE__*/React.createElement("b", {
        className: footerCss.green__text
      }, "TerraCycle")), " ", /*#__PURE__*/React.createElement("span", {
        id: "year"
      }), ". ", footerItems.all_rights), /*#__PURE__*/React.createElement("div", {
        className: footerCss.footer__social
      }, /*#__PURE__*/React.createElement("div", {
        className: footerCss.terms__of__use
      }, this.renderFooterTerms())))));
    }
  }]);

  return TcFooter;
}(React.Component);

export { OpeningHours, OpeningHoursViewer, SanitizeHTML, TcFooter, TcNavbar };